var _metadata, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAverageRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by FontForge 20170731 at Fri Sep 30 11:40:33 2022\n By Aleksey,,,\nCopyright 2012 The Average Project Authors (https://github.com/etunni/average)\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "Average-Regular",
    horizAdvX: 0
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "Average",
    fontWeight: 400,
    fontStretch: "normal",
    unitsPerEm: 1000,
    panose1: "0 0 0 0 0 0 0 0 0 0",
    ascent: 800,
    descent: -200,
    xHeight: 455,
    capHeight: 688,
    bbox: "-164 -265 997 1077",
    underlineThickness: 50,
    underlinePosition: -175,
    unicodeRange: "U+0020-FB04"
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 595,
    d: "M100 -140v841h395v-841h-395zM165 -75h265v711h-265v-711z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ff",
    unicode: "ff",
    horizAdvX: 625,
    d: "M411 406h-234q0 -105 1.5 -173.5t3 -108t3.5 -56.5t2 -20q1 -5 15.5 -10t32.5 -8t28 -4l-3 -29q-24 2 -61.5 2.5t-63.5 0.5q-25 0 -56.5 -0.5t-55.5 -2.5l3 29q11 1 26.5 4t28 8t13.5 10l1.5 16t3 55.5t2.5 109.5t1 177q-33 -1 -51 -1h-18l-3 11l23 39l11.5 -1t36.5 -3 q0 69 20.5 117t55 77.5t76.5 43t85 13.5q47 0 86 -14t65 -38q32 31 66.5 48t61 24t34.5 7q5 0 15.5 -10.5t21 -26.5t14.5 -33l-15 -19q-13 6 -36.5 12.5t-49.5 6.5q-28 0 -54.5 -15.5t-43.5 -60t-17 -131.5q62 0 96 0.5l34 0.5l5 -12l-31 -39l-25.5 1.5t-78.5 2.5 q0 -105 1.5 -173.5t3 -108t3.5 -56.5t2 -20q1 -5 15.5 -10t32.5 -8t28 -4l-3 -29q-24 2 -61.5 2.5t-63.5 0.5q-25 0 -56.5 -0.5t-55.5 -2.5l3 29q11 1 26.5 4t28 8t13.5 10l1.5 16t3 55.5t2.5 109.5t1 177zM308 661q-24 0 -47.5 -8.5t-42.5 -31t-30 -64t-11 -108.5 q26 -1 51 -1.5t50 -0.5q35 0 66.5 1t65.5 2q0 47 10.5 84t27.5 65q-26 26 -58.5 44t-81.5 18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fi",
    unicode: "fi",
    horizAdvX: 581,
    d: "M177 452h40.5t67.5 0.5l76 1t67 2t39 3.5l19 -9q0 -13 -0.5 -40t-0.5 -59.5t-0.5 -65t-0.5 -56.5q0 -73 2.5 -112t5 -54l2.5 -15q1 -5 14.5 -10t30 -8t26.5 -4l-3 -29q-24 2 -56.5 2.5t-58.5 0.5q-25 0 -60 -0.5t-59 -2.5l3 29q11 1 27 4t29 8t14 10l2 15t4 54t2 112 t-2 108.5t-4 47l-2 11.5l-35.5 7.5t-100.5 7.5q-19 0 -41.5 -1.5t-46.5 -3.5q0 -105 1.5 -173.5t3 -108t3.5 -56.5t2 -20q1 -5 15.5 -10t32.5 -8t28 -4l-3 -29q-24 2 -61.5 2.5t-63.5 0.5q-25 0 -56.5 -0.5t-55.5 -2.5l3 29q11 1 26.5 4t28 8t13.5 10l1.5 16t3 55.5 t2.5 109.5t1 177q-33 -1 -51 -1h-18l-3 11l23 39l11.5 -1t36.5 -3q0 77 24 130.5t63 86t84 47.5t86 15q30 0 57 -7t44 -20t17 -31t-13 -34.5t-36 -27.5q-49 60 -116 60q-35 0 -66 -18t-49.5 -65t-18.5 -135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fl",
    unicode: "fl",
    horizAdvX: 588,
    d: "M177 406q0 -105 1.5 -173.5t3 -108t3.5 -56.5t2 -20q1 -5 15.5 -10t32.5 -8t28 -4l-3 -29q-24 2 -61.5 2.5t-63.5 0.5q-25 0 -56.5 -0.5t-55.5 -2.5l3 29q11 1 26.5 4t28 8t13.5 10l1.5 16t3 55.5t2.5 109.5t1 177q-33 -1 -51 -1h-18l-3 11l23 39l11.5 -1t36.5 -3 q0 68 23.5 119t62 84.5t85.5 50t95 16.5q21 0 42 -3.5t40 -9.5l23 22l19 -9l-1 -93t-1 -276q0 -90 1.5 -147t3.5 -90t3.5 -47.5t2.5 -19.5t14 -10t29.5 -8t26.5 -4l-3 -29q-24 2 -56 2.5t-58 0.5q-25 0 -59.5 -0.5t-58.5 -2.5l3 29q11 1 26.5 4t28.5 8t14 10l1 14.5t2.5 50 t2.5 98t1 159.5q0 84 -1 138.5t-2 86t-3 47.5q-59 26 -104 26q-47 0 -75 -27.5t-40 -76t-12 -112.5q62 0 96 0.5l34 0.5l5 -12l-31 -39l-25.5 1.5t-78.5 2.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ffi",
    unicode: "ffi",
    horizAdvX: 891,
    d: "M338 703q44 0 83 -12t66 -33q39 38 87.5 55t92.5 17q30 0 57 -7t44 -20t17 -31t-13 -34.5t-36 -27.5q-49 60 -116 60q-35 0 -66 -18t-49.5 -65t-18.5 -135h40.5t67.5 0.5l76 1t67 2t39 3.5l19 -9q0 -13 -0.5 -40t-0.5 -59.5t-0.5 -65t-0.5 -56.5q0 -73 2.5 -112t5 -54 l2.5 -15q1 -5 14.5 -10t30 -8t26.5 -4l-3 -29q-24 2 -56.5 2.5t-58.5 0.5q-25 0 -60 -0.5t-59 -2.5l3 29q11 1 27 4t29 8t14 10l2 15t4 54t2 112t-2 108.5t-4 47l-2 11.5l-35.5 5t-100.5 5h-88q0 -105 1.5 -173.5t3 -108t3.5 -56.5t2 -20q1 -5 15.5 -10t32.5 -8t28 -4 l-3 -29q-24 2 -61.5 2.5t-63.5 0.5q-25 0 -56.5 -0.5t-55.5 -2.5l3 29q11 1 26.5 4t28 8t13.5 10l1.5 16t3 55.5t2.5 109.5t1 177h-234q0 -105 1.5 -173.5t3 -108t3.5 -56.5t2 -20q1 -5 15.5 -10t32.5 -8t28 -4l-3 -29q-24 2 -61.5 2.5t-63.5 0.5q-25 0 -56.5 -0.5 t-55.5 -2.5l3 29q11 1 26.5 4t28 8t13.5 10l1.5 16t3 55.5t2.5 109.5t1 177h-69l-3 11l23 39l11.5 -1t36.5 -3q0 69 20.5 117t55 77.5t76.5 43t85 13.5zM410 451q0 48 10 87t28 69q-25 23 -60 39t-80 16q-24 0 -47.5 -8.5t-42.5 -31t-30 -64t-11 -108.5q26 -1 51 -1.5 t50 -0.5q35 0 66.5 1t65.5 2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ffl",
    unicode: "ffl",
    horizAdvX: 897,
    d: "M798 352q0 -90 1.5 -147t3.5 -90t3.5 -47.5t2.5 -19.5t14 -10t29.5 -8t26.5 -4l-3 -29q-24 2 -56 2.5t-58 0.5q-25 0 -59.5 -0.5t-58.5 -2.5l3 29q11 1 26.5 4t28.5 8t14 10l1 14.5t2.5 50t2.5 98t1 159.5q0 101 -2 167t-4 106q-59 25 -103 25q-47 0 -75 -27.5t-40.5 -76 t-12.5 -112.5q62 0 96 0.5l34 0.5l5 -12l-31 -39l-25.5 1.5t-78.5 2.5q0 -105 1.5 -173.5t3 -108t3.5 -56.5t2 -20q1 -5 15.5 -10t32.5 -8t28 -4l-3 -29q-24 2 -61.5 2.5t-63.5 0.5q-25 0 -56.5 -0.5t-55.5 -2.5l3 29q11 1 26.5 4t28 8t13.5 10l1.5 16t3 55.5t2.5 109.5 t1 177h-234q0 -105 1.5 -173.5t3 -108t3.5 -56.5t2 -20q1 -5 15.5 -10t32.5 -8t28 -4l-3 -29q-24 2 -61.5 2.5t-63.5 0.5q-25 0 -56.5 -0.5t-55.5 -2.5l3 29q11 1 26.5 4t28 8t13.5 10l1.5 16t3 55.5t2.5 109.5t1 177q-33 -1 -51 -1h-18l-3 11l23 39l11.5 -1t36.5 -3 q0 69 20.5 117t55 77.5t76.5 43t85 13.5q47 0 86.5 -14t65.5 -39q38 36 87.5 54t98.5 18q11 0 22 -1t22 -3q18 2 28 4.5t33 8.5l19 -9l-1 -93t-1 -276zM308 661q-24 0 -47.5 -8.5t-42.5 -31t-30 -64t-11 -108.5q26 -1 51 -1.5t50 -0.5q35 0 66.5 1t65.5 2q0 44 10 81.5 t29 67.5q-27 26 -59.5 44t-81.5 18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fb",
    unicode: "fb",
    horizAdvX: 852,
    d: "M392 649q-80 32 -127.5 13.5t-67.5 -74t-20 -136.5q62 0 96 0.5l34 0.5l5 -12l-31 -39l-25.5 1.5t-78.5 2.5q0 -105 1.5 -173.5t3 -108t3.5 -56.5t2 -20q1 -5 15.5 -10t32.5 -8t28 -4l-3 -29q-24 2 -61.5 2.5t-63.5 0.5q-25 0 -56.5 -0.5t-55.5 -2.5l3 29q11 1 26.5 4 t28 8t13.5 10l1.5 16t3 55.5t2.5 109.5t1 177q-33 -1 -51 -1h-18l-3 11l23 39l11.5 -1t36.5 -3q0 81 32 137.5t83 88.5t109.5 40.5t111.5 -6.5l19 19l19 -9l-1 -81.5t-1 -237.5q44 30 82.5 43.5t72.5 13.5q58 0 98.5 -32.5t62.5 -84t22 -108.5q0 -45 -14.5 -88.5 t-45.5 -78.5t-79.5 -56t-115.5 -21q-41 0 -84 9.5t-82 25.5l2 32.5t4 107.5t2 204q0 97 -1 153.5t-2 83.5t-2 35zM473 367q0 -106 2 -172t4 -99.5t3 -41.5q23 -9 44 -13t40 -4q51 0 85.5 28.5t52.5 73.5t18 92q0 43 -15 81.5t-45.5 62.5t-76.5 24q-49 0 -112 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fh",
    unicode: "fh",
    horizAdvX: 874,
    d: "M177 406q0 -105 1.5 -173.5t3 -108t3.5 -56.5t2 -20q1 -5 15.5 -10t32.5 -8t28 -4l-3 -29q-24 2 -61.5 2.5t-63.5 0.5q-25 0 -56.5 -0.5t-55.5 -2.5l3 29q11 1 26.5 4t28 8t13.5 10l1.5 16t3 55.5t2.5 109.5t1 177q-33 -1 -51 -1h-18l-3 11l23 39l11.5 -1t36.5 -3 q0 83 33 139.5t85.5 88.5t112 39.5t112.5 -8.5l21 20l19 -9l-1 -83.5t-1 -235.5q23 12 57 25.5t71.5 22.5t71.5 9q30 0 53 -7.5t36 -27.5t13 -60v-135q0 -73 2.5 -112t5 -54l2.5 -15q1 -5 12.5 -10t26.5 -8t25 -4l-3 -29q-24 2 -53 2.5t-55 0.5q-25 0 -56.5 -0.5t-55.5 -2.5 l3 29q11 1 25 4t25.5 8t12.5 10l2 15t4 54t2 112v96q0 42 -25 55.5t-67 13.5q-31 0 -61 -6.5t-50 -13t-24 -7.5q0 -100 1.5 -163t3.5 -96.5t4 -46t2 -13.5q1 -5 12.5 -10t26.5 -8t25 -4l-3 -29q-24 2 -53 2.5t-55 0.5q-25 0 -56.5 -0.5t-55.5 -2.5l3 29q11 1 25 4t25.5 8 t12.5 10l1 14.5t2.5 50t2.5 98t1 158.5q0 87 -1 142.5t-2 87t-3 46.5q-84 35 -133 18t-70 -72.5t-21 -138.5q62 0 96 0.5l34 0.5l5 -12l-31 -39l-25.5 1.5t-78.5 2.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fj",
    unicode: "fj",
    horizAdvX: 562,
    d: "M401 396l-35.5 7.5t-100.5 7.5q-19 0 -41.5 -1.5t-46.5 -3.5q0 -105 1.5 -173.5t3 -108t3.5 -56.5t2 -20q1 -5 15.5 -10t32.5 -8t28 -4l-3 -29q-24 2 -61.5 2.5t-63.5 0.5q-25 0 -56.5 -0.5t-55.5 -2.5l3 29q11 1 26.5 4t28 8t13.5 10l1.5 16t3 55.5t2.5 109.5t1 177 q-33 -1 -51 -1h-18l-3 11l23 39l11.5 -1t36.5 -3q0 77 24 130.5t63 86t84 47.5t86 15q30 0 57 -7t44 -20t17 -31t-13 -34.5t-36 -27.5q-49 60 -116 60q-35 0 -66 -18t-49.5 -65t-18.5 -135h40.5t67.5 0.5l76 1t67 2t39 3.5l19 -9l-0.5 -48t-1 -137t-0.5 -211q0 -79 -15 -134 t-37.5 -91t-46.5 -56t-42 -28t-24 -8q-5 0 -15.5 10.5t-20.5 27t-15 32.5l15 19q10 -6 26 -12.5t34 -6.5q16 0 31 15.5t25 60.5t10 132q0 137 -2 221t-4 122z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fk",
    unicode: "fk",
    horizAdvX: 833,
    d: "M516 249l-31 -23q2 -98 5 -137t3 -41q1 -5 12.5 -10t26.5 -8t25 -4l-3 -29q-24 2 -53 2.5t-55 0.5q-25 0 -56.5 -0.5t-55.5 -2.5l3 29q11 1 25 4t25.5 8t12.5 10l1.5 14.5t3 50t3 98t1.5 158.5q0 86 -1 141t-2 87t-3 47q-85 36 -134.5 19.5t-70.5 -72.5t-21 -139 q62 0 96 0.5l34 0.5l5 -12l-31 -39l-25.5 1.5t-78.5 2.5q0 -105 1.5 -173.5t3 -108t3.5 -56.5t2 -20q1 -5 15.5 -10t32.5 -8t28 -4l-3 -29q-24 2 -61.5 2.5t-63.5 0.5q-25 0 -56.5 -0.5t-55.5 -2.5l3 29q11 1 26.5 4t28 8t13.5 10l1.5 16t3 55.5t2.5 109.5t1 177 q-33 -1 -51 -1h-18l-3 11l23 39l11.5 -1t36.5 -3q0 83 33 140t86 89t112.5 39t112.5 -10l22 21l19 -9l-1 -93t-1 -276v-80l160 120q7 6 7 12q0 8 -14 15t-46 8l3 29q21 -1 34 -1.5t27.5 -1t38.5 -0.5q37 0 58.5 1t52.5 2l3 -29q-41 -6 -65.5 -18t-40.5 -23l-124 -92 l188 -251q9 -13 30 -14t37 -3l-3 -29q-17 0 -43 -1t-50 -2.5t-36 -2.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".notdef",
    horizAdvX: 595,
    d: "M100 -140v841h395v-841h-395zM165 -75h265v711h-265v-711z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".null"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nonmarkingreturn",
    horizAdvX: 333
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "space",
    unicode: " ",
    horizAdvX: 250
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclam",
    unicode: "!",
    horizAdvX: 236,
    d: "M172 691l-33 -523l-38 -9l-37 505l5 6.5t27.5 13t75.5 7.5zM118 -9q-22 0 -37.5 15.5t-15.5 39.5q0 23 15.5 38t37.5 15t37.5 -15t15.5 -38q0 -24 -15.5 -39.5t-37.5 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedbl",
    unicode: "\"",
    horizAdvX: 290,
    d: "M127 683l-32 -232l-4.5 -6.5t-35.5 -6.5l-19 221l5.5 6t24.5 12t61 6zM266 683l-32 -232l-4.5 -6.5t-35.5 -6.5l-19 221l5 6t24.5 12t61.5 6z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "numbersign",
    unicode: "#",
    horizAdvX: 523,
    d: "M24 223v61h96l26 101h-81v61h97l59 228h65l-59 -228h128l59 228h65l-59 -228h79v-61h-95l-26 -101h82v-61h-97l-60 -232h-65l60 232h-128l-60 -232h-65l60 232h-81zM211 385l-26 -101h128l26 101h-128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dollar",
    unicode: "$",
    horizAdvX: 523,
    d: "M274 641l15 121h45l-16 -127q14 -2 26.5 -4.5t27.5 -2.5q8 0 18 1.5t21 3.5v-13q0 -27 3.5 -64.5t7.5 -62.5l-24 -12q-14 52 -35 77t-51 33l-27 -217l30 -20t28 -19q56 -39 83 -77.5t27 -91.5q0 -81 -54 -128t-143 -47h-18l-14 -112h-45l14 117q-32 4 -63 11.5t-56 17.5 q3 14 6.5 36.5t6 47t2.5 43.5q0 5 -0.5 9.5t-0.5 8.5l24 11q11 -63 30.5 -95t56.5 -42l31 250q-10 8 -20 15l-20 14q-35 25 -58 47t-34 49.5t-11 67.5q0 71 49.5 112.5t128.5 41.5h9zM172 519q0 -45 22.5 -71t49.5 -46l24 195h-2q-42 0 -68 -24.5t-26 -53.5zM244 39h1 q58 0 84 26.5t26 73.5t-19 69.5t-45 42.5q-5 3 -9.5 6.5t-9.5 7.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "percent",
    unicode: "%",
    horizAdvX: 784,
    d: "M146 -1l412 680h48l-412 -680h-48zM314 509q0 -45 -13 -82t-38.5 -59t-65.5 -22q-39 0 -65 22t-39 59t-13 82t13 82.5t39 59.5t65 22q40 0 65.5 -22t38.5 -59.5t13 -82.5zM197 638q-22 0 -34 -37.5t-12 -90.5q0 -55 12 -91.5t34 -36.5q23 0 34.5 36.5t11.5 91.5 q0 53 -11.5 90.5t-34.5 37.5zM664 154q0 -45 -13 -82t-38.5 -59t-65.5 -22t-65.5 22t-38.5 59t-13 82t13 82.5t38.5 59.5t65.5 22t65.5 -22t38.5 -59.5t13 -82.5zM547 283q-22 0 -34 -37.5t-12 -90.5q0 -55 12 -91.5t34 -36.5q23 0 34.5 36.5t11.5 91.5q0 53 -11.5 90.5 t-34.5 37.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ampersand",
    unicode: "&",
    horizAdvX: 739,
    d: "M610 303q-19 -49 -43 -91t-51 -77q22 -20 49.5 -36.5t68.5 -26t102 -10.5l3 -29l-23.5 -5t-58 -12.5t-68 -15.5t-53.5 -13q-19 19 -39.5 40.5t-40.5 43.5q-52 -43 -106.5 -62t-104.5 -19q-61 0 -104.5 22.5t-67 61t-23.5 85.5q0 67 42 118.5t127 101.5h-1 q-32 54 -51.5 100.5t-19.5 79.5q0 39 19.5 73t57.5 54.5t91 20.5q39 0 76 -12t61 -38.5t24 -69.5q0 -31 -16 -59t-41 -52.5t-52.5 -45t-51.5 -35.5l-2 -2q41 -64 88.5 -125t84.5 -101q21 33 33.5 69.5t12.5 72.5q0 17 -19 27t-67 19l3 29q29 -3 65 -4.5t73 -1.5 q32 0 61.5 1.5t53.5 4.5l3 -29q-45 -9 -66.5 -22t-28.5 -30zM233 578q0 -29 16.5 -69t43.5 -86q56 39 75 78t19 77q0 45 -26 66.5t-55 21.5q-28 0 -50.5 -20.5t-22.5 -67.5zM284 46q39 0 76 16t68 41q-50 58 -100.5 122.5t-86.5 119.5q-37 -29 -67.5 -69t-30.5 -96 q0 -53 20.5 -82t53 -40.5t67.5 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesingle",
    unicode: "'",
    horizAdvX: 152,
    d: "M128 683l-32 -232l-4.5 -6.5t-35.5 -6.5l-20 221l5.5 6t25 12t61.5 6z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenleft",
    unicode: "(",
    horizAdvX: 397,
    d: "M164 291q0 -65 16 -135.5t50 -140t87 -131.5l-31 -29q-83 68 -130.5 144.5t-66.5 152t-19 139.5t19 134.5t66.5 143t130.5 140.5l31 -28q-79 -94 -116 -194t-37 -196z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenright",
    unicode: ")",
    horizAdvX: 397,
    d: "M233 291q0 96 -36.5 196t-116.5 194l31 28q84 -68 131 -140.5t66 -143t19 -134.5t-19 -139.5t-66 -152t-131 -144.5l-31 29q53 62 87 131.5t50 140t16 135.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asterisk",
    unicode: "*",
    horizAdvX: 457,
    d: "M321 348h-70l-4 22t-11.5 55.5t-19.5 68.5q-46 -57 -76 -90.5l-30 -33.5l-34 10l-23 66l20 10.5t50 28.5t60 39q-70 28 -111.5 46l-41.5 18l1 35l55 41l16.5 -16t42.5 -39t56 -45q5 75 9 120.5l4 45.5l34 12l55 -41l-10 -20.5t-23.5 -52.5t-25.5 -67q73 19 117.5 28.5 l44.5 9.5l21 -28l-21 -66l-22.5 3t-57 6.5t-71.5 3.5q40 -63 62.5 -102l22.5 -39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plus",
    unicode: "+",
    horizAdvX: 523,
    d: "M231 541h61v-207h207v-61h-207v-207h-61v207h-207v61h207v207z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "comma",
    unicode: ",",
    horizAdvX: 214,
    d: "M112 91q32 0 52.5 -25t20.5 -61q0 -40 -33 -83t-113 -69l-9 22q45 20 76.5 53.5t31.5 78.5q-8 -9 -17 -12t-17 -3q-19 0 -33 14t-14 35q0 24 17 37t38 13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hyphen",
    unicode: "-",
    horizAdvX: 314,
    d: "M148 235q-57 -4 -89.5 -11.5l-32.5 -7.5l-8 16l39 52h6.5t27.5 1.5t63 3.5q74 5 104 12l30 7l8 -15l-39 -52l-23 -0.5t-86 -5.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "period",
    unicode: ".",
    horizAdvX: 165,
    d: "M82 -9q-22 0 -37 15t-15 40q0 23 15 37.5t37 14.5t37.5 -14.5t15.5 -37.5q0 -25 -15.5 -40t-37.5 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "slash",
    unicode: "/",
    horizAdvX: 290,
    d: "M20 -140l185 841h65l-185 -841h-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero",
    unicode: 0,
    horizAdvX: 523,
    d: "M485 332q0 -94 -24 -171.5t-73.5 -123.5t-126.5 -46q-76 0 -126 46t-74 123.5t-24 171.5t24 171.5t74 123.5t126 46q77 0 126.5 -46t73.5 -123.5t24 -171.5zM261 628q-44 0 -72.5 -40t-42.5 -107t-14 -149t14 -149t42.5 -107t72.5 -40t72.5 40t42.5 107t14 149t-14 149 t-42.5 107t-72.5 40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one",
    unicode: 1,
    horizAdvX: 403,
    d: "M242 673l21 -10l-2 -80t-2 -241q0 -108 2 -167t4 -82.5l2 -23.5q2 -19 24 -26.5t67 -16.5l-3 -29q-60 3 -133 3q-45 0 -89.5 -0.5t-83.5 -2.5l-3 29q30 6 56.5 11t44 12.5t18.5 19.5l2 23.5t3.5 83t1.5 166.5q0 81 -1 131t-2.5 76.5t-2.5 36.5l-1 10l-121 21l-3 36 q71 0 122 6.5t79 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two",
    unicode: 2,
    horizAdvX: 517,
    d: "M444 492q0 -49 -19.5 -97t-51 -92.5t-68.5 -82.5t-72.5 -68.5t-63.5 -51t-40 -29.5l2 -5q90 0 146 2.5t87.5 12.5t48 31.5t28.5 58.5l27 -12q-6 -18 -11 -49t-8.5 -61.5t-4.5 -48.5h-402l-12 40l23 19.5t59.5 53t77 77t77 93t59.5 100t23 96.5q0 49 -18.5 76t-48 38.5 t-63.5 11.5q-46 0 -89.5 -13.5t-66.5 -25.5l-14 28q37 31 85 55t115 24q51 0 95.5 -20t72 -60t27.5 -101z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three",
    unicode: 3,
    horizAdvX: 480,
    d: "M247 375v-5q99 -14 141 -61t42 -106q0 -44 -21.5 -87.5t-62.5 -79.5t-99 -57.5t-131 -21.5q-22 0 -44.5 2.5t-46.5 7.5l3 48q45 -9 82 -9q75 0 125 27.5t75 70t25 86.5q0 37 -17 68.5t-51 51t-86 19.5q-36 0 -75 -10l3 39q71 16 113.5 48t62 67.5t19.5 61.5 q0 34 -23 56.5t-66 22.5q-27 0 -61.5 -11t-75.5 -37l-14 28q47 43 94 61.5t89 18.5q43 0 76.5 -16t53 -43.5t19.5 -62.5q0 -41 -34 -88t-115 -89z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four",
    unicode: 4,
    horizAdvX: 523,
    d: "M407 450v-132.5t1 -75.5h81l6 -15l-38 -46l-6 1.5t-42 2.5q2 -68 4 -92l2 -24q2 -19 20.5 -26.5t63.5 -16.5l-3 -29q-63 3 -137 3q-37 0 -83.5 -0.5t-78.5 -2.5l-3 29q30 6 56.5 11t44 12.5t18.5 19.5l2 23.5t4 93.5h-287l-12 39l255 481l91 -9l-274 -456h228v185l3 5 t21.5 11t62.5 8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five",
    unicode: 5,
    horizAdvX: 489,
    d: "M65 414l47 243l305 33l7 -15l-41 -77l-18 3t-55 3q-8 0 -21 -0.5t-45 -3t-96 -8.5l-28 -153q112 -3 182.5 -36t103.5 -83t33 -106q0 -47 -21.5 -92.5t-62 -83t-98 -59.5t-128.5 -22q-22 0 -45 2.5t-48 7.5l3 45q18 -2 34.5 -3.5t32.5 -1.5q78 0 131 27t80 69t27 88 q0 48 -29 90t-88 68t-150 26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six",
    unicode: 6,
    horizAdvX: 486,
    d: "M187 285l-4 40q26 9 48.5 12.5t41.5 3.5q57 0 95.5 -24t58 -62.5t19.5 -80.5q0 -45 -21.5 -87t-65.5 -69t-112 -27q-64 0 -113 32.5t-76.5 87.5t-27.5 123q0 75 38 157.5t122 161t221 139.5l16 -35q-81 -37 -137.5 -89t-92.5 -111t-52.5 -119t-16.5 -114q0 -51 14 -92 t39.5 -65.5t61.5 -24.5q35 0 58 18.5t34.5 48t11.5 61.5q0 53 -27.5 90t-77.5 37q-25 0 -55 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven",
    unicode: 7,
    horizAdvX: 477,
    d: "M477 638l-282 -671l-91 9l288 601q-2 15 -21 19t-50 4q-64 0 -107 -1.5t-70 -10t-43.5 -30t-28.5 -62.5l-27 12q4 20 6.5 49t4 59.5t1.5 53.5q24 -1 66.5 -2t94 -1.5t100.5 -0.5h100t56 1z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight",
    unicode: 8,
    horizAdvX: 505,
    d: "M460 170q0 -49 -28.5 -90t-77.5 -65t-113 -24t-107.5 23.5t-66 61t-22.5 80.5q0 53 36 104t112 76q-53 32 -81.5 64.5t-39 61.5t-10.5 52q0 45 26 81t70.5 57t100.5 21q58 0 98 -20t60.5 -52.5t20.5 -70.5q0 -45 -30.5 -92.5t-98.5 -73.5q80 -41 115.5 -90t35.5 -104z M250 629q-43 0 -69.5 -27.5t-26.5 -67.5q0 -36 19 -65t47 -50t53 -36q41 23 62.5 63.5t21.5 76.5q0 43 -26 74.5t-81 31.5zM251 41q32 0 58 16.5t41.5 44.5t15.5 60q0 41 -30.5 82.5t-104.5 73.5q-49 -24 -74 -66t-25 -88q0 -49 29.5 -86t89.5 -37z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine",
    unicode: 9,
    horizAdvX: 503,
    d: "M304 344l4 -37q-43 -12 -80 -12q-61 0 -103 27.5t-63.5 70.5t-21.5 90q0 48 22.5 91.5t68 71t114.5 27.5q67 0 118.5 -34t80.5 -92t29 -130q0 -79 -40 -166.5t-127.5 -169.5t-231.5 -147l-16 36q85 39 145.5 94t99 117.5t56.5 126t18 120.5q0 55 -15.5 98.5t-44.5 69 t-68 25.5q-38 0 -64.5 -20.5t-40 -53t-13.5 -68.5q0 -35 14 -67.5t42 -53t70 -20.5q22 0 47 6z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colon",
    unicode: ":",
    horizAdvX: 196,
    d: "M113 295q-22 0 -37.5 15.5t-15.5 39.5q0 23 15.5 38t37.5 15t37.5 -15t15.5 -38q0 -24 -15.5 -39.5t-37.5 -15.5zM113 -9q-22 0 -37.5 15.5t-15.5 39.5q0 23 15.5 38t37.5 15t37.5 -15t15.5 -38q0 -24 -15.5 -39.5t-37.5 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "semicolon",
    unicode: ";",
    horizAdvX: 211,
    d: "M113 295q-22 0 -37.5 15.5t-15.5 39.5q0 23 15.5 38t37.5 15t37.5 -15t15.5 -38q0 -24 -15.5 -39.5t-37.5 -15.5zM109 91q32 0 52.5 -25t20.5 -61q0 -40 -33 -83t-113 -69l-9 22q45 20 76.5 53.5t31.5 78.5q-8 -9 -17 -12t-17 -3q-19 0 -33 14t-14 35q0 24 17 37t38 13z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "less",
    unicode: "<",
    horizAdvX: 523,
    d: "M487 56l-450 247l450 247v-69l-336 -178l336 -178v-69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "equal",
    unicode: "=",
    horizAdvX: 523,
    d: "M24 354v61h475v-61h-475zM24 192v61h475v-61h-475z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greater",
    unicode: ">",
    horizAdvX: 523,
    d: "M487 303l-450 -247v69l336 178l-336 178v69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "question",
    unicode: "?",
    horizAdvX: 343,
    d: "M68 584q-7 8 -12.5 27t-5.5 31q0 14 4.5 27.5t17.5 23.5q122 -54 171.5 -111t49.5 -112q0 -30 -14 -52t-35 -40.5t-42 -37.5t-35 -42t-14 -55q0 -17 2.5 -35t12.5 -40l-38 -9q-31 46 -42 80.5t-11 59.5t17 45.5t42.5 39t50.5 36.5t42 37t17 41q0 35 -45 59.5t-133 26.5z M148 -9q-22 0 -37.5 15.5t-15.5 39.5q0 23 15.5 38t37.5 15t37.5 -15t15.5 -38q0 -24 -15.5 -39.5t-37.5 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "at",
    unicode: "@",
    horizAdvX: 781,
    d: "M624 58l16 -23q-58 -46 -130.5 -74.5t-144.5 -28.5q-61 0 -119.5 20.5t-104.5 62t-73.5 105.5t-27.5 150q0 66 25.5 131t75.5 118.5t123.5 86t169.5 32.5q79 0 136.5 -22t95.5 -59t56.5 -83.5t18.5 -95.5q0 -64 -30.5 -122.5t-90 -95.5t-145.5 -37q-33 0 -45.5 13.5 t-12.5 38.5q0 14 3 30t7 35h-2q-34 -49 -60.5 -74t-44.5 -33.5t-30 -8.5q-33 0 -52 27.5t-19 77.5q0 57 27.5 110t78 87t119.5 34q12 0 30 -2.5t31 -7.5l30 22h15q-20 -64 -35 -127t-23 -114t-8 -78q56 0 96.5 29.5t62.5 77t22 100.5q0 43 -15 85t-47 76.5t-81.5 55 t-118.5 20.5q-63 0 -114.5 -25t-88 -68.5t-56 -100.5t-19.5 -120q0 -57 17 -112t50 -98.5t82.5 -69.5t113.5 -26q51 0 106 15t130 66zM438 288l36 141q-15 5 -27 5q-37 0 -64.5 -20t-45 -51.5t-26.5 -65.5t-9 -62q0 -25 6.5 -40.5t18.5 -15.5q13 0 40.5 28.5t70.5 80.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A",
    unicode: "A",
    horizAdvX: 694,
    d: "M3 -3l-3 29q47 9 67 19.5t26 29.5l199 609l84 10l233 -625q7 -17 23.5 -26t61.5 -17l-3 -29q-33 2 -65 2.5t-68 0.5q-79 0 -141 -3l-3 29q52 10 70 18t18 20l-55 178h-226l-54 -178q0 -12 19 -20t67 -18l-3 -29q-33 2 -65 2.5t-68 0.5q-31 0 -53 -0.5t-61 -2.5zM235 288 h196l-101 302h-4z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B",
    unicode: "B",
    horizAdvX: 626,
    d: "M32 -3l-3 29q53 11 70 19t19 24t4 57.5t3 98.5t1 117q0 108 -2 167.5t-4 83l-2 23.5q-2 17 -17 25t-65 18l3 29q32 -1 64.5 -2t69.5 -1h168q87 0 139.5 -43.5t52.5 -116.5q0 -46 -28.5 -87.5t-76.5 -65.5q77 -18 113 -61t36 -117q0 -53 -29.5 -97.5t-79.5 -70.5t-111 -26 h-184q-79 0 -141 -3zM215 368q9 2 29 4t44 3.5t44.5 3t31.5 1.5q75 48 75 145q0 58 -39 88t-113 30q-36 0 -46.5 -4t-14.5 -18q-2 -11 -5 -48.5t-4.5 -91t-1.5 -113.5zM327 36q45 0 80 20.5t55 56t20 80.5q0 145 -204 145q-30 0 -63 -3q0 -64 1.5 -122t4.5 -97t5 -48 q5 -15 32 -23.5t69 -8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C",
    unicode: "C",
    horizAdvX: 700,
    d: "M404 -12q-112 0 -191.5 41.5t-122 119t-42.5 185.5q0 106 45 187t125.5 127t184.5 46q62 0 102.5 -7.5t71.5 -7.5q27 0 52 6q0 -36 3.5 -80.5t8.5 -75.5l-27 -12q-20 64 -74.5 97.5t-137.5 33.5q-75 0 -131 -37t-87 -103.5t-31 -156.5q0 -94 32 -164.5t89 -110t133 -39.5 q90 0 151 37.5t83 105.5l27 -12q-9 -32 -15 -68t-8 -66q-126 -46 -241 -46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "D",
    unicode: "D",
    horizAdvX: 769,
    d: "M173 685h178q66 0 131.5 -17.5t119.5 -55t86 -98.5t32 -149q0 -102 -42 -185t-127.5 -131.5t-216.5 -48.5h-161q-78 0 -141 -3l-3 29q45 9 66 16.5t23 26.5l2 23.5t4 83t2 166.5q0 108 -2 167.5t-4 83l-2 23.5q-2 19 -19.5 26.5t-62.5 16.5l3 29q32 -1 64.5 -2t69.5 -1z M227 60q27 -6 51 -9t52 -3q77 0 129 23t83 60t47 78.5t21 79t5 61.5q0 50 -12.5 101.5t-47 95t-98.5 70t-168 26.5q-37 0 -48 -4t-14 -17l-2.5 -25t-5.5 -86t-3 -168q0 -108 3 -169.5t5.5 -87.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E",
    unicode: "E",
    horizAdvX: 608,
    d: "M453 236l-35 -5q-10 50 -17 67t-26 21q-12 3 -38 4.5t-58 2.5t-64 1q0 -103 3 -159t5.5 -78l2.5 -22q5 -18 37 -25t64 -7q52 0 94 7t74 35.5t52 92.5l27 -12q-6 -18 -11 -49t-8.5 -61.5t-4.5 -48.5h-400q-37 0 -62.5 -0.5t-57.5 -2.5l-3 29q45 9 66 16.5t23 26.5l2 23.5 t4.5 82.5t2.5 167t-2 167.5t-4 83l-2 23.5q-2 19 -19.5 26.5t-62.5 16.5l3 29q32 -1 54 -2t59 -1h137.5t137 1.5t105.5 4.5v-15q0 -21 1.5 -49t4.5 -54.5t6 -43.5l-27 -12q-13 42 -27.5 67.5t-36 38t-54 16.5t-80.5 4q-36 0 -62.5 -3t-29.5 -19l-2.5 -24t-5 -79.5 t-3.5 -150.5q32 0 64 1t58 2.5t38 4.5q19 5 26 21.5t17 66.5l35 -4q-4 -27 -6 -55t-2 -56t2 -56t6 -56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "F",
    unicode: "F",
    horizAdvX: 554,
    d: "M216 327q0 -100 2 -156.5t4 -79l2 -22.5q2 -19 21 -26.5t64 -16.5l-3 -29q-31 2 -63 2.5t-70 0.5q-78 0 -141 -3l-3 29q45 9 66 16.5t23 26.5l2 23.5t4 83t2 166.5q0 108 -2 167.5t-4 83l-2 23.5q-2 19 -19.5 26.5t-62.5 16.5l3 29q21 -1 34 -1.5t27 -1t39 -0.5h137.5 t137 1.5t105.5 4.5v-15q0 -21 1.5 -49t4.5 -54.5t6 -43.5l-27 -12q-13 42 -27.5 67.5t-36 38t-54 16.5t-80.5 4q-36 0 -57.5 -2.5t-23.5 -19.5l-2 -23.5t-4 -79t-3 -151.5q32 0 66 1t62 2.5t40 4.5q19 5 26 21.5t17 66.5l35 -4q-4 -27 -6 -55t-2 -56t2 -56t6 -56l-35 -5 q-10 50 -17 67t-26 21q-12 3 -40 4.5t-62 2.5t-66 1z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G",
    unicode: "G",
    horizAdvX: 759,
    d: "M407 37q53 0 102 11t76 25q-1 72 -4 117l-3 45q-2 19 -19.5 26.5t-62.5 16.5l3 29q32 -1 64.5 -2t69.5 -1q25 0 40 0.5t28.5 1t34.5 1.5l3 -29q-30 -6 -40.5 -11t-11.5 -12t-3 -20l-7 -180q-79 -34 -144 -50.5t-129 -16.5q-107 0 -187 39t-124.5 116t-44.5 191 q0 72 24 136.5t71 115t116 79.5t159 29q65 0 107 -7.5t79 -7.5q24 0 49 6v-15q0 -20 1.5 -46.5t4.5 -52t6 -42.5l-28 -12q-16 51 -51 79.5t-79.5 40t-92.5 11.5q-67 0 -126.5 -31.5t-97 -97t-37.5 -168.5q0 -55 14 -111t44 -101.5t78.5 -73.5t117.5 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H",
    unicode: "H",
    horizAdvX: 803,
    d: "M587 384q0 93 -2 143t-4 69.5l-2 19.5q-2 19 -19.5 26.5t-62.5 16.5l3 29q32 -1 64.5 -2t69.5 -1q38 0 68.5 1t61.5 2l3 -29q-45 -9 -62.5 -16.5t-19.5 -26.5l-2 -23.5t-4 -83t-2 -167.5t2 -167t4 -82.5l2 -23.5q2 -19 21 -26.5t64 -16.5l-3 -29q-31 2 -63 2.5t-70 0.5 q-78 0 -141 -3l-3 29q45 9 66 16.5t23 26.5l2 22t4 78t2 159l-16 1.5t-56 2.5t-114 1q-73 0 -113 -1t-56 -2.5l-16 -1.5q0 -103 2 -159.5t4 -78l2 -21.5q2 -19 21 -26.5t64 -16.5l-3 -29q-31 2 -63 2.5t-70 0.5q-78 0 -141 -3l-3 29q45 9 66 16.5t23 26.5l2 23.5t4 83 t2 166.5q0 108 -2 167.5t-4 83l-2 23.5q-2 19 -19.5 26.5t-62.5 16.5l3 29q32 -1 64.5 -2t69.5 -1q38 0 68.5 1t61.5 2l3 -29q-45 -9 -62.5 -16.5t-19.5 -26.5l-2 -19.5t-3.5 -70t-2.5 -142.5l16 -1t56 -2.5t113 -1.5q74 0 114 1.5t56 2.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "I",
    horizAdvX: 342,
    d: "M216 342q0 -108 2 -167t4 -82.5l2 -23.5q2 -19 21 -26.5t64 -16.5l-3 -29q-31 2 -63 2.5t-70 0.5q-78 0 -141 -3l-3 29q45 9 66 16.5t23 26.5l2 23.5t4 83t2 166.5q0 108 -2 167.5t-4 83l-2 23.5q-2 19 -19.5 26.5t-62.5 16.5l3 29q32 -1 64.5 -2t69.5 -1q38 0 68.5 1 t61.5 2l3 -29q-45 -9 -62.5 -16.5t-19.5 -26.5l-2 -23.5t-4 -83t-2 -167.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J",
    unicode: "J",
    horizAdvX: 352,
    d: "M29 -178q-5 0 -18 11t-26 28t-18 34l16 20q10 -7 30 -13.5t39 -6.5q18 0 33 7.5t26.5 30t19.5 66.5t12 117.5t4 182.5q0 161 -4 239l-4 78q-2 19 -19.5 26.5t-62.5 16.5l3 29q32 -1 64.5 -2t69.5 -1q38 0 68.5 1t61.5 2l3 -29q-45 -9 -64 -16.5t-21 -26.5l-1 -32 t-1.5 -88t-1.5 -128t-1 -153q0 -97 -22 -171t-55 -123t-68.5 -74t-62.5 -25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K",
    unicode: "K",
    horizAdvX: 696,
    d: "M224 69q2 -19 21 -26.5t64 -16.5l-3 -29q-31 2 -63 2.5t-70 0.5q-78 0 -141 -3l-3 29q45 9 66 16.5t23 26.5l2 23.5t4 83t2 166.5q0 108 -2 167.5t-4 83l-2 23.5q-2 19 -19.5 26.5t-62.5 16.5l3 29q32 -1 64.5 -2t69.5 -1q38 0 68.5 1t61.5 2l3 -29q-45 -9 -62.5 -16.5 t-19.5 -26.5l-2 -22t-4 -76.5t-2 -152.5l264 253q4 3 4 7q0 19 -74 34l3 29l64 -2t69 -1q38 0 60.5 1t53.5 2l3 -29q-45 -9 -72 -21.5t-42 -26.5l-215 -204l278 -364l19 -6.5t64 -10.5l-3 -29q-24 0 -52.5 -1t-55 -2t-43 -2l-16.5 -1l-256 355l-53 -50q1 -88 2.5 -137.5 t3.5 -69.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "L",
    unicode: "L",
    horizAdvX: 580,
    d: "M224 69q1 -10 16 -17.5t37.5 -11.5t43.5 -4q52 0 94 7t74 35.5t52 92.5l27 -12q-6 -18 -11 -49t-8.5 -61.5t-4.5 -48.5h-393q-37 0 -62.5 -0.5t-57.5 -2.5l-3 29q45 9 66 16.5t23 26.5l2 23.5t4.5 82.5t2.5 167t-2 167.5t-4 83l-2 23.5q-2 19 -19.5 26.5t-62.5 16.5l3 29 q32 -1 64.5 -2t69.5 -1q38 0 68.5 1t61.5 2l3 -29q-45 -9 -62.5 -16.5t-19.5 -26.5l-2 -23.5t-4 -83t-2 -167.5t2 -167t4 -82.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M",
    unicode: "M",
    horizAdvX: 922,
    d: "M695 526h-6l-214 -525l-62 -11l-214 536h-4q-2 -88 -6 -176t-4 -176q0 -55 1.5 -80l1.5 -25q2 -19 25.5 -26.5t68.5 -16.5l-3 -29q-31 2 -67.5 2.5t-74.5 0.5h-42t-32.5 -0.5t-36.5 -2.5l-3 29q45 9 64.5 17t21.5 26q9 69 13 134.5t5.5 133.5t1.5 146q0 74 -2 103.5 l-2 29.5q-2 19 -19.5 26.5t-62.5 16.5l3 29q21 -1 52.5 -1.5t64 -1t57.5 -0.5l238 -590l238 590q25 0 58.5 0.5t65.5 1t53 1.5l3 -29q-45 -9 -62.5 -16.5t-19.5 -26.5l-2 -19t-2 -75q0 -6 0.5 -30t1.5 -54.5t2 -57t1 -38.5q4 -84 7.5 -137.5t5.5 -83t3.5 -41l1.5 -11.5 q2 -19 21 -26.5t64 -16.5l-3 -29q-31 2 -63 2.5t-70 0.5q-78 0 -141 -3l-3 29q45 9 67 16.5t22 26.5l0.5 23.5t0.5 65.5q0 33 -1 80.5t-3 100.5t-4.5 102t-4.5 85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N",
    unicode: "N",
    horizAdvX: 785,
    d: "M603 132h5q2 42 2 96v114q0 108 -2.5 167.5t-4.5 83l-2 23.5q-2 19 -25.5 26.5t-68.5 16.5l3 29q32 -1 68.5 -2t73.5 -1q25 0 41 0.5t30.5 1t35.5 1.5l3 -29q-45 -9 -62.5 -16.5t-19.5 -26.5l-2.5 -23.5t-5 -83t-2.5 -167.5q0 -161 5.5 -251.5l5.5 -90.5l-80 -9l-406 546 h-5q-1 -33 -2.5 -82t-1.5 -113q0 -108 3 -167t5.5 -82.5l2.5 -23.5q2 -19 25.5 -26.5t68.5 -16.5l-3 -29q-31 2 -67.5 2.5t-74.5 0.5q-37 0 -63.5 -0.5t-58.5 -2.5l-3 29q45 8 70 16t27 27l2 23.5t4 82.5t2 167t-2 167.5t-4 83l-2 23.5q-2 19 -19.5 26.5t-62.5 16.5l3 29 q32 -1 72 -2t77 -1z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O",
    unicode: "O",
    horizAdvX: 786,
    d: "M737 369q0 -72 -20.5 -141t-64 -124t-113 -87.5t-167.5 -32.5q-113 0 -184.5 42t-105 116.5t-33.5 171.5q0 72 20.5 140.5t64 123.5t113 87.5t167.5 32.5q114 0 185 -41.5t104.5 -115.5t33.5 -172zM632 312q0 65 -10 125t-35.5 108.5t-71 76.5t-117.5 28 q-61 0 -103.5 -22.5t-70 -58t-43 -76.5t-21.5 -79t-6 -64q0 -62 11.5 -119t38.5 -102t72 -71t112 -26q55 0 96.5 19.5t69.5 51.5t45.5 69.5t25 74t7.5 65.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P",
    unicode: "P",
    horizAdvX: 576,
    d: "M173 685h152q78 0 128 -26t74 -67.5t24 -89.5q0 -53 -31 -104t-89.5 -84.5t-143.5 -33.5q-33 0 -71 6q0 -81 1 -125.5t3 -64t3 -23.5l1 -4q2 -19 21 -26.5t64 -16.5l-3 -29q-31 2 -63 2.5t-70 0.5q-78 0 -141 -3l-3 29q45 9 66 16.5t23 26.5l2 23.5t4 83t2 166.5 q0 108 -2 167.5t-4 83l-2 23.5q-2 19 -19.5 26.5t-62.5 16.5l3 29q32 -1 64.5 -2t69.5 -1zM216 325q29 -3 55 -3q83 0 133.5 39.5t50.5 127.5q0 85 -43.5 119.5t-124.5 34.5q-35 0 -46 -4.5t-15 -29.5l-1.5 -12t-3.5 -43t-3.5 -86.5t-1.5 -142.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Q",
    unicode: "Q",
    horizAdvX: 792,
    d: "M737 369q0 -81 -25.5 -156.5t-80 -132.5t-142.5 -81l311 -155v-22l-83 -39l-22 14.5t-58.5 38.5t-81 51t-90 53t-84.5 44h1h-10q-113 0 -184.5 42t-105 116.5t-33.5 171.5q0 72 20.5 140.5t64 123.5t113 87.5t167.5 32.5q114 0 185 -41.5t104.5 -115.5t33.5 -172z M632 312q0 65 -10 125t-35.5 108.5t-71 76.5t-117.5 28q-61 0 -103.5 -22.5t-70 -58t-43 -76.5t-21.5 -79t-6 -64q0 -62 11.5 -119t38.5 -102t72 -71t112 -26q55 0 96.5 19.5t69.5 51.5t45.5 69.5t25 74t7.5 65.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "R",
    unicode: "R",
    horizAdvX: 668,
    d: "M227 69q2 -19 21.5 -26.5t65.5 -16.5l-3 -29q-32 2 -65 2.5t-72 0.5q-79 0 -142 -3l-3 29q45 9 66 16.5t23 26.5l2 23.5t4 83t2 166.5q0 108 -2 167.5t-4 83l-2 23.5q-2 19 -19.5 26.5t-62.5 16.5l3 29q32 -1 64.5 -2t69.5 -1h173q68 0 112 -22.5t65 -59t21 -78.5 q0 -51 -29 -101t-106 -88l176 -293l19 -6.5t64 -10.5l-3 -29q-24 0 -53 -1t-55.5 -2t-43.5 -2l-17 -1l-177 331q-13 -1 -33 -1.5t-70 -0.5q0 -81 1.5 -130.5t4 -75.5t4 -35.5zM373 369q37 23 58.5 63.5t21.5 92.5q0 57 -41.5 87.5t-124.5 30.5q-36 0 -46.5 -4t-14.5 -18 l-2.5 -23.5t-5 -80.5t-2.5 -158q110 0 157 10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S",
    unicode: "S",
    horizAdvX: 528,
    d: "M443 529l-27 -12q-21 77 -57.5 102t-92.5 25q-58 0 -86.5 -28.5t-28.5 -66.5q0 -29 17 -58t50 -51l158 -103q104 -68 104 -161q0 -45 -25 -88t-75 -70.5t-126 -27.5q-52 0 -109.5 10t-96.5 26q5 27 10.5 63.5t5.5 83.5l27 12q10 -54 27 -85.5t46.5 -45t76.5 -13.5 q46 0 75.5 16.5t44.5 41.5t15 53q0 61 -65 103l-160 105q-47 31 -69.5 71.5t-22.5 82.5q0 46 25 87t71 67t110 26q28 0 47.5 -3.5t36.5 -7.5t37 -4t45 6v-15q0 -20 2 -46.5t4.5 -52t5.5 -42.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T",
    unicode: "T",
    horizAdvX: 642,
    d: "M322 685q97 0 166.5 1t130.5 5v-15q0 -21 1.5 -49t4.5 -54.5t6 -43.5l-27 -12q-13 42 -27.5 67.5t-36 38t-54 16.5t-80.5 4q-12 0 -21.5 -4t-11.5 -23l-2 -23.5t-4 -83t-2 -167.5t2 -167t4 -82.5l2 -23.5q2 -19 21 -26.5t64 -16.5l-3 -29q-31 2 -63 2.5t-70 0.5 q-78 0 -141 -3l-3 29q45 9 66 16.5t23 26.5l2 23.5t4 83t2 166.5q0 108 -2 167.5t-4 83l-2 23.5q-2 19 -11 23t-20 4q-48 0 -80.5 -4t-53.5 -16.5t-36 -38t-28 -67.5l-27 12q3 17 6 43.5t4.5 54.5t1.5 49v15q62 -4 132 -5t167 -1z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "U",
    unicode: "U",
    horizAdvX: 760,
    d: "M584 616q-2 19 -25.5 26.5t-68.5 16.5l3 29q32 -1 68.5 -2t73.5 -1q25 0 41 0.5t30.5 1t35.5 1.5l3 -29q-45 -9 -63 -16.5t-19 -26.5q-4 -92 -6 -184.5t-5 -184.5q-2 -71 -28.5 -130t-85.5 -94t-158 -35q-84 0 -143.5 20t-91.5 73.5t-34 154.5q-1 95 -3 190l-4 190 q0 19 -18.5 26.5t-63.5 16.5l3 29q32 -1 64.5 -2t69.5 -1q38 0 68.5 1t61.5 2l3 -29q-45 -9 -62.5 -16.5t-19.5 -26.5l-2.5 -26t-4.5 -89.5t-2 -178.5q0 -64 3.5 -115.5t20 -87.5t53 -55t102.5 -19q68 0 109.5 21t64 60t30.5 93t8 120q0 108 -2 168t-4 84.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "V",
    unicode: "V",
    horizAdvX: 689,
    d: "M356 87h5q20 64 43 135.5t45 140.5t40 126t28.5 92.5t9.5 39.5q0 14 -22.5 22t-63.5 16l3 29l64 -2t69 -1q38 0 60.5 1t53.5 2l3 -29q-45 -9 -63.5 -19.5t-26.5 -29.5l-11 -31.5t-29.5 -84t-41.5 -118t-46.5 -134t-44.5 -131.5t-36 -111l-98 -9l-214 625 q-7 17 -23.5 25.5t-61.5 17.5l3 29l64 -2t69 -1q38 0 69.5 1t62.5 2l3 -29q-40 -8 -64 -15.5t-24 -21.5q0 -4 11.5 -41t31 -95.5t43 -128t47 -140t42.5 -130.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W",
    unicode: "W",
    horizAdvX: 990,
    d: "M491 531h-4l-149 -531l-92 -9l-163 625q-7 17 -23.5 25.5t-61.5 17.5l3 29l64 -2t69 -1q72 0 135 3l3 -29q-40 -8 -64 -15.5t-24 -21.5q0 -3 10 -46.5t27.5 -115.5t39.5 -162.5t45 -188.5h5q25 82 48.5 164.5t43.5 156t35 131.5t23.5 91l8.5 33h65l176 -576h5 q13 56 28.5 121l31 130t27.5 120.5t19.5 93t7.5 47.5q0 14 -22.5 22t-63.5 16l3 29l64 -2t69 -1q38 0 60.5 1t53.5 2l3 -29q-45 -9 -65 -19.5t-25 -29.5l-7.5 -30.5t-20.5 -82t-29.5 -116t-34.5 -133.5t-35 -133t-31 -115l-92 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X",
    unicode: "X",
    horizAdvX: 700,
    d: "M366 409q45 59 80 105.5t55.5 75.5t20.5 33q0 11 -24 19.5t-63 16.5l3 29l64 -2t69 -1q38 0 60.5 1t53.5 2l3 -29q-45 -9 -61 -20.5t-29 -28.5l-195 -252l208 -289q8 -10 16 -17.5t23.5 -13.5t45.5 -12l-3 -29q-31 2 -63 2.5t-70 0.5q-78 0 -141 -3l-3 29q40 8 64.5 16 t24.5 21q0 5 -22 35.5t-58.5 81t-81.5 113.5q-44 -59 -83 -110t-63 -83.5t-24 -37.5q0 -10 24 -19t63 -17l-3 -29q-31 2 -63 2.5t-70 0.5q-37 0 -59.5 -0.5t-54.5 -2.5l-3 29q45 9 61 21t29 28l208 269l-194 272q-7 11 -15.5 18t-24 13t-45.5 12l3 29l64 -2t69 -1 q78 0 141 3l3 -29q-40 -7 -64.5 -15t-24.5 -21q0 -3 20.5 -33t54.5 -77.5t74 -103.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y",
    unicode: "Y",
    horizAdvX: 641,
    d: "M336 331q45 83 73.5 136.5t44.5 84.5t23 45.5t8.5 19t1.5 6.5q0 12 -26 20t-66 16l3 29l64 -2t69 -1q38 0 60.5 1t53.5 2l3 -29q-45 -9 -62.5 -20t-27.5 -29l-193 -347q1 -77 2.5 -119t3.5 -58.5l2 -16.5q2 -19 21 -26.5t64 -16.5l-3 -29q-31 2 -63 2.5t-70 0.5 q-78 0 -141 -3l-3 29q45 9 66 16.5t23 26.5l1.5 17t3.5 59.5t2 116.5l-193 354q-9 17 -24.5 25.5t-60.5 17.5l3 29l64 -2t69 -1q78 0 141 3l3 -29q-40 -7 -64.5 -15t-24.5 -21q0 -2 0.5 -4t1.5 -4z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z",
    unicode: "Z",
    horizAdvX: 640,
    d: "M598 652l-447 -599h116q83 0 139 3t91 14.5t56 35t34 65.5l27 -12q-6 -18 -11 -49t-8.5 -61.5t-4.5 -48.5h-536l-24 35l448 596q-105 0 -172.5 -1t-107.5 -6.5t-61 -17.5t-32 -33.5t-22 -55.5l-27 12q3 17 6 43.5t4.5 54.5t1.5 49v15q41 -3 105.5 -4.5t137.5 -1.5h137 h132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketleft",
    unicode: "[",
    horizAdvX: 427,
    d: "M124 291q0 81 -3.5 154t-8.5 129.5t-8.5 89.5l-3.5 33l21 10q19 -5 54.5 -9.5t80 -7.5t91.5 -3l-3 -36l-152 -16l6.5 -91.5t6.5 -252.5q0 -107 -3 -189t-6.5 -128l-3.5 -46l152 -16l3 -36q-47 0 -91.5 -3t-80 -7.5t-54.5 -9.5l-21 10l3.5 35.5t8.5 96t8.5 136.5t3.5 157z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "backslash",
    unicode: "\\\\\\\\",
    horizAdvX: 290,
    d: "M85 701l185 -841h-65l-185 841h65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketright",
    unicode: "]",
    horizAdvX: 427,
    d: "M303 273q0 -81 3.5 -154t8.5 -129.5t8.5 -89.5l3.5 -33l-21 -10q-19 5 -54.5 9.5t-80 7.5t-91.5 3l3 36l152 16l-6.5 91.5t-6.5 252.5q0 108 3.5 189.5t6.5 127.5l3 46l-152 16l-3 36q47 0 91.5 3t80 7.5t54.5 9.5l21 -10l-3.5 -35.5t-8.5 -96t-8.5 -136.5t-3.5 -157z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciicircum",
    unicode: "^",
    horizAdvX: 523,
    d: "M235 664h51l200 -399h-69l-156 336l-156 -336h-69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "underscore",
    unicode: "_",
    horizAdvX: 462,
    d: "M44 -16q41 -2 67.5 -3t53 -1.5t66.5 -0.5q47 0 79.5 0.5t65.5 1.5t79 3l7 -15l-44 -48q-40 2 -66.5 2.5l-53 1t-67.5 0.5q-46 0 -79 -0.5t-65.5 -1.5t-79.5 -3l-7 16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "grave",
    unicode: "`",
    d: "M32 518l-173 162q2 17 23 29.5t46 12.5l134 -199z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a",
    unicode: "a",
    horizAdvX: 457,
    d: "M437 52l10 -26q-38 -35 -83 -35q-25 0 -45 15.5t-25 49.5q-37 -28 -73.5 -46.5t-78.5 -18.5q-40 0 -71.5 25t-31.5 79q0 36 23 70.5t78.5 59t150.5 30.5v93q0 29 -21.5 43.5t-51.5 14.5q-44 0 -65 -21t-21 -52q0 -12 3 -27l-22 -10q-21 11 -38 30.5t-17 27.5q0 7 12.5 24 t37.5 36t61 32.5t83 13.5q31 0 56.5 -9t40.5 -32t15 -66q0 -10 0.5 -36t1.5 -60t1.5 -68.5t1.5 -60.5t1 -36q1 -27 11.5 -37.5t24.5 -10.5q6 0 14 2t17 6zM291 94v116q-88 -2 -128 -33t-40 -66q0 -30 18 -45t47 -15q22 0 48.5 10.5t54.5 32.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "b",
    unicode: "b",
    horizAdvX: 536,
    d: "M265 -9q-55 0 -105 10t-86 24l2 32.5t4 107.5t2 204q0 97 -1 156t-3 90t-3 41.5l-1 10.5l-64 19l-2 26q18 0 42.5 2.5t48.5 7t41 8.5l19 -9l-1 -81.5t-1 -237.5q38 29 80 43.5t82 14.5q47 0 87 -22.5t64.5 -70t24.5 -124.5q0 -86 -32.5 -142t-85 -83t-112.5 -27zM248 44 q62 0 97 28.5t50 73t15 91.5q0 71 -28 115.5t-102 44.5q-35 0 -71 -10t-53 -21q0 -106 1.5 -170t3.5 -95.5t3 -39.5q23 -9 44 -13t40 -4z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c",
    unicode: "c",
    horizAdvX: 443,
    d: "M409 90l12 -33q-34 -27 -77.5 -46.5t-99.5 -19.5q-70 0 -116.5 29.5t-69 80.5t-22.5 114q0 45 14.5 88.5t43 79t71 56.5t99.5 21q43 0 77 -14.5t54 -31t20 -22.5q0 -13 -6 -34.5t-18 -38.5h-24q-6 17 -20 37t-37 35t-57 15q-44 0 -73 -27.5t-42.5 -70t-13.5 -86.5 q0 -91 41 -131.5t105 -40.5q32 0 70 10.5t69 29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "d",
    unicode: "d",
    horizAdvX: 544,
    d: "M377 56q-35 -33 -75.5 -49t-78.5 -16q-50 0 -92 25.5t-67 76t-25 124.5q0 80 30 134t79.5 82t107.5 28q32 0 59 -7.5t61 -27.5q0 78 -1.5 126t-3 72.5t-2.5 33.5l-1 9l-64 19l-2 26q18 0 42.5 2.5t48.5 7t41 8.5l19 -9l-1 -93t-1 -276q0 -121 1 -181t2 -86q1 -18 13 -27 t29 -11.5t34 -3.5l-3 -29q-27 -2 -55 -7.5t-54 -10.5l-16.5 12.5t-24.5 47.5zM376 382q-26 9 -48.5 13.5t-45.5 4.5q-56 0 -90 -26t-49 -67t-15 -88q0 -70 31.5 -117.5t98.5 -47.5q35 0 66 14t47 26q1 16 2 59.5t2 103.5t1 125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "e",
    unicode: "e",
    horizAdvX: 459,
    d: "M403 83l12 -30q-31 -25 -72.5 -43.5t-91.5 -18.5q-74 0 -121.5 29.5t-70 78.5t-22.5 108q0 48 13.5 93t41.5 81t74 57.5t110 21.5q36 0 71 -17t58 -54.5t23 -99.5l-34 -41q-4 1 -13.5 1h-23.5q-25 0 -59 -0.5t-69 -1.5t-64 -2.5t-43 -2.5v-9q0 -94 39.5 -138t102.5 -44 q37 0 70 8t69 24zM338 320q0 34 -13.5 53.5t-33 28.5t-37.5 9q-49 0 -82 -38.5t-44 -89.5l207 8q3 15 3 29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f",
    unicode: "f",
    horizAdvX: 316,
    d: "M187 48q1 -5 15.5 -10t32.5 -8t28 -4l-3 -29q-24 2 -61.5 2.5t-63.5 0.5q-25 0 -56.5 -0.5t-55.5 -2.5l3 29q11 1 26.5 4t28 8t13.5 10l1.5 16t3 55.5t2.5 109.5t1 177q-33 -1 -51 -1h-18l-3 11l23 39l11.5 -1t36.5 -3q0 69 22 118t55 80.5t67.5 49t61.5 24.5t35 7 q5 0 15.5 -10.5t21 -26.5t14.5 -33l-15 -19q-13 6 -36.5 12.5t-49.5 6.5q-28 0 -54.5 -15.5t-43.5 -60t-17 -132.5q62 0 96 0.5l34 0.5l5 -12l-31 -39l-25.5 1.5t-78.5 2.5q0 -105 1.5 -173.5t3 -108t3.5 -56.5t2 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "g",
    unicode: "g",
    horizAdvX: 490,
    d: "M354 429q6 9 19.5 25t30 29t30.5 13q5 0 15.5 -10.5t21 -26.5t14.5 -33l-15 -19q-7 4 -18.5 6.5t-25.5 2.5q-10 0 -22 -2.5t-24 -8.5q17 -20 26 -48.5t9 -68.5q0 -39 -18.5 -77t-58.5 -63t-105 -25q-23 0 -44 3q-17 -22 -27 -38.5t-10 -27.5q0 -13 15.5 -18t49.5 -5h75 q96 0 142.5 -32t46.5 -90q0 -41 -32 -82.5t-94 -68.5t-152 -27q-45 0 -86.5 10t-68.5 31t-27 53q0 28 25 66t78 81q-31 7 -47 20t-16 29q0 20 26.5 48t63.5 58q-48 15 -74.5 53t-26.5 108q0 39 19 77t59.5 63t104.5 25q36 0 67 -6.5t54 -23.5zM329 278q0 33 -7 65 t-27.5 53.5t-60.5 21.5q-31 0 -51 -14t-30 -34.5t-14 -41t-4 -34.5q0 -30 8.5 -60t29.5 -50t57 -20q39 0 60 20t29.5 47t9.5 47zM105 -136q0 -37 28 -62t86 -25q54 0 94 20.5t62 51t22 58.5t-24 48t-83 20h-135q-25 -28 -37.5 -56.5t-12.5 -54.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "h",
    unicode: "h",
    horizAdvX: 558,
    d: "M166 362q0 -99 1.5 -160.5t3.5 -94.5t4 -45.5t2 -13.5q1 -5 12.5 -10t26.5 -8t25 -4l-3 -29q-24 2 -53 2.5t-55 0.5q-25 0 -56.5 -0.5t-55.5 -2.5l3 29q11 1 25 4t25.5 8t12.5 10l1 14.5t2.5 50t2.5 98t1 158.5q0 97 -1 156t-3 90t-3 41.5l-1 10.5l-64 19l-2 26 q18 0 42.5 2.5t48.5 7t41 8.5l19 -9l-1 -83.5t-1 -235.5q21 12 55 25.5t72.5 23t72.5 9.5q43 0 72.5 -20.5t29.5 -74.5v-136q0 -73 2.5 -112t5 -54l2.5 -15q1 -5 12.5 -10t26.5 -8t25 -4l-3 -29q-24 2 -53 2.5t-55 0.5q-25 0 -56.5 -0.5t-55.5 -2.5l3 29q11 1 25 4t25.5 8 t12.5 10l2 15t4 54t2 112v105q0 37 -21.5 50.5t-53.5 13.5q-25 0 -54.5 -6.5t-55.5 -14.5t-42 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "i",
    unicode: "i",
    horizAdvX: 275,
    d: "M161 459l19 -9q0 -13 -0.5 -40t-0.5 -59.5t-0.5 -65t-0.5 -56.5q0 -73 2.5 -112t5 -54l2.5 -15q1 -5 14.5 -10t30 -8t26.5 -4l-3 -29q-24 2 -56.5 2.5t-58.5 0.5q-25 0 -60 -0.5t-59 -2.5l3 29q11 1 27 4t29 8t14 10l2 15t4 54t2 112t-2 108.5t-4 47l-2 11.5l-64 19 l-2 26q18 0 42.5 2.5t48.5 7t41 8.5zM138 563q-22 0 -37 15.5t-15 38.5q0 22 15 37t37 15t37 -15t15 -37q0 -23 -15 -38.5t-37 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j",
    unicode: "j",
    horizAdvX: 258,
    d: "M105 15q0 137 -2 221t-4 122l-2 38l-64 19l-2 26q18 0 42.5 2.5t48.5 7t41 8.5l19 -9l-0.5 -48t-1 -137t-0.5 -211q0 -79 -15 -134t-37.5 -91t-46.5 -56t-42 -28t-24 -8q-5 0 -15.5 10.5t-20.5 27t-15 32.5l15 19q10 -6 26 -12.5t34 -6.5q16 0 31 15.5t25 60.5t10 132z M141 563q-22 0 -37 15.5t-15 38.5q0 22 15 37t37 15t37 -15t15 -37q0 -23 -15 -38.5t-37 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "k",
    unicode: "k",
    horizAdvX: 517,
    d: "M517 26l-3 -29q-17 0 -43 -1t-50 -2.5t-36 -2.5l-185 258l-31 -23q2 -98 5 -137t3 -41q1 -5 12.5 -10t26.5 -8t25 -4l-3 -29q-24 2 -53 2.5t-55 0.5q-25 0 -56.5 -0.5t-55.5 -2.5l3 29q11 1 25 4t25.5 8t12.5 10l1.5 14.5t3 50t3 98t1.5 158.5q0 97 -1 156t-3 90t-3 41.5 l-1 10.5l-64 19l-2 26q18 0 42.5 2.5t48.5 7t41 8.5l19 -9l-1 -93t-1 -276v-80l160 120q7 6 7 12q0 8 -14 15t-46 8l3 29q21 -1 34 -1.5t27.5 -1t38.5 -0.5q37 0 58.5 1t52.5 2l3 -29q-41 -6 -65.5 -18t-40.5 -23l-124 -92l188 -251q9 -13 30 -14t37 -3z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "l",
    unicode: "l",
    horizAdvX: 272,
    d: "M173 352q0 -90 1.5 -147t3.5 -90t3.5 -47.5t2.5 -19.5t14 -10t29.5 -8t26.5 -4l-3 -29q-24 2 -56 2.5t-58 0.5q-25 0 -59.5 -0.5t-58.5 -2.5l3 29q11 1 26.5 4t28.5 8t14 10l1 14.5t2.5 50t2.5 98t1 159.5q0 96 -1 155t-3 90t-3 41.5l-1 10.5l-64 19l-2 26q18 0 42.5 2.5 t48.5 7t41 8.5l19 -9l-1 -93t-1 -276z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "m",
    unicode: "m",
    horizAdvX: 838,
    d: "M821 26l-3 -29q-24 2 -53 2.5t-55 0.5q-25 0 -56.5 -0.5t-55.5 -2.5l3 29q11 1 25 4t25.5 8t12.5 10l2 15t4 54t2 112v105q0 37 -21.5 50.5t-53.5 13.5q-35 0 -74 -12t-64 -22v-135q0 -73 2.5 -112t5 -54l2.5 -15q1 -5 12.5 -10t26.5 -8t25 -4l-3 -29q-24 2 -53 2.5 t-55 0.5q-25 0 -56.5 -0.5t-55.5 -2.5l3 29q11 1 25 4t25.5 8t12.5 10l2 15t4 54t2 112v105q0 37 -21.5 50.5t-53.5 13.5q-23 0 -49.5 -6.5t-49.5 -14.5t-38 -15v-133q0 -73 3 -112t5.5 -54l2.5 -15q1 -5 12.5 -10t26.5 -8t25 -4l-3 -29q-24 2 -53 2.5t-55 0.5 q-25 0 -56.5 -0.5t-55.5 -2.5l3 29q11 1 25 4t25.5 8t12.5 10l2 15t3.5 54t1.5 112t-2 108.5t-4 47l-2 11.5l-64 19l-2 26q18 0 42.5 2.5t48.5 7t41 8.5l19 -9l-0.5 -15.5t-0.5 -32.5q20 12 51 25.5t66 23t67 9.5q34 0 60.5 -13t36.5 -45q20 12 52.5 25.5t69 23t69.5 9.5 q43 0 72.5 -20.5t29.5 -74.5v-136q0 -73 2.5 -112t5 -54l2.5 -15q1 -5 12.5 -10t26.5 -8t25 -4z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "n",
    unicode: "n",
    horizAdvX: 560,
    d: "M155 459l19 -9v-48q21 12 53 25.5t69 23t71 9.5q43 0 72.5 -20.5t29.5 -74.5v-136q0 -73 2.5 -112t5 -54l2.5 -15q1 -5 12.5 -10t26.5 -8t25 -4l-3 -29q-24 2 -53 2.5t-55 0.5q-25 0 -56.5 -0.5t-55.5 -2.5l3 29q11 1 25 4t25.5 8t12.5 10l2 15t4 54t2 112v105 q0 37 -21.5 50.5t-53.5 13.5q-25 0 -52.5 -6.5t-52.5 -14.5t-41 -15q0 -25 -0.5 -57t-0.5 -76q0 -73 2.5 -112t5 -54l2.5 -15q1 -5 12.5 -10t26.5 -8t25 -4l-3 -29q-24 2 -53 2.5t-55 0.5q-25 0 -56.5 -0.5t-55.5 -2.5l3 29q11 1 25 4t25.5 8t12.5 10l2 15t4 54t2 112 t-2 108.5t-4 47l-2 11.5l-64 19l-2 26q18 0 42.5 2.5t48.5 7t41 8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "o",
    unicode: "o",
    horizAdvX: 529,
    d: "M490 243q0 -48 -13.5 -93t-41.5 -81t-73.5 -57t-110.5 -21q-112 0 -162 59.5t-50 155.5q0 48 13.5 93t41.5 81.5t74 58t110 21.5q75 0 121.5 -27.5t68.5 -76.5t22 -113zM404 206q0 51 -11.5 98t-41 77t-84.5 30q-44 0 -72 -20.5t-43 -50.5t-21 -60t-6 -50q0 -49 13 -92.5 t43 -71t81 -27.5q40 0 67.5 17.5t44 44.5t23.5 55.5t7 49.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "p",
    unicode: "p",
    horizAdvX: 546,
    d: "M164 23q1 -94 2 -145t2.5 -71t1.5 -22q1 -5 14 -9t29.5 -6.5t26.5 -3.5l-3 -29q-24 2 -56 2.5t-58 0.5q-25 0 -59.5 -0.5t-58.5 -2.5l3 29q11 1 26.5 3.5t28.5 6.5t14 9l2 13t4 47t4 95.5t2 157.5q0 97 -1 156t-3 90t-3 41.5l-1 10.5l-64 19l-2 26q27 0 66.5 5.5 t64.5 12.5l19 -9v-49q38 29 80.5 44t82.5 15q48 0 88 -22.5t64.5 -70t24.5 -124.5q0 -86 -29 -142t-78 -83t-110 -27q-31 0 -62.5 8t-61.5 24zM164 366v-305q26 -9 49 -13t43 -4q63 0 98.5 28.5t50.5 73t15 91.5q0 71 -29 115.5t-103 44.5q-35 0 -71 -10t-53 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "q",
    unicode: "q",
    horizAdvX: 536,
    d: "M393 430l42 37l19 -9l-1 -91.5t-1 -277.5q0 -90 1.5 -147t3.5 -90t3.5 -47.5t2.5 -19.5t12.5 -9t26.5 -6.5t25 -3.5l-3 -29q-24 2 -53 2.5t-55 0.5q-25 0 -59.5 -0.5t-58.5 -2.5l3 29q11 1 26.5 3.5t28.5 6.5t14 9l2 21.5t4 78t2 159.5q-43 -30 -78.5 -42t-80.5 -12 q-57 0 -97 31.5t-60.5 82t-20.5 107.5q0 72 30.5 128.5t81.5 89t113 32.5q31 0 64.5 -7t62.5 -24zM379 81q0 104 -2 168.5t-4 98t-3 41.5q-23 9 -44 13t-40 4q-51 0 -85.5 -29t-52.5 -73.5t-18 -92.5q0 -41 14 -78t43 -60t75 -23q32 0 58.5 7.5t58.5 23.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "r",
    unicode: "r",
    horizAdvX: 377,
    d: "M160 459l19 -9q-1 -11 -1.5 -33.5t-0.5 -48.5q22 37 51.5 58t55 30.5t35.5 9.5q5 0 15.5 -10.5t21 -26.5t14.5 -33l-15 -19q-13 5 -31 9.5t-38 4.5q-26 0 -51 -12.5t-41.5 -42t-16.5 -82.5q0 -82 1.5 -124.5t4 -58.5t3.5 -22q2 -8 30 -14.5t56 -8.5l-3 -29q-16 1 -40 1.5 l-48 1t-41 0.5q-25 0 -57.5 -0.5t-56.5 -2.5l3 29q11 1 25.5 4t26.5 8t13 10l2 15t4 54t2 112t-2 108.5t-4 47l-2 11.5l-64 19l-2 26q18 0 42.5 2.5t48.5 7t41 8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s",
    unicode: "s",
    horizAdvX: 382,
    d: "M193 460q62 0 96.5 -12.5l34.5 -12.5q0 -22 1 -50t5 -49l-26 -9q-13 53 -37 72t-62 19q-34 0 -54.5 -19t-20.5 -45q0 -18 11 -37.5t41 -36.5l102 -56q31 -17 48.5 -43t17.5 -64q0 -30 -16 -59t-51.5 -48t-92.5 -19q-30 0 -68.5 6t-81.5 19q3 15 5.5 36.5t4.5 43t2 35.5 l26 9q9 -35 18 -60.5t28.5 -38.5t59.5 -13q43 0 65 21t22 47q0 19 -11.5 37t-35.5 31l-108 60q-34 18 -50 47t-16 60q0 32 16.5 61.5t48.5 48.5t78 19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "t",
    unicode: "t",
    horizAdvX: 327,
    d: "M311 71l12 -33q-34 -22 -65 -34.5t-63 -12.5q-43 0 -73.5 21t-30.5 79l0.5 24.5t0.5 60v67.5q0 50 -0.5 91.5t-1.5 71.5q-30 -1 -47 -1h-17l-3 11l23 39l10.5 -1.5t31.5 -2.5q0 20 -1 41.5t-2 36l-1 14.5l66 59l19 -9l-0.5 -21.5t-1 -53.5t-0.5 -66q68 0 107.5 0.5 l39.5 0.5l5 -12l-36 -40l-27 2t-89 3v-134q0 -60 0.5 -99t2.5 -80q2 -25 17 -35t36 -10q23 0 47.5 8t40.5 15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "u",
    unicode: "u",
    horizAdvX: 550,
    d: "M458 85q1 -18 12.5 -27t29 -11.5t34.5 -3.5l-3 -29q-27 -2 -55 -7.5t-54 -10.5l-16.5 12.5t-24.5 47.5q-40 -27 -92 -46t-102 -19q-44 0 -73 22.5t-29 81.5v134q0 73 -1.5 108.5t-3.5 47l-2 11.5l-59 19l-2 26q27 0 64.5 5.5t62.5 12.5l19 -9l-0.5 -30t-1 -79.5t-1 -107 t-0.5 -113.5q0 -37 20.5 -52t60.5 -15q37 0 75.5 14t59.5 28q2 20 3 48t1 86q0 73 -2 108.5t-4 47l-2 11.5l-63 19l-2 26q18 0 42.5 2.5t48.5 7t41 8.5l19 -9l-1.5 -59t-1.5 -189q0 -63 1.5 -90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "v",
    unicode: "v",
    horizAdvX: 479,
    d: "M142 397q0 -4 29.5 -87.5t78.5 -243.5q53 162 81 244.5t28 87.5q0 22 -55 29l-3 29l22 -1.5t50 -1.5q19 0 42.5 1t41.5 1.5l18 0.5l3 -29q-35 -5 -47 -14.5t-17 -25.5l-136 -387l-75 -9l-137 395q-4 11 -16 23.5t-45 17.5l-3 29l18 -0.5t42 -1.5t42 -1q19 0 42 1 t39.5 1.5l16.5 0.5l3 -29q-33 -4 -48 -13t-15 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "w",
    unicode: "w",
    horizAdvX: 725,
    d: "M604 396q0 11 -17 19t-46 12l-3 29l26 -1.5t54 -1.5q19 0 42.5 1t41.5 1.5l18 0.5l3 -29q-32 -4 -45.5 -13.5t-17.5 -23.5l-111 -390l-79 -9l-110 288l-103 -279l-78 -9l-112 395q-3 11 -15.5 23.5t-45.5 17.5l-3 29l18 -0.5t42 -1.5t42 -1q19 0 45.5 1t46.5 1.5l20 0.5 l3 -29q-38 -5 -52.5 -15.5t-14.5 -18.5q0 -2 5.5 -26t14.5 -60.5t19.5 -79.5t21 -85.5t18.5 -75.5l136 384h22l132 -384q8 34 18.5 76t22 85t20.5 80.5t15 61.5t6 27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "x",
    unicode: "x",
    horizAdvX: 496,
    d: "M234 183l-86 -113q-16 -20 -16 -26t14 -10.5t48 -7.5l-6 -29l-13 1t-32.5 1.5t-38.5 0.5q-18 0 -41 -0.5t-39.5 -1.5l-16.5 -1l3 29q29 3 41 9.5t22 18.5l134 168l-122 177q-7 10 -18 17.5t-40 10.5l-3 29l21.5 -0.5t49 -1.5t46.5 -1t38.5 1t33 1.5l13.5 0.5l3 -29 q-34 -3 -45 -8t-11 -12q0 -8 16 -30l74 -102l75 101q6 8 10 15.5t4 14.5q0 9 -10.5 13.5t-37.5 7.5l-3 29l14 -0.5t34 -1.5t39 -1q28 0 55 1.5l27 1.5l3 -29q-19 -1 -35.5 -12t-25.5 -22l-121 -157l131 -179q7 -10 21 -19t47 -12l-3 -29l-21.5 1t-49 1.5t-46.5 0.5 t-41.5 -0.5t-38.5 -1.5l-16 -1l3 29q32 3 42.5 8.5t10.5 12.5q0 5 -12 21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y",
    unicode: "y",
    horizAdvX: 482,
    d: "M228 0l-35 21l-130 365q-4 11 -16 23.5t-45 17.5l-3 29l18 -0.5t42 -1.5t42 -1q19 0 42 1t39.5 1.5l16.5 0.5l3 -29q-33 -4 -46.5 -13t-13.5 -17q0 -4 29 -88.5t81 -244.5q56 158 84 241.5t28 92.5q0 22 -55 29l-3 29l22 -1.5t50 -1.5q18 0 42 1t42 1.5l18 0.5l3 -29 q-31 -4 -43.5 -11.5t-17 -21.5t-14.5 -40l-133 -354q-36 -96 -68 -150t-57.5 -78t-44.5 -29.5t-30 -5.5q-5 0 -15.5 10.5t-20.5 27t-15 32.5l15 19q19 -9 45 -9q16 0 38 14t49 53.5t57 115.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "z",
    unicode: "z",
    horizAdvX: 444,
    d: "M398 0h-352l-20 30l287 380q-76 0 -119.5 -1.5t-66 -9.5t-33.5 -25.5t-21 -49.5l-26 9q3 19 6 51.5t3 57.5v13q23 -2 65.5 -3t92.5 -1.5t99 -0.5h85l15 -28l-283 -377q89 0 141 6t80 28t42 68l26 -9q-5 -15 -9.5 -42t-7.5 -53.5t-4 -42.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceleft",
    unicode: "{",
    horizAdvX: 353,
    d: "M60 263v34q1 0 11.5 1t24 7t23.5 20t10 39q0 6 -5 32t-12 62.5t-14.5 76t-12.5 73t-5 52.5q0 17 20.5 26.5t54 14t72.5 5.5t76 1l-3 -36q-25 0 -57 -4.5t-55.5 -12t-23.5 -19.5l4.5 -17.5t11 -46.5t11 -64.5t4.5 -71.5q0 -34 -3.5 -65t-16 -54.5t-38.5 -35.5 q26 -11 38.5 -35t16 -54.5t3.5 -64.5q0 -48 -7.5 -94.5t-15.5 -76.5l-8 -30q0 -11 23.5 -19t55.5 -12t57 -5l3 -36q-37 0 -76 1t-72.5 5.5t-54 14t-20.5 26.5q0 19 5 52.5t12.5 73t14.5 76t12 62.5t5 32q0 26 -10 39.5t-23.5 19.5t-24 7t-11.5 1z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bar",
    unicode: "|",
    horizAdvX: 289,
    d: "M112 -140v841h65v-841h-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceright",
    unicode: "}",
    horizAdvX: 353,
    d: "M293 297v-34q-1 0 -11.5 -1t-24 -7t-23.5 -19.5t-10 -39.5q0 -6 5 -32t12.5 -62.5t14.5 -76t12 -73t5 -52.5q0 -17 -20.5 -26.5t-54 -14t-72.5 -5.5t-76 -1l3 36q26 1 57.5 5t55 12t23.5 19l-4.5 17.5t-11 46.5t-11 64.5t-4.5 71.5q0 34 3.5 65t16 55t38.5 35 q-26 12 -38.5 35.5t-16 54.5t-3.5 64q0 49 8 95t15.5 76l7.5 30q0 12 -23.5 19.5t-55 12t-57.5 4.5l-3 36q37 0 76 -1t72.5 -5.5t54 -14t20.5 -26.5q0 -19 -5 -52.5t-12 -73t-14.5 -76t-12.5 -62.5t-5 -32q0 -25 10 -39t23.5 -20t24 -7t11.5 -1z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciitilde",
    unicode: "~",
    horizAdvX: 523,
    d: "M468 334l31 -31q-30 -34 -59 -48t-59 -14t-60 10t-59.5 22.5t-59.5 22.5t-60 10q-29 0 -50.5 -10t-35.5 -22l-31 31q30 35 59 48.5t59 13.5t60 -10t59.5 -22.5t59.5 -22.5t60 -10q29 0 50 10t36 22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00A0",
    unicode: "\xA0",
    horizAdvX: 250
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclamdown",
    unicode: "\xA1",
    horizAdvX: 236,
    d: "M118 461q22 0 37.5 -15.5t15.5 -39.5q0 -22 -15.5 -37.5t-37.5 -15.5t-37.5 15.5t-15.5 37.5q0 24 15.5 39.5t37.5 15.5zM64 -239l33 523l38 9l37 -505l-5 -6.5t-27.5 -13t-75.5 -7.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cent",
    unicode: "\xA2",
    horizAdvX: 523,
    d: "M257 553l11 88h45l-11 -88q26 -2 44.5 -7t41.5 -5q8 0 18 1.5t21 3.5v-13q0 -27 3.5 -64t7.5 -60l-24 -11q-17 62 -49 85t-69 26l-44 -356q23 -6 49 -6q27 0 59 7t66 23l14 -29q-34 -27 -76.5 -44.5t-98.5 -17.5h-10.5t-10.5 1l-12 -96h-45l13 103q-49 14 -82 46.5 t-49 76.5t-16 91q0 57 23 111t68.5 91t112.5 43zM139 328q0 -46 16.5 -88t53.5 -68l42 335q-42 -8 -66.5 -35.5t-35 -65.5t-10.5 -78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sterling",
    unicode: "\xA3",
    horizAdvX: 523,
    d: "M128 50q36 -4 67 -6t56 -2q61 0 98.5 11.5t60 35.5t36.5 62l23 -11q-5 -16 -9.5 -43t-7.5 -54t-4 -43h-402l-15 24l45 30q19 32 31 73.5t19 84.5t8 77h-94l6 43h88q-1 52 -8 92.5t-7 65.5q0 83 49 117t128 34q37 0 58.5 -6.5t48.5 -6.5q8 0 18 1.5t21 3.5 q0 -17 1.5 -42.5t4 -51t5.5 -43.5l-24 -11q-19 68 -51 90t-81 22q-39 0 -58.5 -20.5t-25.5 -54.5t-6 -75q0 -25 1.5 -51.5t1.5 -54.5v-9h156l-6 -43h-152q-4 -70 -23 -136t-57 -103z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "currency",
    unicode: "\xA4",
    horizAdvX: 523,
    d: "M33 148l82 65q-36 49 -36 110q0 59 36 109l-80 63l51 56l66 -83q23 17 50.5 26.5t58.5 9.5q30 0 57.5 -9.5t51.5 -26.5l64 81l55 -53l-82 -65q16 -23 26 -50.5t10 -57.5q0 -31 -10 -59t-26 -51l80 -62l-51 -56l-66 82q-50 -36 -109 -36q-61 0 -110 36l-62 -80zM146 323 q0 -49 33 -82.5t82 -33.5q50 0 82.5 33.5t32.5 82.5q0 48 -32.5 81.5t-82.5 33.5q-49 0 -82 -33.5t-33 -81.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yen",
    unicode: "\xA5",
    horizAdvX: 523,
    d: "M162 584q0 -2 9.5 -28.5t25 -69t35 -92.5t39.5 -99l122 274q2 3 2 6v5q0 11 -10 18t-36 14l3 29q20 -1 36 -2t38 -1q26 0 77 3l3 -29q-25 -4 -36.5 -13t-21.5 -30l-85 -190h108l-6 -43h-122l-23 -52h151l-6 -43h-157q1 -97 3 -134.5l2 -37.5q2 -19 21 -26.5t64 -16.5 l-3 -29q-31 2 -61.5 2.5t-68.5 0.5q-75 0 -138 -3l-3 29q45 9 66 16.5t23 26.5l1.5 36.5t2.5 135.5h-163l6 43h141l-21 52h-126l6 43h103l-76 191q-7 20 -23.5 28.5t-41.5 13.5l3 29q24 -1 47 -2t41 -1q33 0 56.5 1t36.5 2l3 -29q-23 -4 -35 -10t-12 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "brokenbar",
    unicode: "\xA6",
    horizAdvX: 289,
    d: "M112 366v335h65v-335h-65zM112 -140v335h65v-335h-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "section",
    unicode: "\xA7",
    horizAdvX: 501,
    d: "M474 707q11 -10 15.5 -24t4.5 -28q0 -22 -9 -41.5t-24 -29.5q-26 10 -53 10q-59 0 -95.5 -25.5t-55 -69.5t-25 -100t-6.5 -116v-109q0 -51 -4 -97t-17 -81.5t-39 -56t-70 -20.5q-6 0 -12 0.5t-12 1.5q35 18 53.5 42t27 62t10 96t1.5 145q0 74 11 144.5t42.5 131t93 104 t163.5 61.5zM27 -229q-10 11 -15 24.5t-5 27.5q0 22 9 41.5t24 29.5q26 -10 53 -10q59 0 95.5 25.5t55 69.5t25 100t6.5 116v109q0 51 4 97t17 81.5t39 56t70 20.5q6 0 12 -0.5t12 -1.5q-34 -18 -53 -42t-27.5 -62t-10 -96t-1.5 -145q0 -73 -11 -144t-42.5 -131.5t-93 -104 t-163.5 -61.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dieresis",
    unicode: "\xA8",
    d: "M90 563q-22 0 -37 15.5t-15 38.5q0 22 15 37t37 15t37 -15t15 -37q0 -23 -15 -38.5t-37 -15.5zM-90 563q-22 0 -37 15.5t-15 38.5q0 22 15 37t37 15t37 -15t15 -37q0 -23 -15 -38.5t-37 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "copyright",
    unicode: "\xA9",
    horizAdvX: 600,
    d: "M18 479q0 58 22 109t60.5 89.5t89.5 60.5t109 22q59 0 110 -22t89.5 -60.5t60.5 -89.5t22 -109t-22 -109.5t-60.5 -90t-89.5 -60.5t-110 -22q-58 0 -109 22t-89.5 60.5t-60.5 90t-22 109.5zM55 479q0 -67 33 -122.5t88.5 -88.5t122.5 -33q68 0 123 33t88 88.5t33 122.5 t-33 122.5t-88 88.5t-123 33q-67 0 -122.5 -33t-88.5 -88.5t-33 -122.5zM302 339q43 0 70 19t37 50l22 -9q-4 -14 -6.5 -30t-4.5 -33q-31 -11 -61.5 -17.5t-58.5 -6.5q-48 0 -87.5 16.5t-63 51.5t-23.5 89q0 46 18 87.5t58 68t104 26.5q17 0 36.5 -3.5t38.5 -3.5q8 0 16 1 t15 4q0 -22 1.5 -44t3.5 -35l-21 -9q-11 38 -38.5 52t-58.5 14q-28 0 -54 -15t-42.5 -46t-16.5 -79q0 -35 11.5 -69.5t37 -56.5t67.5 -22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordfeminine",
    unicode: "\xAA",
    horizAdvX: 286,
    d: "M273 406l9 -22q-13 -10 -27.5 -17t-28.5 -7q-16 0 -28.5 9.5t-17.5 28.5q-22 -16 -44.5 -27t-46.5 -11q-26 0 -47 14t-21 48q0 35 38.5 66.5t117.5 41.5v54q0 17 -12 25t-30 8q-24 0 -36 -12.5t-12 -30.5q0 -4 0.5 -7.5t2.5 -10.5l-19 -8q-15 8 -26.5 21.5t-11.5 18.5 q0 6 14.5 22.5t42 31t67.5 14.5q30 0 51.5 -14t21.5 -55q0 -8 0.5 -30.5t1.5 -50t1.5 -50t0.5 -30.5q0 -16 5.5 -21t12.5 -5q3 0 8.5 1t12.5 5zM177 422v74q-49 -1 -72 -20.5t-23 -40.5q0 -16 10 -23.5t26 -7.5q13 0 28.5 4.5t30.5 13.5zM37 317q24 -2 39 -3t30.5 -1h38.5 h46t37.5 1t45.5 3l4 -12l-25 -39q-23 2 -38.5 2.5t-30.5 0.5h-39h-45t-38 -1t-46 -3l-4 13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotleft",
    unicode: "\xAB",
    horizAdvX: 517,
    d: "M397 389l20 -17l-104 -149l104 -149l-20 -17l-157 151q-4 8 -4 15t4 15zM251 389l20 -17l-104 -149l104 -149l-20 -17l-157 151q-4 8 -4 15t4 15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "logicalnot",
    unicode: "\xAC",
    horizAdvX: 523,
    d: "M24 273v61h475v-268h-61v207h-414z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "registered",
    unicode: "\xAE",
    horizAdvX: 600,
    d: "M18 479q0 58 22 109t60.5 89.5t89.5 60.5t109 22q59 0 110 -22t89.5 -60.5t60.5 -89.5t22 -109t-22 -109.5t-60.5 -90t-89.5 -60.5t-110 -22q-58 0 -109 22t-89.5 60.5t-60.5 90t-22 109.5zM55 479q0 -67 33 -122.5t88.5 -88.5t122.5 -33q68 0 123 33t88 88.5t33 122.5 t-33 122.5t-88 88.5t-123 33q-67 0 -122.5 -33t-88.5 -88.5t-33 -122.5zM258 352q1 -8 10 -11.5t31 -8.5l-1 -16q-16 1 -34 1.5t-37 0.5q-17 0 -37 -0.5t-36 -1.5l-2 16q23 5 33 8.5t11 11.5l2 27.5t2 103.5t-2 103l-2 27q-1 8 -9.5 11.5t-30.5 7.5l1 16q16 -1 34.5 -1h35.5 h82q50 0 74 -23t24 -52q0 -26 -17 -50.5t-49 -38.5q22 -37 41.5 -72t41.5 -70q11 -5 39 -9l-1 -16q-15 0 -35 -0.5t-35 -1.5l-15 -1l-83 160q-10 -1 -20 -1h-22q0 -50 1.5 -76t3 -35zM319 496q36 21 36 73q0 55 -74 55q-13 0 -17 -1.5t-6 -7.5l-3 -25.5t-3 -98.5 q15 0 35.5 0.5t31.5 4.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "macron",
    unicode: "\xAF",
    d: "M160 618l-39 -46q-34 2 -68.5 3t-69.5 1q-34 0 -68 -1t-69 -3l-8 16l39 46q38 -2 75 -3.5t74 -1.5q32 0 63.5 1t62.5 3z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "degree",
    unicode: "\xB0",
    horizAdvX: 281,
    d: "M10 554q0 36 17.5 66t47 47.5t65.5 17.5t65.5 -17.5t47.5 -47.5t18 -66t-18 -65.5t-47.5 -47t-65.5 -17.5t-65.5 17.5t-47 47t-17.5 65.5zM52 554q0 -37 25.5 -62.5t62.5 -25.5t63.5 25.5t26.5 62.5t-26.5 63.5t-63.5 26.5t-62.5 -26.5t-25.5 -63.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plusminus",
    unicode: "\xB1",
    horizAdvX: 523,
    d: "M231 541h61v-207h207v-61h-207v-207h-61v207h-207v61h207v207zM24 -60v61h475v-61h-475z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00B2",
    unicode: "\xB2",
    horizAdvX: 320,
    d: "M286 562q0 -37 -18.5 -72.5t-46 -67t-55.5 -56t-48 -39.5t-23 -17l2 -3q61 0 95.5 4t52.5 18t27 45l30 -7q-3 -11 -6 -30.5t-4.5 -38.5t-2.5 -31h-264l-7 30l19.5 16t47.5 42.5t56.5 60t48 69.5t19.5 69q0 38 -21.5 53t-49.5 15q-25 0 -49.5 -8t-36.5 -15l-15 24 q23 19 53.5 33.5t72.5 14.5q32 0 60 -12t45.5 -36t17.5 -61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00B3",
    unicode: "\xB3",
    horizAdvX: 320,
    d: "M266 596q0 -31 -22.5 -62.5t-66.5 -49.5v-4q52 -7 80 -38.5t28 -70.5q0 -31 -20 -61t-62.5 -49.5t-108.5 -19.5q-29 0 -64 6l2 37q21 -5 59 -5q41 0 68 14.5t40 36.5t13 45q0 32 -23 56.5t-68 24.5q-10 0 -20.5 -1t-22.5 -5l2 36q64 11 90 38.5t26 52.5q0 26 -15 36.5 t-38 10.5q-21 0 -42 -7.5t-38 -17.5l-14 25q26 21 56 34t67 13q48 0 71 -22t23 -53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acute",
    unicode: "\xB4",
    d: "M147 680l-173 -162l-30 5l134 199q25 0 46 -12.5t23 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00B5",
    unicode: "\xB5",
    horizAdvX: 550,
    d: "M217 -9q-28 0 -51.5 10.5t-31.5 35.5h-4v-58q0 -40 6 -75.5t21.5 -57.5t44.5 -22q14 0 14 -13q0 -16 -8 -32.5t-20 -27t-23 -10.5q-15 0 -29 11t-25.5 44.5t-18.5 101t-7 180.5q0 77 -1 133.5t-2.5 100.5t-3.5 84l-59 19l-2 26q27 0 64.5 5.5t62.5 12.5l19 -9l-0.5 -27.5 t-1 -73.5t-1 -101t-0.5 -110q0 -52 22 -66t58 -14q37 0 76 12t60 25q2 20 3 48t1 86q0 73 -2 108.5t-4 47l-2 11.5l-63 19l-2 26q18 0 42.5 2.5t48.5 7t41 8.5l19 -9l-1.5 -59t-1.5 -189q0 -63 1.5 -86.5l1.5 -23.5q1 -27 11 -37.5t24 -10.5q17 0 38 12l3 -30 q-18 -16 -40 -26t-43 -10q-25 0 -45 16t-25 50q-16 -16 -44 -31t-59.5 -24.5t-60.5 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "paragraph",
    unicode: "\xB6",
    horizAdvX: 524,
    d: "M186 -229q-14 11 -20 26t-6 31q0 14 6.5 35t13.5 31q27 -10 54 -10q56 0 92.5 56.5t36.5 184.5q0 19 -1 38.5t-4 40.5q-64 -32 -125 -32q-50 0 -92 20.5t-66.5 60.5t-24.5 97q0 81 54 135.5t146.5 81.5t209.5 27l7 -37q-38 0 -55.5 -21.5t-17.5 -64.5q0 -31 5 -77t12 -96 t12 -96.5t5 -80.5q0 -93 -23.5 -159.5t-61 -108.5t-79.5 -62t-78 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "periodcentered",
    unicode: "\xB7",
    horizAdvX: 165,
    d: "M82 209q-22 0 -37 15t-15 40q0 23 15 37.5t37 14.5t37.5 -14.5t15.5 -37.5q0 -25 -15.5 -40t-37.5 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cedilla",
    unicode: "\xB8",
    horizAdvX: 443,
    d: "M221 11h26q-9 -14 -11 -21.5t-2 -13.5q0 -12 12 -23t27 -22t27 -24.5t12 -31.5q0 -34 -39 -69t-119 -65q-16 13 -16 33q0 13 6.5 25.5t16.5 20.5q46 2 71.5 11.5t25.5 23.5q0 12 -10 21.5t-23.5 19t-23.5 21.5t-10 30q0 12 7 28t23 36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00B9",
    unicode: "\xB9",
    horizAdvX: 320,
    d: "M194 671l14 -6l-1 -48t-1 -145q0 -61 1 -95.5t2 -48l1 -13.5q2 -10 14 -14.5t37 -9.5l-2 -26q-19 1 -40.5 1.5t-44.5 0.5q-28 0 -56.5 -0.5t-53.5 -1.5l-2 26q26 4 46.5 9t21.5 15l1 13.5t2 48t1 95.5q0 62 -1 93t-2 41.5l-1 10.5l-69 13l-2 29q47 0 81.5 4t53.5 8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordmasculine",
    unicode: "\xBA",
    horizAdvX: 331,
    d: "M308 519q0 -40 -15 -76.5t-48.5 -59.5t-88.5 -23q-71 0 -103 37.5t-32 98.5q0 40 15 76.5t48.5 60t88.5 23.5q71 0 103 -38t32 -99zM245 496q0 30 -6 59t-23 48.5t-50 19.5q-26 0 -42.5 -12.5t-25 -31t-11.5 -37.5t-3 -31q0 -28 7 -55t24.5 -44.5t47.5 -17.5 q32 0 49.5 18t25 42.5t7.5 41.5zM51 317q24 -2 39 -3t30.5 -1h38.5h46t38 1t45 3l4 -12l-25 -39q-23 2 -38.5 2.5t-30.5 0.5h-39h-45.5t-38 -1t-45.5 -3l-4 13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotright",
    unicode: "\xBB",
    horizAdvX: 517,
    d: "M100 372l20 17l157 -151q4 -8 4 -15t-4 -15l-157 -151l-20 17l104 149zM246 372l20 17l157 -151q4 -8 4 -15t-4 -15l-157 -151l-20 17l104 149z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onequarter",
    unicode: "\xBC",
    horizAdvX: 750,
    d: "M146 -1l412 680h48l-412 -680h-48zM194 671l14 -6l-1 -48t-1 -145q0 -61 1 -95.5t2 -48l1 -13.5q2 -10 14 -14.5t37 -9.5l-2 -26q-19 1 -40.5 1.5t-44.5 0.5q-28 0 -56.5 -0.5t-53.5 -1.5l-2 26q26 4 46.5 9t21.5 15l1 13.5t2 48t1 95.5q0 62 -1 93t-2 41.5l-1 10.5 l-69 13l-2 29q47 0 81.5 4t53.5 8zM642 270v-125h46l4 -11l-23 -34l-26 2q1 -36 2 -44.5l1 -8.5q2 -10 14 -15t37 -10l-2 -26q-40 3 -89 3q-25 0 -53 -0.5t-48 -2.5l-2 26q27 5 46.5 10t20.5 15l1 8.5t2 45.5h-172l-10 31l170 295l70 -6l-177 -279h119v112l4 3.5t18.5 7 t46.5 3.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onehalf",
    unicode: "\xBD",
    horizAdvX: 750,
    d: "M137 -1l412 680h48l-412 -680h-48zM194 671l14 -6l-1 -48t-1 -145q0 -61 1 -95.5t2 -48l1 -13.5q2 -10 14 -14.5t37 -9.5l-2 -26q-19 1 -40.5 1.5t-44.5 0.5q-28 0 -56.5 -0.5t-53.5 -1.5l-2 26q26 4 46.5 9t21.5 15l1 13.5t2 48t1 95.5q0 62 -1 93t-2 41.5l-1 10.5 l-69 13l-2 29q47 0 81.5 4t53.5 8zM687 295q0 -37 -18.5 -72.5t-46 -67t-55.5 -56t-48 -39.5t-23 -17l2 -3q61 0 95.5 4t52.5 18t27 45l30 -7q-3 -11 -6 -30.5t-4.5 -38.5t-2.5 -31h-264l-7 30l19.5 16t47.5 42.5t56.5 60t48 69.5t19.5 69q0 38 -21.5 53t-49.5 15 q-25 0 -49.5 -8t-36.5 -15l-15 24q23 19 53.5 33.5t72.5 14.5q32 0 60 -12t45.5 -36t17.5 -61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threequarters",
    unicode: "\xBE",
    horizAdvX: 750,
    d: "M167 -1l412 680h48l-412 -680h-48zM279 596q0 -31 -22.5 -62.5t-66.5 -49.5v-4q52 -7 80 -38.5t28 -70.5q0 -31 -20 -61t-62.5 -49.5t-108.5 -19.5q-29 0 -64 6l2 37q21 -5 59 -5q41 0 68 14.5t40 36.5t13 45q0 32 -23 56.5t-68 24.5q-10 0 -20.5 -1t-22.5 -5l2 36 q64 11 90 38.5t26 52.5q0 26 -15 36.5t-38 10.5q-21 0 -42 -7.5t-38 -17.5l-14 25q26 21 56 34t67 13q48 0 71 -22t23 -53zM661 270v-125h46l4 -11l-23 -34l-26 2q1 -36 2 -44.5l1 -8.5q2 -10 14 -15t37 -10l-2 -26q-40 3 -89 3q-25 0 -53 -0.5t-48 -2.5l-2 26q27 5 46.5 10 t20.5 15l1 8.5t2 45.5h-172l-10 31l170 295l70 -6l-177 -279h119v112l4 3.5t18.5 7t46.5 3.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "questiondown",
    unicode: "\xBF",
    horizAdvX: 343,
    d: "M195 461q22 0 37.5 -15.5t15.5 -39.5q0 -22 -15.5 -37.5t-37.5 -15.5t-37.5 15.5t-15.5 37.5q0 24 15.5 39.5t37.5 15.5zM275 -132q7 -8 12.5 -27t5.5 -31q0 -14 -4.5 -27.5t-17.5 -23.5q-122 54 -171.5 111t-49.5 112q0 30 14 52t35 40.5t42 37.5t35 42t14 55 q0 17 -2.5 35t-12.5 40l38 9q31 -46 42 -80t11 -60q0 -25 -17 -45.5t-42 -39t-50.5 -36.5t-42.5 -37t-17 -41q0 -35 45 -59.5t133 -26.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Agrave",
    unicode: "\xC0",
    horizAdvX: 694,
    d: "M3 -3l-3 29q47 9 67 19.5t26 29.5l199 609l84 10l233 -625q7 -17 23.5 -26t61.5 -17l-3 -29q-33 2 -65 2.5t-68 0.5q-79 0 -141 -3l-3 29q52 10 70 18t18 20l-55 178h-226l-54 -178q0 -12 19 -20t67 -18l-3 -29q-33 2 -65 2.5t-68 0.5q-31 0 -53 -0.5t-61 -2.5zM235 288 h196l-101 302h-4zM362 747l-173 162q2 17 23 29.5t46 12.5l134 -199z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aacute",
    unicode: "\xC1",
    horizAdvX: 694,
    d: "M3 -3l-3 29q47 9 67 19.5t26 29.5l199 609l84 10l233 -625q7 -17 23.5 -26t61.5 -17l-3 -29q-33 2 -65 2.5t-68 0.5q-79 0 -141 -3l-3 29q52 10 70 18t18 20l-55 178h-226l-54 -178q0 -12 19 -20t67 -18l-3 -29q-33 2 -65 2.5t-68 0.5q-31 0 -53 -0.5t-61 -2.5zM235 288 h196l-101 302h-4zM478 909l-173 -162l-30 5l134 199q25 0 46 -12.5t23 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Acircumflex",
    unicode: "\xC2",
    horizAdvX: 694,
    d: "M3 -3l-3 29q47 9 67 19.5t26 29.5l199 609l84 10l233 -625q7 -17 23.5 -26t61.5 -17l-3 -29q-33 2 -65 2.5t-68 0.5q-79 0 -141 -3l-3 29q52 10 70 18t18 20l-55 178h-226l-54 -178q0 -12 19 -20t67 -18l-3 -29q-33 2 -65 2.5t-68 0.5q-31 0 -53 -0.5t-61 -2.5zM235 288 h196l-101 302h-4zM329 946h37l94 -194l-30 -5l-83 104l-82 -104l-30 5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Atilde",
    unicode: "\xC3",
    horizAdvX: 694,
    d: "M3 -3l-3 29q47 9 67 19.5t26 29.5l199 609l84 10l233 -625q7 -17 23.5 -26t61.5 -17l-3 -29q-33 2 -65 2.5t-68 0.5q-79 0 -141 -3l-3 29q52 10 70 18t18 20l-55 178h-226l-54 -178q0 -12 19 -20t67 -18l-3 -29q-33 2 -65 2.5t-68 0.5q-31 0 -53 -0.5t-61 -2.5zM235 288 h196l-101 302h-4zM485 893l26 -8q-15 -50 -34 -72.5t-40.5 -27t-44.5 2.5t-47 17t-47.5 15.5t-46 -1t-42.5 -34.5l-26 8q15 50 34 72.5t40.5 27t44.5 -2.5t47 -17t47.5 -15.5t46 1t42.5 34.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Adieresis",
    unicode: "\xC4",
    horizAdvX: 694,
    d: "M3 -3l-3 29q47 9 67 19.5t26 29.5l199 609l84 10l233 -625q7 -17 23.5 -26t61.5 -17l-3 -29q-33 2 -65 2.5t-68 0.5q-79 0 -141 -3l-3 29q52 10 70 18t18 20l-55 178h-226l-54 -178q0 -12 19 -20t67 -18l-3 -29q-33 2 -65 2.5t-68 0.5q-31 0 -53 -0.5t-61 -2.5zM235 288 h196l-101 302h-4zM437 792q-22 0 -37 15.5t-15 38.5q0 22 15 37t37 15t37 -15t15 -37q0 -23 -15 -38.5t-37 -15.5zM257 792q-22 0 -37 15.5t-15 38.5q0 22 15 37t37 15t37 -15t15 -37q0 -23 -15 -38.5t-37 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aring",
    unicode: "\xC5",
    horizAdvX: 694,
    d: "M3 -3l-3 29q47 9 67 19.5t26 29.5l199 609l84 10l233 -625q7 -17 23.5 -26t61.5 -17l-3 -29q-33 2 -65 2.5t-68 0.5q-79 0 -141 -3l-3 29q52 10 70 18t18 20l-55 178h-226l-54 -178q0 -12 19 -20t67 -18l-3 -29q-33 2 -65 2.5t-68 0.5q-31 0 -53 -0.5t-61 -2.5zM235 288 h196l-101 302h-4zM242 848q0 44 31 74.5t74 30.5q44 0 74 -30.5t30 -74.5q0 -43 -30 -73.5t-74 -30.5q-43 0 -74 30.5t-31 73.5zM344 923q-20 0 -35 -14.5t-15 -55.5q0 -30 12 -54.5t40 -24.5q20 0 34.5 15t14.5 55q0 31 -11 55t-40 24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "AE",
    unicode: "\xC6",
    horizAdvX: 967,
    d: "M475 69l2 22.5t4.5 78.5t2.5 157h-207q-29 -67 -55 -124.5t-42.5 -94.5t-16.5 -45q5 -13 27 -21t64 -16l-3 -29q-31 2 -63 2.5t-70 0.5q-37 0 -60 -0.5t-55 -2.5l-3 29q45 9 63.5 19.5t26.5 29.5l281 610h217q86 0 167 2t135 4v-11q0 -23 1.5 -51.5t4.5 -55t6 -44.5 l-27 -12q-14 47 -30.5 73t-41.5 37.5t-65 14t-101 2.5q-22 0 -36 -4t-16 -19l-2.5 -24t-5 -79.5t-3.5 -150.5q32 0 64 1t58 2.5t38 4.5q19 5 26 21.5t17 66.5l35 -4q-4 -27 -6 -55t-2 -56t2 -56t6 -56l-35 -5q-10 50 -17 67t-26 21q-12 3 -38 4.5t-58 2.5t-64 1 q0 -103 3 -159t5.5 -78l2.5 -22q5 -18 37 -25t64 -7q52 0 94 7t74 35.5t52 92.5l27 -12q-6 -18 -11 -49t-8.5 -61.5t-4.5 -48.5h-400q-37 0 -62.5 -0.5t-57.5 -2.5l-3 29q45 9 66 16.5t23 26.5zM420 646l-125 -279h189q0 97 -1.5 151t-2.5 76l-1 22q-2 19 -16 24.5t-43 5.5z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccedilla",
    unicode: "\xC7",
    horizAdvX: 700,
    d: "M404 -12q-112 0 -191.5 41.5t-122 119t-42.5 185.5q0 106 45 187t125.5 127t184.5 46q62 0 102.5 -7.5t71.5 -7.5q27 0 52 6q0 -36 3.5 -80.5t8.5 -75.5l-27 -12q-20 64 -74.5 97.5t-137.5 33.5q-75 0 -131 -37t-87 -103.5t-31 -156.5q0 -94 32 -164.5t89 -110t133 -39.5 q90 0 151 37.5t83 105.5l27 -12q-9 -32 -15 -68t-8 -66q-126 -46 -241 -46zM344 11h26q-9 -14 -11 -21.5t-2 -13.5q0 -12 12 -23t27 -22t27 -24.5t12 -31.5q0 -34 -39 -69t-119 -65q-16 13 -16 33q0 13 6.5 25.5t16.5 20.5q46 2 71.5 11.5t25.5 23.5q0 12 -10 21.5t-23.5 19 t-23.5 21.5t-10 30q0 12 7 28t23 36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Egrave",
    unicode: "\xC8",
    horizAdvX: 608,
    d: "M453 236l-35 -5q-10 50 -17 67t-26 21q-12 3 -38 4.5t-58 2.5t-64 1q0 -103 3 -159t5.5 -78l2.5 -22q5 -18 37 -25t64 -7q52 0 94 7t74 35.5t52 92.5l27 -12q-6 -18 -11 -49t-8.5 -61.5t-4.5 -48.5h-400q-37 0 -62.5 -0.5t-57.5 -2.5l-3 29q45 9 66 16.5t23 26.5l2 23.5 t4.5 82.5t2.5 167t-2 167.5t-4 83l-2 23.5q-2 19 -19.5 26.5t-62.5 16.5l3 29q32 -1 54 -2t59 -1h137.5t137 1.5t105.5 4.5v-15q0 -21 1.5 -49t4.5 -54.5t6 -43.5l-27 -12q-13 42 -27.5 67.5t-36 38t-54 16.5t-80.5 4q-36 0 -62.5 -3t-29.5 -19l-2.5 -24t-5 -79.5 t-3.5 -150.5q32 0 64 1t58 2.5t38 4.5q19 5 26 21.5t17 66.5l35 -4q-4 -27 -6 -55t-2 -56t2 -56t6 -56zM319 747l-173 162q2 17 23 29.5t46 12.5l134 -199z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eacute",
    unicode: "\xC9",
    horizAdvX: 608,
    d: "M453 236l-35 -5q-10 50 -17 67t-26 21q-12 3 -38 4.5t-58 2.5t-64 1q0 -103 3 -159t5.5 -78l2.5 -22q5 -18 37 -25t64 -7q52 0 94 7t74 35.5t52 92.5l27 -12q-6 -18 -11 -49t-8.5 -61.5t-4.5 -48.5h-400q-37 0 -62.5 -0.5t-57.5 -2.5l-3 29q45 9 66 16.5t23 26.5l2 23.5 t4.5 82.5t2.5 167t-2 167.5t-4 83l-2 23.5q-2 19 -19.5 26.5t-62.5 16.5l3 29q32 -1 54 -2t59 -1h137.5t137 1.5t105.5 4.5v-15q0 -21 1.5 -49t4.5 -54.5t6 -43.5l-27 -12q-13 42 -27.5 67.5t-36 38t-54 16.5t-80.5 4q-36 0 -62.5 -3t-29.5 -19l-2.5 -24t-5 -79.5 t-3.5 -150.5q32 0 64 1t58 2.5t38 4.5q19 5 26 21.5t17 66.5l35 -4q-4 -27 -6 -55t-2 -56t2 -56t6 -56zM435 909l-173 -162l-30 5l134 199q25 0 46 -12.5t23 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecircumflex",
    unicode: "\xCA",
    horizAdvX: 608,
    d: "M453 236l-35 -5q-10 50 -17 67t-26 21q-12 3 -38 4.5t-58 2.5t-64 1q0 -103 3 -159t5.5 -78l2.5 -22q5 -18 37 -25t64 -7q52 0 94 7t74 35.5t52 92.5l27 -12q-6 -18 -11 -49t-8.5 -61.5t-4.5 -48.5h-400q-37 0 -62.5 -0.5t-57.5 -2.5l-3 29q45 9 66 16.5t23 26.5l2 23.5 t4.5 82.5t2.5 167t-2 167.5t-4 83l-2 23.5q-2 19 -19.5 26.5t-62.5 16.5l3 29q32 -1 54 -2t59 -1h137.5t137 1.5t105.5 4.5v-15q0 -21 1.5 -49t4.5 -54.5t6 -43.5l-27 -12q-13 42 -27.5 67.5t-36 38t-54 16.5t-80.5 4q-36 0 -62.5 -3t-29.5 -19l-2.5 -24t-5 -79.5 t-3.5 -150.5q32 0 64 1t58 2.5t38 4.5q19 5 26 21.5t17 66.5l35 -4q-4 -27 -6 -55t-2 -56t2 -56t6 -56zM286 946h37l94 -194l-30 -5l-83 104l-82 -104l-30 5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edieresis",
    unicode: "\xCB",
    horizAdvX: 608,
    d: "M453 236l-35 -5q-10 50 -17 67t-26 21q-12 3 -38 4.5t-58 2.5t-64 1q0 -103 3 -159t5.5 -78l2.5 -22q5 -18 37 -25t64 -7q52 0 94 7t74 35.5t52 92.5l27 -12q-6 -18 -11 -49t-8.5 -61.5t-4.5 -48.5h-400q-37 0 -62.5 -0.5t-57.5 -2.5l-3 29q45 9 66 16.5t23 26.5l2 23.5 t4.5 82.5t2.5 167t-2 167.5t-4 83l-2 23.5q-2 19 -19.5 26.5t-62.5 16.5l3 29q32 -1 54 -2t59 -1h137.5t137 1.5t105.5 4.5v-15q0 -21 1.5 -49t4.5 -54.5t6 -43.5l-27 -12q-13 42 -27.5 67.5t-36 38t-54 16.5t-80.5 4q-36 0 -62.5 -3t-29.5 -19l-2.5 -24t-5 -79.5 t-3.5 -150.5q32 0 64 1t58 2.5t38 4.5q19 5 26 21.5t17 66.5l35 -4q-4 -27 -6 -55t-2 -56t2 -56t6 -56zM394 792q-22 0 -37 15.5t-15 38.5q0 22 15 37t37 15t37 -15t15 -37q0 -23 -15 -38.5t-37 -15.5zM214 792q-22 0 -37 15.5t-15 38.5q0 22 15 37t37 15t37 -15t15 -37 q0 -23 -15 -38.5t-37 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Igrave",
    unicode: "\xCC",
    horizAdvX: 342,
    d: "M216 342q0 -108 2 -167t4 -82.5l2 -23.5q2 -19 21 -26.5t64 -16.5l-3 -29q-31 2 -63 2.5t-70 0.5q-78 0 -141 -3l-3 29q45 9 66 16.5t23 26.5l2 23.5t4 83t2 166.5q0 108 -2 167.5t-4 83l-2 23.5q-2 19 -19.5 26.5t-62.5 16.5l3 29q32 -1 64.5 -2t69.5 -1q38 0 68.5 1 t61.5 2l3 -29q-45 -9 -62.5 -16.5t-19.5 -26.5l-2 -23.5t-4 -83t-2 -167.5zM186 747l-173 162q2 17 23 29.5t46 12.5l134 -199z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iacute",
    unicode: "\xCD",
    horizAdvX: 342,
    d: "M216 342q0 -108 2 -167t4 -82.5l2 -23.5q2 -19 21 -26.5t64 -16.5l-3 -29q-31 2 -63 2.5t-70 0.5q-78 0 -141 -3l-3 29q45 9 66 16.5t23 26.5l2 23.5t4 83t2 166.5q0 108 -2 167.5t-4 83l-2 23.5q-2 19 -19.5 26.5t-62.5 16.5l3 29q32 -1 64.5 -2t69.5 -1q38 0 68.5 1 t61.5 2l3 -29q-45 -9 -62.5 -16.5t-19.5 -26.5l-2 -23.5t-4 -83t-2 -167.5zM302 909l-173 -162l-30 5l134 199q25 0 46 -12.5t23 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Icircumflex",
    unicode: "\xCE",
    horizAdvX: 342,
    d: "M216 342q0 -108 2 -167t4 -82.5l2 -23.5q2 -19 21 -26.5t64 -16.5l-3 -29q-31 2 -63 2.5t-70 0.5q-78 0 -141 -3l-3 29q45 9 66 16.5t23 26.5l2 23.5t4 83t2 166.5q0 108 -2 167.5t-4 83l-2 23.5q-2 19 -19.5 26.5t-62.5 16.5l3 29q32 -1 64.5 -2t69.5 -1q38 0 68.5 1 t61.5 2l3 -29q-45 -9 -62.5 -16.5t-19.5 -26.5l-2 -23.5t-4 -83t-2 -167.5zM153 946h37l94 -194l-30 -5l-83 104l-82 -104l-30 5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idieresis",
    unicode: "\xCF",
    horizAdvX: 342,
    d: "M216 342q0 -108 2 -167t4 -82.5l2 -23.5q2 -19 21 -26.5t64 -16.5l-3 -29q-31 2 -63 2.5t-70 0.5q-78 0 -141 -3l-3 29q45 9 66 16.5t23 26.5l2 23.5t4 83t2 166.5q0 108 -2 167.5t-4 83l-2 23.5q-2 19 -19.5 26.5t-62.5 16.5l3 29q32 -1 64.5 -2t69.5 -1q38 0 68.5 1 t61.5 2l3 -29q-45 -9 -62.5 -16.5t-19.5 -26.5l-2 -23.5t-4 -83t-2 -167.5zM261 792q-22 0 -37 15.5t-15 38.5q0 22 15 37t37 15t37 -15t15 -37q0 -23 -15 -38.5t-37 -15.5zM81 792q-22 0 -37 15.5t-15 38.5q0 22 15 37t37 15t37 -15t15 -37q0 -23 -15 -38.5t-37 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eth",
    unicode: "\xD0",
    horizAdvX: 769,
    d: "M173 685h178q66 0 131.5 -17.5t119.5 -55t86 -98.5t32 -149q0 -102 -42 -185t-127.5 -131.5t-216.5 -48.5h-161q-78 0 -141 -3l-3 29q45 9 66 16.5t23 26.5l2 21.5t4 75t2 150.5h-88v53h88q0 97 -2 150.5t-4 75l-2 21.5q-2 19 -19.5 26.5t-62.5 16.5l3 29q32 -1 64.5 -2 t69.5 -1zM227 60q27 -6 51 -9t52 -3q77 0 129 23t83 60t47 78.5t21 79t5 61.5q0 50 -12.5 101.5t-47 95t-98.5 70t-168 26.5q-37 0 -48 -4t-14 -17l-2.5 -23t-5.5 -78t-3 -152h204v-54l-204 1q1 -97 3.5 -153t5 -79.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ntilde",
    unicode: "\xD1",
    horizAdvX: 785,
    d: "M603 132h5q2 42 2 96v114q0 108 -2.5 167.5t-4.5 83l-2 23.5q-2 19 -25.5 26.5t-68.5 16.5l3 29q32 -1 68.5 -2t73.5 -1q25 0 41 0.5t30.5 1t35.5 1.5l3 -29q-45 -9 -62.5 -16.5t-19.5 -26.5l-2.5 -23.5t-5 -83t-2.5 -167.5q0 -161 5.5 -251.5l5.5 -90.5l-80 -9l-406 546 h-5q-1 -33 -2.5 -82t-1.5 -113q0 -108 3 -167t5.5 -82.5l2.5 -23.5q2 -19 25.5 -26.5t68.5 -16.5l-3 -29q-31 2 -67.5 2.5t-74.5 0.5q-37 0 -63.5 -0.5t-58.5 -2.5l-3 29q45 8 70 16t27 27l2 23.5t4 82.5t2 167t-2 167.5t-4 83l-2 23.5q-2 19 -19.5 26.5t-62.5 16.5l3 29 q32 -1 72 -2t77 -1zM551 893l26 -8q-15 -50 -34 -72.5t-40.5 -27t-44.5 2.5t-47 17t-47.5 15.5t-46 -1t-42.5 -34.5l-26 8q15 50 34 72.5t40.5 27t44.5 -2.5t47 -17t47.5 -15.5t46 1t42.5 34.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ograve",
    unicode: "\xD2",
    horizAdvX: 786,
    d: "M737 369q0 -72 -20.5 -141t-64 -124t-113 -87.5t-167.5 -32.5q-113 0 -184.5 42t-105 116.5t-33.5 171.5q0 72 20.5 140.5t64 123.5t113 87.5t167.5 32.5q114 0 185 -41.5t104.5 -115.5t33.5 -172zM632 312q0 65 -10 125t-35.5 108.5t-71 76.5t-117.5 28 q-61 0 -103.5 -22.5t-70 -58t-43 -76.5t-21.5 -79t-6 -64q0 -62 11.5 -119t38.5 -102t72 -71t112 -26q55 0 96.5 19.5t69.5 51.5t45.5 69.5t25 74t7.5 65.5zM408 747l-173 162q2 17 23 29.5t46 12.5l134 -199z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oacute",
    unicode: "\xD3",
    horizAdvX: 786,
    d: "M737 369q0 -72 -20.5 -141t-64 -124t-113 -87.5t-167.5 -32.5q-113 0 -184.5 42t-105 116.5t-33.5 171.5q0 72 20.5 140.5t64 123.5t113 87.5t167.5 32.5q114 0 185 -41.5t104.5 -115.5t33.5 -172zM632 312q0 65 -10 125t-35.5 108.5t-71 76.5t-117.5 28 q-61 0 -103.5 -22.5t-70 -58t-43 -76.5t-21.5 -79t-6 -64q0 -62 11.5 -119t38.5 -102t72 -71t112 -26q55 0 96.5 19.5t69.5 51.5t45.5 69.5t25 74t7.5 65.5zM524 909l-173 -162l-30 5l134 199q25 0 46 -12.5t23 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ocircumflex",
    unicode: "\xD4",
    horizAdvX: 786,
    d: "M737 369q0 -72 -20.5 -141t-64 -124t-113 -87.5t-167.5 -32.5q-113 0 -184.5 42t-105 116.5t-33.5 171.5q0 72 20.5 140.5t64 123.5t113 87.5t167.5 32.5q114 0 185 -41.5t104.5 -115.5t33.5 -172zM632 312q0 65 -10 125t-35.5 108.5t-71 76.5t-117.5 28 q-61 0 -103.5 -22.5t-70 -58t-43 -76.5t-21.5 -79t-6 -64q0 -62 11.5 -119t38.5 -102t72 -71t112 -26q55 0 96.5 19.5t69.5 51.5t45.5 69.5t25 74t7.5 65.5zM375 946h37l94 -194l-30 -5l-83 104l-82 -104l-30 5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Otilde",
    unicode: "\xD5",
    horizAdvX: 786,
    d: "M737 369q0 -72 -20.5 -141t-64 -124t-113 -87.5t-167.5 -32.5q-113 0 -184.5 42t-105 116.5t-33.5 171.5q0 72 20.5 140.5t64 123.5t113 87.5t167.5 32.5q114 0 185 -41.5t104.5 -115.5t33.5 -172zM632 312q0 65 -10 125t-35.5 108.5t-71 76.5t-117.5 28 q-61 0 -103.5 -22.5t-70 -58t-43 -76.5t-21.5 -79t-6 -64q0 -62 11.5 -119t38.5 -102t72 -71t112 -26q55 0 96.5 19.5t69.5 51.5t45.5 69.5t25 74t7.5 65.5zM531 893l26 -8q-15 -50 -34 -72.5t-40.5 -27t-44.5 2.5t-47 17t-47.5 15.5t-46 -1t-42.5 -34.5l-26 8 q15 50 34 72.5t40.5 27t44.5 -2.5t47 -17t47.5 -15.5t46 1t42.5 34.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odieresis",
    unicode: "\xD6",
    horizAdvX: 786,
    d: "M737 369q0 -72 -20.5 -141t-64 -124t-113 -87.5t-167.5 -32.5q-113 0 -184.5 42t-105 116.5t-33.5 171.5q0 72 20.5 140.5t64 123.5t113 87.5t167.5 32.5q114 0 185 -41.5t104.5 -115.5t33.5 -172zM632 312q0 65 -10 125t-35.5 108.5t-71 76.5t-117.5 28 q-61 0 -103.5 -22.5t-70 -58t-43 -76.5t-21.5 -79t-6 -64q0 -62 11.5 -119t38.5 -102t72 -71t112 -26q55 0 96.5 19.5t69.5 51.5t45.5 69.5t25 74t7.5 65.5zM483 792q-22 0 -37 15.5t-15 38.5q0 22 15 37t37 15t37 -15t15 -37q0 -23 -15 -38.5t-37 -15.5zM303 792 q-22 0 -37 15.5t-15 38.5q0 22 15 37t37 15t37 -15t15 -37q0 -23 -15 -38.5t-37 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "multiply",
    unicode: "\xD7",
    horizAdvX: 523,
    d: "M443 529l44 -43l-182 -182l181 -181l-43 -44l-182 181l-180 -180l-44 43l181 181l-181 181l43 44l181 -182z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oslash",
    unicode: "\xD8",
    horizAdvX: 786,
    d: "M737 369q0 -72 -20.5 -141t-64 -124t-113 -87.5t-167.5 -32.5q-113 0 -184.5 42t-105 116.5t-33.5 171.5q0 72 20.5 140.5t64 123.5t113 87.5t167.5 32.5q114 0 185 -41.5t104.5 -115.5t33.5 -172zM632 312q0 65 -10 125t-35.5 108.5t-71 76.5t-117.5 28 q-61 0 -103.5 -22.5t-70 -58t-43 -76.5t-21.5 -79t-6 -64q0 -62 11.5 -119t38.5 -102t72 -71t112 -26q55 0 96.5 19.5t69.5 51.5t45.5 69.5t25 74t7.5 65.5zM268 -80l185 841h65l-185 -841h-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ugrave",
    unicode: "\xD9",
    horizAdvX: 760,
    d: "M584 616q-2 19 -25.5 26.5t-68.5 16.5l3 29q32 -1 68.5 -2t73.5 -1q25 0 41 0.5t30.5 1t35.5 1.5l3 -29q-45 -9 -63 -16.5t-19 -26.5q-4 -92 -6 -184.5t-5 -184.5q-2 -71 -28.5 -130t-85.5 -94t-158 -35q-84 0 -143.5 20t-91.5 73.5t-34 154.5q-1 95 -3 190l-4 190 q0 19 -18.5 26.5t-63.5 16.5l3 29q32 -1 64.5 -2t69.5 -1q38 0 68.5 1t61.5 2l3 -29q-45 -9 -62.5 -16.5t-19.5 -26.5l-2.5 -26t-4.5 -89.5t-2 -178.5q0 -64 3.5 -115.5t20 -87.5t53 -55t102.5 -19q68 0 109.5 21t64 60t30.5 93t8 120q0 108 -2 168t-4 84.5zM417 747 l-173 162q2 17 23 29.5t46 12.5l134 -199z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uacute",
    unicode: "\xDA",
    horizAdvX: 760,
    d: "M584 616q-2 19 -25.5 26.5t-68.5 16.5l3 29q32 -1 68.5 -2t73.5 -1q25 0 41 0.5t30.5 1t35.5 1.5l3 -29q-45 -9 -63 -16.5t-19 -26.5q-4 -92 -6 -184.5t-5 -184.5q-2 -71 -28.5 -130t-85.5 -94t-158 -35q-84 0 -143.5 20t-91.5 73.5t-34 154.5q-1 95 -3 190l-4 190 q0 19 -18.5 26.5t-63.5 16.5l3 29q32 -1 64.5 -2t69.5 -1q38 0 68.5 1t61.5 2l3 -29q-45 -9 -62.5 -16.5t-19.5 -26.5l-2.5 -26t-4.5 -89.5t-2 -178.5q0 -64 3.5 -115.5t20 -87.5t53 -55t102.5 -19q68 0 109.5 21t64 60t30.5 93t8 120q0 108 -2 168t-4 84.5zM533 909 l-173 -162l-30 5l134 199q25 0 46 -12.5t23 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ucircumflex",
    unicode: "\xDB",
    horizAdvX: 760,
    d: "M584 616q-2 19 -25.5 26.5t-68.5 16.5l3 29q32 -1 68.5 -2t73.5 -1q25 0 41 0.5t30.5 1t35.5 1.5l3 -29q-45 -9 -63 -16.5t-19 -26.5q-4 -92 -6 -184.5t-5 -184.5q-2 -71 -28.5 -130t-85.5 -94t-158 -35q-84 0 -143.5 20t-91.5 73.5t-34 154.5q-1 95 -3 190l-4 190 q0 19 -18.5 26.5t-63.5 16.5l3 29q32 -1 64.5 -2t69.5 -1q38 0 68.5 1t61.5 2l3 -29q-45 -9 -62.5 -16.5t-19.5 -26.5l-2.5 -26t-4.5 -89.5t-2 -178.5q0 -64 3.5 -115.5t20 -87.5t53 -55t102.5 -19q68 0 109.5 21t64 60t30.5 93t8 120q0 108 -2 168t-4 84.5zM384 946h37 l94 -194l-30 -5l-83 104l-82 -104l-30 5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udieresis",
    unicode: "\xDC",
    horizAdvX: 760,
    d: "M584 616q-2 19 -25.5 26.5t-68.5 16.5l3 29q32 -1 68.5 -2t73.5 -1q25 0 41 0.5t30.5 1t35.5 1.5l3 -29q-45 -9 -63 -16.5t-19 -26.5q-4 -92 -6 -184.5t-5 -184.5q-2 -71 -28.5 -130t-85.5 -94t-158 -35q-84 0 -143.5 20t-91.5 73.5t-34 154.5q-1 95 -3 190l-4 190 q0 19 -18.5 26.5t-63.5 16.5l3 29q32 -1 64.5 -2t69.5 -1q38 0 68.5 1t61.5 2l3 -29q-45 -9 -62.5 -16.5t-19.5 -26.5l-2.5 -26t-4.5 -89.5t-2 -178.5q0 -64 3.5 -115.5t20 -87.5t53 -55t102.5 -19q68 0 109.5 21t64 60t30.5 93t8 120q0 108 -2 168t-4 84.5zM492 792 q-22 0 -37 15.5t-15 38.5q0 22 15 37t37 15t37 -15t15 -37q0 -23 -15 -38.5t-37 -15.5zM312 792q-22 0 -37 15.5t-15 38.5q0 22 15 37t37 15t37 -15t15 -37q0 -23 -15 -38.5t-37 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Yacute",
    unicode: "\xDD",
    horizAdvX: 641,
    d: "M336 331q45 83 73.5 136.5t44.5 84.5t23 45.5t8.5 19t1.5 6.5q0 12 -26 20t-66 16l3 29l64 -2t69 -1q38 0 60.5 1t53.5 2l3 -29q-45 -9 -62.5 -20t-27.5 -29l-193 -347q1 -77 2.5 -119t3.5 -58.5l2 -16.5q2 -19 21 -26.5t64 -16.5l-3 -29q-31 2 -63 2.5t-70 0.5 q-78 0 -141 -3l-3 29q45 9 66 16.5t23 26.5l1.5 17t3.5 59.5t2 116.5l-193 354q-9 17 -24.5 25.5t-60.5 17.5l3 29l64 -2t69 -1q78 0 141 3l3 -29q-40 -7 -64.5 -15t-24.5 -21q0 -2 0.5 -4t1.5 -4zM468 909l-173 -162l-30 5l134 199q25 0 46 -12.5t23 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Thorn",
    unicode: "\xDE",
    horizAdvX: 576,
    d: "M224 69q2 -19 21 -26.5t64 -16.5l-3 -29q-31 2 -63 2.5t-70 0.5q-78 0 -141 -3l-3 29q45 9 66 16.5t23 26.5l2 23.5t4 83t2 166.5q0 108 -2 167.5t-4 83l-2 23.5q-2 19 -19.5 26.5t-62.5 16.5l3 29q32 -1 64.5 -2t69.5 -1q38 0 68.5 1t61.5 2l3 -29q-45 -9 -62.5 -16.5 t-19.5 -26.5l-1 -8t-2 -28h104q78 0 128 -26t74 -67.5t24 -89.5q0 -53 -31 -104t-89.5 -84.5t-143.5 -33.5q-16 0 -33.5 1t-35.5 4q2 -61 4 -86zM216 220q29 -3 55 -3q83 0 133.5 39.5t50.5 127.5q0 85 -43.5 119.5t-124.5 34.5q-35 0 -46 -4.5t-15 -29.5l-1.5 -12t-3.5 -43 t-3.5 -86.5t-1.5 -142.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "germandbls",
    unicode: "\xDF",
    horizAdvX: 576,
    d: "M231 16l13 71q15 -13 39 -26t51.5 -21.5t51.5 -8.5q29 0 48 14.5t19 51.5q0 26 -20.5 46.5t-51 41.5t-61 44.5t-51 54.5t-20.5 73t18 68t44 44.5t52.5 35.5t44.5 41t18 62q0 34 -29 56t-72 22q-39 0 -72 -21t-53 -71t-20 -138q0 -129 2.5 -227.5t5 -157.5t2.5 -71 q-42 0 -89 -0.5t-78 -2.5l3 29q11 1 26.5 4t28 8t13.5 10l1.5 16t3 55.5t2.5 109.5t1 177q-33 -1 -51 -1h-18l-3 11l23 39l11.5 -1t36.5 -3q0 72 26.5 135.5t81.5 103.5t138 40q52 0 84.5 -12t49.5 -30t23 -36.5t6 -31.5q0 -42 -18.5 -67.5t-45.5 -43.5t-54.5 -35.5 t-46 -41.5t-18.5 -63q0 -30 21 -53t52.5 -43t62.5 -42t52 -49t21 -65q0 -30 -15.5 -59t-50 -48t-92.5 -19q-37 0 -77.5 7t-69.5 18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "agrave",
    unicode: "\xE0",
    horizAdvX: 457,
    d: "M437 52l10 -26q-38 -35 -83 -35q-25 0 -45 15.5t-25 49.5q-37 -28 -73.5 -46.5t-78.5 -18.5q-40 0 -71.5 25t-31.5 79q0 36 23 70.5t78.5 59t150.5 30.5v93q0 29 -21.5 43.5t-51.5 14.5q-44 0 -65 -21t-21 -52q0 -12 3 -27l-22 -10q-21 11 -38 30.5t-17 27.5q0 7 12.5 24 t37.5 36t61 32.5t83 13.5q31 0 56.5 -9t40.5 -32t15 -66q0 -10 0.5 -36t1.5 -60t1.5 -68.5t1.5 -60.5t1 -36q1 -27 11.5 -37.5t24.5 -10.5q6 0 14 2t17 6zM291 94v116q-88 -2 -128 -33t-40 -66q0 -30 18 -45t47 -15q22 0 48.5 10.5t54.5 32.5zM261 518l-173 162 q2 17 23 29.5t46 12.5l134 -199z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aacute",
    unicode: "\xE1",
    horizAdvX: 457,
    d: "M437 52l10 -26q-38 -35 -83 -35q-25 0 -45 15.5t-25 49.5q-37 -28 -73.5 -46.5t-78.5 -18.5q-40 0 -71.5 25t-31.5 79q0 36 23 70.5t78.5 59t150.5 30.5v93q0 29 -21.5 43.5t-51.5 14.5q-44 0 -65 -21t-21 -52q0 -12 3 -27l-22 -10q-21 11 -38 30.5t-17 27.5q0 7 12.5 24 t37.5 36t61 32.5t83 13.5q31 0 56.5 -9t40.5 -32t15 -66q0 -10 0.5 -36t1.5 -60t1.5 -68.5t1.5 -60.5t1 -36q1 -27 11.5 -37.5t24.5 -10.5q6 0 14 2t17 6zM291 94v116q-88 -2 -128 -33t-40 -66q0 -30 18 -45t47 -15q22 0 48.5 10.5t54.5 32.5zM375 680l-173 -162l-30 5 l134 199q25 0 46 -12.5t23 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acircumflex",
    unicode: "\xE2",
    horizAdvX: 457,
    d: "M437 52l10 -26q-38 -35 -83 -35q-25 0 -45 15.5t-25 49.5q-37 -28 -73.5 -46.5t-78.5 -18.5q-40 0 -71.5 25t-31.5 79q0 36 23 70.5t78.5 59t150.5 30.5v93q0 29 -21.5 43.5t-51.5 14.5q-44 0 -65 -21t-21 -52q0 -12 3 -27l-22 -10q-21 11 -38 30.5t-17 27.5q0 7 12.5 24 t37.5 36t61 32.5t83 13.5q31 0 56.5 -9t40.5 -32t15 -66q0 -10 0.5 -36t1.5 -60t1.5 -68.5t1.5 -60.5t1 -36q1 -27 11.5 -37.5t24.5 -10.5q6 0 14 2t17 6zM291 94v116q-88 -2 -128 -33t-40 -66q0 -30 18 -45t47 -15q22 0 48.5 10.5t54.5 32.5zM210 717h37l94 -194l-30 -5 l-83 104l-82 -104l-30 5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "atilde",
    unicode: "\xE3",
    horizAdvX: 457,
    d: "M437 52l10 -26q-38 -35 -83 -35q-25 0 -45 15.5t-25 49.5q-37 -28 -73.5 -46.5t-78.5 -18.5q-40 0 -71.5 25t-31.5 79q0 36 23 70.5t78.5 59t150.5 30.5v93q0 29 -21.5 43.5t-51.5 14.5q-44 0 -65 -21t-21 -52q0 -12 3 -27l-22 -10q-21 11 -38 30.5t-17 27.5q0 7 12.5 24 t37.5 36t61 32.5t83 13.5q31 0 56.5 -9t40.5 -32t15 -66q0 -10 0.5 -36t1.5 -60t1.5 -68.5t1.5 -60.5t1 -36q1 -27 11.5 -37.5t24.5 -10.5q6 0 14 2t17 6zM291 94v116q-88 -2 -128 -33t-40 -66q0 -30 18 -45t47 -15q22 0 48.5 10.5t54.5 32.5zM370 664l26 -8 q-15 -50 -34 -72.5t-40.5 -27t-44.5 2.5t-47 17t-47.5 15.5t-46 -1t-42.5 -34.5l-26 8q15 50 34 72.5t40.5 27t44.5 -2.5t47 -17t47.5 -15.5t46 1t42.5 34.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "adieresis",
    unicode: "\xE4",
    horizAdvX: 457,
    d: "M437 52l10 -26q-38 -35 -83 -35q-25 0 -45 15.5t-25 49.5q-37 -28 -73.5 -46.5t-78.5 -18.5q-40 0 -71.5 25t-31.5 79q0 36 23 70.5t78.5 59t150.5 30.5v93q0 29 -21.5 43.5t-51.5 14.5q-44 0 -65 -21t-21 -52q0 -12 3 -27l-22 -10q-21 11 -38 30.5t-17 27.5q0 7 12.5 24 t37.5 36t61 32.5t83 13.5q31 0 56.5 -9t40.5 -32t15 -66q0 -10 0.5 -36t1.5 -60t1.5 -68.5t1.5 -60.5t1 -36q1 -27 11.5 -37.5t24.5 -10.5q6 0 14 2t17 6zM291 94v116q-88 -2 -128 -33t-40 -66q0 -30 18 -45t47 -15q22 0 48.5 10.5t54.5 32.5zM319 563q-22 0 -37 15.5 t-15 38.5q0 22 15 37t37 15t37 -15t15 -37q0 -23 -15 -38.5t-37 -15.5zM139 563q-22 0 -37 15.5t-15 38.5q0 22 15 37t37 15t37 -15t15 -37q0 -23 -15 -38.5t-37 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aring",
    unicode: "\xE5",
    horizAdvX: 457,
    d: "M437 52l10 -26q-38 -35 -83 -35q-25 0 -45 15.5t-25 49.5q-37 -28 -73.5 -46.5t-78.5 -18.5q-40 0 -71.5 25t-31.5 79q0 36 23 70.5t78.5 59t150.5 30.5v93q0 29 -21.5 43.5t-51.5 14.5q-44 0 -65 -21t-21 -52q0 -12 3 -27l-22 -10q-21 11 -38 30.5t-17 27.5q0 7 12.5 24 t37.5 36t61 32.5t83 13.5q31 0 56.5 -9t40.5 -32t15 -66q0 -10 0.5 -36t1.5 -60t1.5 -68.5t1.5 -60.5t1 -36q1 -27 11.5 -37.5t24.5 -10.5q6 0 14 2t17 6zM291 94v116q-88 -2 -128 -33t-40 -66q0 -30 18 -45t47 -15q22 0 48.5 10.5t54.5 32.5zM124 619q0 44 31 74.5t74 30.5 q44 0 74 -30.5t30 -74.5q0 -43 -30 -73.5t-74 -30.5q-43 0 -74 30.5t-31 73.5zM226 694q-20 0 -35 -14.5t-15 -55.5q0 -30 12 -54.5t40 -24.5q20 0 34.5 15t14.5 55q0 31 -11 55t-40 24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ae",
    unicode: "\xE6",
    horizAdvX: 700,
    d: "M284 255v96q0 30 -21.5 43t-51.5 13q-44 0 -65 -20.5t-21 -52.5q0 -13 3 -28l-22 -10q-21 11 -38 30.5t-17 27.5q0 7 12.5 24t37.5 36t61 32.5t83 13.5q38 0 68.5 -9.5t40.5 -47.5q29 26 69 41.5t94 15.5q36 0 71 -18t58 -56.5t23 -100.5l-34 -41q-55 -6 -99 -10 t-84.5 -7t-85.5 -7q0 -44 12.5 -82.5t45 -61.5t92.5 -23q38 0 72.5 10t55.5 20l12 -30q-31 -26 -72 -44t-92 -18q-60 0 -102 19.5t-68 52.5q-49 -41 -92 -56.5t-88 -15.5q-40 0 -71.5 25t-31.5 79q0 36 22.5 70.5t76 59t146.5 30.5zM579 316q0 34 -13.5 54.5t-33 30.5 t-37.5 10q-49 0 -81 -39.5t-43 -109.5q62 7 108.5 12t96.5 13q3 15 3 29zM284 213q-86 -7 -123.5 -37t-37.5 -65q0 -30 18 -45t47 -15q22 0 54.5 10.5t60.5 28.5q-9 29 -14 58t-5 65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccedilla",
    unicode: "\xE7",
    horizAdvX: 443,
    d: "M409 90l12 -33q-34 -27 -77.5 -46.5t-99.5 -19.5q-70 0 -116.5 29.5t-69 80.5t-22.5 114q0 45 14.5 88.5t43 79t71 56.5t99.5 21q43 0 77 -14.5t54 -31t20 -22.5q0 -13 -6 -34.5t-18 -38.5h-24q-6 17 -20 37t-37 35t-57 15q-44 0 -73 -27.5t-42.5 -70t-13.5 -86.5 q0 -91 41 -131.5t105 -40.5q32 0 70 10.5t69 29.5zM221 11h26q-9 -14 -11 -21.5t-2 -13.5q0 -12 12 -23t27 -22t27 -24.5t12 -31.5q0 -34 -39 -69t-119 -65q-16 13 -16 33q0 13 6.5 25.5t16.5 20.5q46 2 71.5 11.5t25.5 23.5q0 12 -10 21.5t-23.5 19t-23.5 21.5t-10 30 q0 12 7 28t23 36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "egrave",
    unicode: "\xE8",
    horizAdvX: 459,
    d: "M403 83l12 -30q-31 -25 -72.5 -43.5t-91.5 -18.5q-74 0 -121.5 29.5t-70 78.5t-22.5 108q0 48 13.5 93t41.5 81t74 57.5t110 21.5q36 0 71 -17t58 -54.5t23 -99.5l-34 -41q-4 1 -13.5 1h-23.5q-25 0 -59 -0.5t-69 -1.5t-64 -2.5t-43 -2.5v-9q0 -94 39.5 -138t102.5 -44 q37 0 70 8t69 24zM338 320q0 34 -13.5 53.5t-33 28.5t-37.5 9q-49 0 -82 -38.5t-44 -89.5l207 8q3 15 3 29zM285 518l-173 162q2 17 23 29.5t46 12.5l134 -199z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eacute",
    unicode: "\xE9",
    horizAdvX: 459,
    d: "M403 83l12 -30q-31 -25 -72.5 -43.5t-91.5 -18.5q-74 0 -121.5 29.5t-70 78.5t-22.5 108q0 48 13.5 93t41.5 81t74 57.5t110 21.5q36 0 71 -17t58 -54.5t23 -99.5l-34 -41q-4 1 -13.5 1h-23.5q-25 0 -59 -0.5t-69 -1.5t-64 -2.5t-43 -2.5v-9q0 -94 39.5 -138t102.5 -44 q37 0 70 8t69 24zM338 320q0 34 -13.5 53.5t-33 28.5t-37.5 9q-49 0 -82 -38.5t-44 -89.5l207 8q3 15 3 29zM399 680l-173 -162l-30 5l134 199q25 0 46 -12.5t23 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecircumflex",
    unicode: "\xEA",
    horizAdvX: 459,
    d: "M403 83l12 -30q-31 -25 -72.5 -43.5t-91.5 -18.5q-74 0 -121.5 29.5t-70 78.5t-22.5 108q0 48 13.5 93t41.5 81t74 57.5t110 21.5q36 0 71 -17t58 -54.5t23 -99.5l-34 -41q-4 1 -13.5 1h-23.5q-25 0 -59 -0.5t-69 -1.5t-64 -2.5t-43 -2.5v-9q0 -94 39.5 -138t102.5 -44 q37 0 70 8t69 24zM338 320q0 34 -13.5 53.5t-33 28.5t-37.5 9q-49 0 -82 -38.5t-44 -89.5l207 8q3 15 3 29zM234 717h37l94 -194l-30 -5l-83 104l-82 -104l-30 5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edieresis",
    unicode: "\xEB",
    horizAdvX: 459,
    d: "M403 83l12 -30q-31 -25 -72.5 -43.5t-91.5 -18.5q-74 0 -121.5 29.5t-70 78.5t-22.5 108q0 48 13.5 93t41.5 81t74 57.5t110 21.5q36 0 71 -17t58 -54.5t23 -99.5l-34 -41q-4 1 -13.5 1h-23.5q-25 0 -59 -0.5t-69 -1.5t-64 -2.5t-43 -2.5v-9q0 -94 39.5 -138t102.5 -44 q37 0 70 8t69 24zM338 320q0 34 -13.5 53.5t-33 28.5t-37.5 9q-49 0 -82 -38.5t-44 -89.5l207 8q3 15 3 29zM343 563q-22 0 -37 15.5t-15 38.5q0 22 15 37t37 15t37 -15t15 -37q0 -23 -15 -38.5t-37 -15.5zM163 563q-22 0 -37 15.5t-15 38.5q0 22 15 37t37 15t37 -15t15 -37 q0 -23 -15 -38.5t-37 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "igrave",
    unicode: "\xEC",
    horizAdvX: 275,
    d: "M161 459l19 -9q0 -13 -0.5 -40t-0.5 -59.5t-0.5 -65t-0.5 -56.5q0 -73 2.5 -112t5 -54l2.5 -15q1 -5 14.5 -10t30 -8t26.5 -4l-3 -29q-24 2 -56.5 2.5t-58.5 0.5q-25 0 -60 -0.5t-59 -2.5l3 29q11 1 27 4t29 8t14 10l2 15t4 54t2 112t-2 108.5t-4 47l-2 11.5l-64 19 l-2 26q18 0 42.5 2.5t48.5 7t41 8.5zM170 518l-173 162q2 17 23 29.5t46 12.5l134 -199z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iacute",
    unicode: "\xED",
    horizAdvX: 275,
    d: "M161 459l19 -9q0 -13 -0.5 -40t-0.5 -59.5t-0.5 -65t-0.5 -56.5q0 -73 2.5 -112t5 -54l2.5 -15q1 -5 14.5 -10t30 -8t26.5 -4l-3 -29q-24 2 -56.5 2.5t-58.5 0.5q-25 0 -60 -0.5t-59 -2.5l3 29q11 1 27 4t29 8t14 10l2 15t4 54t2 112t-2 108.5t-4 47l-2 11.5l-64 19 l-2 26q18 0 42.5 2.5t48.5 7t41 8.5zM284 680l-173 -162l-30 5l134 199q25 0 46 -12.5t23 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "icircumflex",
    unicode: "\xEE",
    horizAdvX: 275,
    d: "M161 459l19 -9q0 -13 -0.5 -40t-0.5 -59.5t-0.5 -65t-0.5 -56.5q0 -73 2.5 -112t5 -54l2.5 -15q1 -5 14.5 -10t30 -8t26.5 -4l-3 -29q-24 2 -56.5 2.5t-58.5 0.5q-25 0 -60 -0.5t-59 -2.5l3 29q11 1 27 4t29 8t14 10l2 15t4 54t2 112t-2 108.5t-4 47l-2 11.5l-64 19 l-2 26q18 0 42.5 2.5t48.5 7t41 8.5zM119 717h37l94 -194l-30 -5l-83 104l-82 -104l-30 5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idieresis",
    unicode: "\xEF",
    horizAdvX: 275,
    d: "M161 459l19 -9q0 -13 -0.5 -40t-0.5 -59.5t-0.5 -65t-0.5 -56.5q0 -73 2.5 -112t5 -54l2.5 -15q1 -5 14.5 -10t30 -8t26.5 -4l-3 -29q-24 2 -56.5 2.5t-58.5 0.5q-25 0 -60 -0.5t-59 -2.5l3 29q11 1 27 4t29 8t14 10l2 15t4 54t2 112t-2 108.5t-4 47l-2 11.5l-64 19 l-2 26q18 0 42.5 2.5t48.5 7t41 8.5zM228 563q-22 0 -37 15.5t-15 38.5q0 22 15 37t37 15t37 -15t15 -37q0 -23 -15 -38.5t-37 -15.5zM48 563q-22 0 -37 15.5t-15 38.5q0 22 15 37t37 15t37 -15t15 -37q0 -23 -15 -38.5t-37 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eth",
    unicode: "\xF0",
    horizAdvX: 529,
    d: "M226 600l-123 -90v57l85 62q-47 35 -112 66l16 35q27 -11 61.5 -29.5t71.5 -44.5l103 75v-57l-63 -46q57 -43 108 -101t84 -129t33 -155q0 -48 -13.5 -93t-41.5 -81t-73.5 -57t-110.5 -21q-112 0 -162 59.5t-50 155.5q0 48 13.5 93t41.5 81t74 57.5t110 21.5 q18 0 34.5 -4t31.5 -12q-16 35 -43.5 75.5t-74.5 81.5zM402 206q0 37 -5.5 74.5t-20 69t-41 50.5t-68.5 19q-45 0 -72.5 -21t-42 -52.5t-20 -63t-5.5 -52.5q0 -47 12 -93t41.5 -76t81.5 -30q41 0 68 18.5t42.5 46.5t22 57.5t7.5 52.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ntilde",
    unicode: "\xF1",
    horizAdvX: 560,
    d: "M155 459l19 -9v-48q21 12 53 25.5t69 23t71 9.5q43 0 72.5 -20.5t29.5 -74.5v-136q0 -73 2.5 -112t5 -54l2.5 -15q1 -5 12.5 -10t26.5 -8t25 -4l-3 -29q-24 2 -53 2.5t-55 0.5q-25 0 -56.5 -0.5t-55.5 -2.5l3 29q11 1 25 4t25.5 8t12.5 10l2 15t4 54t2 112v105 q0 37 -21.5 50.5t-53.5 13.5q-25 0 -52.5 -6.5t-52.5 -14.5t-41 -15q0 -25 -0.5 -57t-0.5 -76q0 -73 2.5 -112t5 -54l2.5 -15q1 -5 12.5 -10t26.5 -8t25 -4l-3 -29q-24 2 -53 2.5t-55 0.5q-25 0 -56.5 -0.5t-55.5 -2.5l3 29q11 1 25 4t25.5 8t12.5 10l2 15t4 54t2 112 t-2 108.5t-4 47l-2 11.5l-64 19l-2 26q18 0 42.5 2.5t48.5 7t41 8.5zM421 664l26 -8q-15 -50 -34 -72.5t-40.5 -27t-44.5 2.5t-47 17t-47.5 15.5t-46 -1t-42.5 -34.5l-26 8q15 50 34 72.5t40.5 27t44.5 -2.5t47 -17t47.5 -15.5t46 1t42.5 34.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ograve",
    unicode: "\xF2",
    horizAdvX: 529,
    d: "M490 243q0 -48 -13.5 -93t-41.5 -81t-73.5 -57t-110.5 -21q-112 0 -162 59.5t-50 155.5q0 48 13.5 93t41.5 81.5t74 58t110 21.5q75 0 121.5 -27.5t68.5 -76.5t22 -113zM404 206q0 51 -11.5 98t-41 77t-84.5 30q-44 0 -72 -20.5t-43 -50.5t-21 -60t-6 -50q0 -49 13 -92.5 t43 -71t81 -27.5q40 0 67.5 17.5t44 44.5t23.5 55.5t7 49.5zM306 518l-173 162q2 17 23 29.5t46 12.5l134 -199z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oacute",
    unicode: "\xF3",
    horizAdvX: 529,
    d: "M490 243q0 -48 -13.5 -93t-41.5 -81t-73.5 -57t-110.5 -21q-112 0 -162 59.5t-50 155.5q0 48 13.5 93t41.5 81.5t74 58t110 21.5q75 0 121.5 -27.5t68.5 -76.5t22 -113zM404 206q0 51 -11.5 98t-41 77t-84.5 30q-44 0 -72 -20.5t-43 -50.5t-21 -60t-6 -50q0 -49 13 -92.5 t43 -71t81 -27.5q40 0 67.5 17.5t44 44.5t23.5 55.5t7 49.5zM420 680l-173 -162l-30 5l134 199q25 0 46 -12.5t23 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ocircumflex",
    unicode: "\xF4",
    horizAdvX: 529,
    d: "M490 243q0 -48 -13.5 -93t-41.5 -81t-73.5 -57t-110.5 -21q-112 0 -162 59.5t-50 155.5q0 48 13.5 93t41.5 81.5t74 58t110 21.5q75 0 121.5 -27.5t68.5 -76.5t22 -113zM404 206q0 51 -11.5 98t-41 77t-84.5 30q-44 0 -72 -20.5t-43 -50.5t-21 -60t-6 -50q0 -49 13 -92.5 t43 -71t81 -27.5q40 0 67.5 17.5t44 44.5t23.5 55.5t7 49.5zM255 717h37l94 -194l-30 -5l-83 104l-82 -104l-30 5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "otilde",
    unicode: "\xF5",
    horizAdvX: 529,
    d: "M490 243q0 -48 -13.5 -93t-41.5 -81t-73.5 -57t-110.5 -21q-112 0 -162 59.5t-50 155.5q0 48 13.5 93t41.5 81.5t74 58t110 21.5q75 0 121.5 -27.5t68.5 -76.5t22 -113zM404 206q0 51 -11.5 98t-41 77t-84.5 30q-44 0 -72 -20.5t-43 -50.5t-21 -60t-6 -50q0 -49 13 -92.5 t43 -71t81 -27.5q40 0 67.5 17.5t44 44.5t23.5 55.5t7 49.5zM415 664l26 -8q-15 -50 -34 -72.5t-40.5 -27t-44.5 2.5t-47 17t-47.5 15.5t-46 -1t-42.5 -34.5l-26 8q15 50 34 72.5t40.5 27t44.5 -2.5t47 -17t47.5 -15.5t46 1t42.5 34.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odieresis",
    unicode: "\xF6",
    horizAdvX: 529,
    d: "M490 243q0 -48 -13.5 -93t-41.5 -81t-73.5 -57t-110.5 -21q-112 0 -162 59.5t-50 155.5q0 48 13.5 93t41.5 81.5t74 58t110 21.5q75 0 121.5 -27.5t68.5 -76.5t22 -113zM404 206q0 51 -11.5 98t-41 77t-84.5 30q-44 0 -72 -20.5t-43 -50.5t-21 -60t-6 -50q0 -49 13 -92.5 t43 -71t81 -27.5q40 0 67.5 17.5t44 44.5t23.5 55.5t7 49.5zM364 563q-22 0 -37 15.5t-15 38.5q0 22 15 37t37 15t37 -15t15 -37q0 -23 -15 -38.5t-37 -15.5zM184 563q-22 0 -37 15.5t-15 38.5q0 22 15 37t37 15t37 -15t15 -37q0 -23 -15 -38.5t-37 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "divide",
    unicode: "\xF7",
    horizAdvX: 523,
    d: "M261 398q-22 0 -37 15t-15 40q0 23 15 37.5t37 14.5t37.5 -14.5t15.5 -37.5q0 -25 -15.5 -40t-37.5 -15zM24 273v61h475v-61h-475zM261 101q-22 0 -37 15t-15 40q0 23 15 37.5t37 14.5t37.5 -14.5t15.5 -37.5q0 -25 -15.5 -40t-37.5 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oslash",
    unicode: "\xF8",
    horizAdvX: 529,
    d: "M490 243q0 -48 -13.5 -93t-41.5 -81t-73.5 -57t-110.5 -21q-112 0 -162 59.5t-50 155.5q0 48 13.5 93t41.5 81.5t74 58t110 21.5q75 0 121.5 -27.5t68.5 -76.5t22 -113zM404 206q0 51 -11.5 98t-41 77t-84.5 30q-44 0 -72 -20.5t-43 -50.5t-21 -60t-6 -50q0 -49 13 -92.5 t43 -71t81 -27.5q40 0 67.5 17.5t44 44.5t23.5 55.5t7 49.5zM170 -90l139 631h49l-139 -631h-49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ugrave",
    unicode: "\xF9",
    horizAdvX: 550,
    d: "M458 85q1 -18 12.5 -27t29 -11.5t34.5 -3.5l-3 -29q-27 -2 -55 -7.5t-54 -10.5l-16.5 12.5t-24.5 47.5q-40 -27 -92 -46t-102 -19q-44 0 -73 22.5t-29 81.5v134q0 73 -1.5 108.5t-3.5 47l-2 11.5l-59 19l-2 26q27 0 64.5 5.5t62.5 12.5l19 -9l-0.5 -30t-1 -79.5t-1 -107 t-0.5 -113.5q0 -37 20.5 -52t60.5 -15q37 0 75.5 14t59.5 28q2 20 3 48t1 86q0 73 -2 108.5t-4 47l-2 11.5l-63 19l-2 26q18 0 42.5 2.5t48.5 7t41 8.5l19 -9l-1.5 -59t-1.5 -189q0 -63 1.5 -90zM307 518l-173 162q2 17 23 29.5t46 12.5l134 -199z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uacute",
    unicode: "\xFA",
    horizAdvX: 550,
    d: "M458 85q1 -18 12.5 -27t29 -11.5t34.5 -3.5l-3 -29q-27 -2 -55 -7.5t-54 -10.5l-16.5 12.5t-24.5 47.5q-40 -27 -92 -46t-102 -19q-44 0 -73 22.5t-29 81.5v134q0 73 -1.5 108.5t-3.5 47l-2 11.5l-59 19l-2 26q27 0 64.5 5.5t62.5 12.5l19 -9l-0.5 -30t-1 -79.5t-1 -107 t-0.5 -113.5q0 -37 20.5 -52t60.5 -15q37 0 75.5 14t59.5 28q2 20 3 48t1 86q0 73 -2 108.5t-4 47l-2 11.5l-63 19l-2 26q18 0 42.5 2.5t48.5 7t41 8.5l19 -9l-1.5 -59t-1.5 -189q0 -63 1.5 -90zM421 680l-173 -162l-30 5l134 199q25 0 46 -12.5t23 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ucircumflex",
    unicode: "\xFB",
    horizAdvX: 550,
    d: "M458 85q1 -18 12.5 -27t29 -11.5t34.5 -3.5l-3 -29q-27 -2 -55 -7.5t-54 -10.5l-16.5 12.5t-24.5 47.5q-40 -27 -92 -46t-102 -19q-44 0 -73 22.5t-29 81.5v134q0 73 -1.5 108.5t-3.5 47l-2 11.5l-59 19l-2 26q27 0 64.5 5.5t62.5 12.5l19 -9l-0.5 -30t-1 -79.5t-1 -107 t-0.5 -113.5q0 -37 20.5 -52t60.5 -15q37 0 75.5 14t59.5 28q2 20 3 48t1 86q0 73 -2 108.5t-4 47l-2 11.5l-63 19l-2 26q18 0 42.5 2.5t48.5 7t41 8.5l19 -9l-1.5 -59t-1.5 -189q0 -63 1.5 -90zM256 717h37l94 -194l-30 -5l-83 104l-82 -104l-30 5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udieresis",
    unicode: "\xFC",
    horizAdvX: 550,
    d: "M458 85q1 -18 12.5 -27t29 -11.5t34.5 -3.5l-3 -29q-27 -2 -55 -7.5t-54 -10.5l-16.5 12.5t-24.5 47.5q-40 -27 -92 -46t-102 -19q-44 0 -73 22.5t-29 81.5v134q0 73 -1.5 108.5t-3.5 47l-2 11.5l-59 19l-2 26q27 0 64.5 5.5t62.5 12.5l19 -9l-0.5 -30t-1 -79.5t-1 -107 t-0.5 -113.5q0 -37 20.5 -52t60.5 -15q37 0 75.5 14t59.5 28q2 20 3 48t1 86q0 73 -2 108.5t-4 47l-2 11.5l-63 19l-2 26q18 0 42.5 2.5t48.5 7t41 8.5l19 -9l-1.5 -59t-1.5 -189q0 -63 1.5 -90zM365 563q-22 0 -37 15.5t-15 38.5q0 22 15 37t37 15t37 -15t15 -37 q0 -23 -15 -38.5t-37 -15.5zM185 563q-22 0 -37 15.5t-15 38.5q0 22 15 37t37 15t37 -15t15 -37q0 -23 -15 -38.5t-37 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yacute",
    unicode: "\xFD",
    horizAdvX: 482,
    d: "M228 0l-35 21l-130 365q-4 11 -16 23.5t-45 17.5l-3 29l18 -0.5t42 -1.5t42 -1q19 0 42 1t39.5 1.5l16.5 0.5l3 -29q-33 -4 -46.5 -13t-13.5 -17q0 -4 29 -88.5t81 -244.5q56 158 84 241.5t28 92.5q0 22 -55 29l-3 29l22 -1.5t50 -1.5q18 0 42 1t42 1.5l18 0.5l3 -29 q-31 -4 -43.5 -11.5t-17 -21.5t-14.5 -40l-133 -354q-36 -96 -68 -150t-57.5 -78t-44.5 -29.5t-30 -5.5q-5 0 -15.5 10.5t-20.5 27t-15 32.5l15 19q19 -9 45 -9q16 0 38 14t49 53.5t57 115.5zM401 680l-173 -162l-30 5l134 199q25 0 46 -12.5t23 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "thorn",
    unicode: "\xFE",
    horizAdvX: 546,
    d: "M164 23q1 -94 2 -145t2.5 -71t1.5 -22q1 -5 14 -9t29.5 -6.5t26.5 -3.5l-3 -29q-24 2 -56 2.5t-58 0.5q-25 0 -59.5 -0.5t-58.5 -2.5l3 29q11 1 26.5 3.5t28.5 6.5t14 9l2 33.5t4 94.5t4 143t2 178q0 129 -2 226.5t-4 152.5l-2 55l-64 19l-2 26q18 0 42.5 2.5t48.5 7 t41 8.5l18 -9v-321q38 29 80.5 44t82.5 15q48 0 88 -22.5t64.5 -70t24.5 -124.5q0 -86 -29 -142t-78 -83t-110 -27q-31 0 -62.5 8t-61.5 24zM164 366v-305q26 -9 49 -13t43 -4q63 0 98.5 28.5t50.5 73t15 91.5q0 71 -29 115.5t-103 44.5q-35 0 -71 -10t-53 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ydieresis",
    unicode: "\xFF",
    horizAdvX: 482,
    d: "M228 0l-35 21l-130 365q-4 11 -16 23.5t-45 17.5l-3 29l18 -0.5t42 -1.5t42 -1q19 0 42 1t39.5 1.5l16.5 0.5l3 -29q-33 -4 -46.5 -13t-13.5 -17q0 -4 29 -88.5t81 -244.5q56 158 84 241.5t28 92.5q0 22 -55 29l-3 29l22 -1.5t50 -1.5q18 0 42 1t42 1.5l18 0.5l3 -29 q-31 -4 -43.5 -11.5t-17 -21.5t-14.5 -40l-133 -354q-36 -96 -68 -150t-57.5 -78t-44.5 -29.5t-30 -5.5q-5 0 -15.5 10.5t-20.5 27t-15 32.5l15 19q19 -9 45 -9q16 0 38 14t49 53.5t57 115.5zM345 563q-22 0 -37 15.5t-15 38.5q0 22 15 37t37 15t37 -15t15 -37 q0 -23 -15 -38.5t-37 -15.5zM165 563q-22 0 -37 15.5t-15 38.5q0 22 15 37t37 15t37 -15t15 -37q0 -23 -15 -38.5t-37 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Amacron",
    unicode: "\u0100",
    horizAdvX: 694,
    d: "M3 -3l-3 29q47 9 67 19.5t26 29.5l199 609l84 10l233 -625q7 -17 23.5 -26t61.5 -17l-3 -29q-33 2 -65 2.5t-68 0.5q-79 0 -141 -3l-3 29q52 10 70 18t18 20l-55 178h-226l-54 -178q0 -12 19 -20t67 -18l-3 -29q-33 2 -65 2.5t-68 0.5q-31 0 -53 -0.5t-61 -2.5zM235 288 h196l-101 302h-4zM505 850l-39 -46q-34 2 -68.5 3t-69.5 1q-34 0 -68 -1t-69 -3l-8 16l39 46q38 -2 75 -3.5t74 -1.5q32 0 63.5 1t62.5 3z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "amacron",
    unicode: "\u0101",
    horizAdvX: 457,
    d: "M437 52l10 -26q-38 -35 -83 -35q-25 0 -45 15.5t-25 49.5q-37 -28 -73.5 -46.5t-78.5 -18.5q-40 0 -71.5 25t-31.5 79q0 36 23 70.5t78.5 59t150.5 30.5v93q0 29 -21.5 43.5t-51.5 14.5q-44 0 -65 -21t-21 -52q0 -12 3 -27l-22 -10q-21 11 -38 30.5t-17 27.5q0 7 12.5 24 t37.5 36t61 32.5t83 13.5q31 0 56.5 -9t40.5 -32t15 -66q0 -10 0.5 -36t1.5 -60t1.5 -68.5t1.5 -60.5t1 -36q1 -27 11.5 -37.5t24.5 -10.5q6 0 14 2t17 6zM291 94v116q-88 -2 -128 -33t-40 -66q0 -30 18 -45t47 -15q22 0 48.5 10.5t54.5 32.5zM390 618l-39 -46 q-34 2 -68.5 3t-69.5 1q-34 0 -68 -1t-69 -3l-8 16l39 46q38 -2 75 -3.5t74 -1.5q32 0 63.5 1t62.5 3z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Abreve",
    unicode: "\u0102",
    horizAdvX: 694,
    d: "M3 -3l-3 29q47 9 67 19.5t26 29.5l199 609l84 10l233 -625q7 -17 23.5 -26t61.5 -17l-3 -29q-33 2 -65 2.5t-68 0.5q-79 0 -141 -3l-3 29q52 10 70 18t18 20l-55 178h-226l-54 -178q0 -12 19 -20t67 -18l-3 -29q-33 2 -65 2.5t-68 0.5q-31 0 -53 -0.5t-61 -2.5zM235 288 h196l-101 302h-4zM218 891l37 5q5 -27 33 -40t59 -13q32 0 60 13t33 40l37 -5q-7 -54 -46 -81t-84 -27q-44 0 -82.5 27t-46.5 81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "abreve",
    unicode: "\u0103",
    horizAdvX: 457,
    d: "M437 52l10 -26q-38 -35 -83 -35q-25 0 -45 15.5t-25 49.5q-37 -28 -73.5 -46.5t-78.5 -18.5q-40 0 -71.5 25t-31.5 79q0 36 23 70.5t78.5 59t150.5 30.5v93q0 29 -21.5 43.5t-51.5 14.5q-44 0 -65 -21t-21 -52q0 -12 3 -27l-22 -10q-21 11 -38 30.5t-17 27.5q0 7 12.5 24 t37.5 36t61 32.5t83 13.5q31 0 56.5 -9t40.5 -32t15 -66q0 -10 0.5 -36t1.5 -60t1.5 -68.5t1.5 -60.5t1 -36q1 -27 11.5 -37.5t24.5 -10.5q6 0 14 2t17 6zM291 94v116q-88 -2 -128 -33t-40 -66q0 -30 18 -45t47 -15q22 0 48.5 10.5t54.5 32.5zM99 659l37 5q5 -27 33 -40 t59 -13q32 0 60 13t33 40l37 -5q-7 -54 -46 -81t-84 -27q-44 0 -82.5 27t-46.5 81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aogonek",
    unicode: "\u0104",
    horizAdvX: 694,
    d: "M3 -3l-3 29q47 9 67 19.5t26 29.5l199 609l84 10l233 -625q7 -17 23.5 -26t61.5 -17l-3 -29q-33 2 -65 2.5t-68 0.5q-79 0 -141 -3l-3 29q52 10 70 18t18 20l-55 178h-226l-54 -178q0 -12 19 -20t67 -18l-3 -29q-33 2 -65 2.5t-68 0.5q-31 0 -53 -0.5t-61 -2.5zM235 288 h196l-101 302h-4zM628 -144l6 -32q-41 -27 -87 -27q-42 0 -62.5 22.5t-20.5 54.5q0 29 15.5 59.5t47 55.5t79.5 37v-26q-46 -16 -61.5 -45t-15.5 -52q0 -29 16 -42.5t40 -13.5q21 0 43 9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aogonek",
    unicode: "\u0105",
    horizAdvX: 457,
    d: "M437 52l10 -26q-38 -35 -83 -35q-25 0 -45 15.5t-25 49.5q-37 -28 -73.5 -46.5t-78.5 -18.5q-40 0 -71.5 25t-31.5 79q0 36 23 70.5t78.5 59t150.5 30.5v93q0 29 -21.5 43.5t-51.5 14.5q-44 0 -65 -21t-21 -52q0 -12 3 -27l-22 -10q-21 11 -38 30.5t-17 27.5q0 7 12.5 24 t37.5 36t61 32.5t83 13.5q31 0 56.5 -9t40.5 -32t15 -66q0 -10 0.5 -36t1.5 -60t1.5 -68.5t1.5 -60.5t1 -36q1 -27 11.5 -37.5t24.5 -10.5q6 0 14 2t17 6zM291 94v116q-88 -2 -128 -33t-40 -66q0 -30 18 -45t47 -15q22 0 48.5 10.5t54.5 32.5zM428 -144l6 -32 q-41 -27 -87 -27q-42 0 -62.5 22.5t-20.5 54.5q0 29 15.5 59.5t47 55.5t79.5 37v-26q-46 -16 -61.5 -45t-15.5 -52q0 -29 16 -42.5t40 -13.5q21 0 43 9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cacute",
    unicode: "\u0106",
    horizAdvX: 700,
    d: "M404 -12q-112 0 -191.5 41.5t-122 119t-42.5 185.5q0 106 45 187t125.5 127t184.5 46q62 0 102.5 -7.5t71.5 -7.5q27 0 52 6q0 -36 3.5 -80.5t8.5 -75.5l-27 -12q-20 64 -74.5 97.5t-137.5 33.5q-75 0 -131 -37t-87 -103.5t-31 -156.5q0 -94 32 -164.5t89 -110t133 -39.5 q90 0 151 37.5t83 105.5l27 -12q-9 -32 -15 -68t-8 -66q-126 -46 -241 -46zM550 909l-173 -162l-30 5l134 199q25 0 46 -12.5t23 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cacute",
    unicode: "\u0107",
    horizAdvX: 443,
    d: "M409 90l12 -33q-34 -27 -77.5 -46.5t-99.5 -19.5q-70 0 -116.5 29.5t-69 80.5t-22.5 114q0 45 14.5 88.5t43 79t71 56.5t99.5 21q43 0 77 -14.5t54 -31t20 -22.5q0 -13 -6 -34.5t-18 -38.5h-24q-6 17 -20 37t-37 35t-57 15q-44 0 -73 -27.5t-42.5 -70t-13.5 -86.5 q0 -91 41 -131.5t105 -40.5q32 0 70 10.5t69 29.5zM401 680l-173 -162l-30 5l134 199q25 0 46 -12.5t23 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccircumflex",
    unicode: "\u0108",
    horizAdvX: 700,
    d: "M404 -12q-112 0 -191.5 41.5t-122 119t-42.5 185.5q0 106 45 187t125.5 127t184.5 46q62 0 102.5 -7.5t71.5 -7.5q27 0 52 6q0 -36 3.5 -80.5t8.5 -75.5l-27 -12q-20 64 -74.5 97.5t-137.5 33.5q-75 0 -131 -37t-87 -103.5t-31 -156.5q0 -94 32 -164.5t89 -110t133 -39.5 q90 0 151 37.5t83 105.5l27 -12q-9 -32 -15 -68t-8 -66q-126 -46 -241 -46zM401 946h37l94 -194l-30 -5l-83 104l-82 -104l-30 5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccircumflex",
    unicode: "\u0109",
    horizAdvX: 443,
    d: "M409 90l12 -33q-34 -27 -77.5 -46.5t-99.5 -19.5q-70 0 -116.5 29.5t-69 80.5t-22.5 114q0 45 14.5 88.5t43 79t71 56.5t99.5 21q43 0 77 -14.5t54 -31t20 -22.5q0 -13 -6 -34.5t-18 -38.5h-24q-6 17 -20 37t-37 35t-57 15q-44 0 -73 -27.5t-42.5 -70t-13.5 -86.5 q0 -91 41 -131.5t105 -40.5q32 0 70 10.5t69 29.5zM236 717h37l94 -194l-30 -5l-83 104l-82 -104l-30 5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cdotaccent",
    unicode: "\u010A",
    horizAdvX: 700,
    d: "M404 -12q-112 0 -191.5 41.5t-122 119t-42.5 185.5q0 106 45 187t125.5 127t184.5 46q62 0 102.5 -7.5t71.5 -7.5q27 0 52 6q0 -36 3.5 -80.5t8.5 -75.5l-27 -12q-20 64 -74.5 97.5t-137.5 33.5q-75 0 -131 -37t-87 -103.5t-31 -156.5q0 -94 32 -164.5t89 -110t133 -39.5 q90 0 151 37.5t83 105.5l27 -12q-9 -32 -15 -68t-8 -66q-126 -46 -241 -46zM419 793q-22 0 -37 15.5t-15 38.5q0 22 15 37t37 15t37 -15t15 -37q0 -23 -15 -38.5t-37 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cdotaccent",
    unicode: "\u010B",
    horizAdvX: 443,
    d: "M409 90l12 -33q-34 -27 -77.5 -46.5t-99.5 -19.5q-70 0 -116.5 29.5t-69 80.5t-22.5 114q0 45 14.5 88.5t43 79t71 56.5t99.5 21q43 0 77 -14.5t54 -31t20 -22.5q0 -13 -6 -34.5t-18 -38.5h-24q-6 17 -20 37t-37 35t-57 15q-44 0 -73 -27.5t-42.5 -70t-13.5 -86.5 q0 -91 41 -131.5t105 -40.5q32 0 70 10.5t69 29.5zM255 563q-22 0 -37 15.5t-15 38.5q0 22 15 37t37 15t37 -15t15 -37q0 -23 -15 -38.5t-37 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccaron",
    unicode: "\u010C",
    horizAdvX: 700,
    d: "M404 -12q-112 0 -191.5 41.5t-122 119t-42.5 185.5q0 106 45 187t125.5 127t184.5 46q62 0 102.5 -7.5t71.5 -7.5q27 0 52 6q0 -36 3.5 -80.5t8.5 -75.5l-27 -12q-20 64 -74.5 97.5t-137.5 33.5q-75 0 -131 -37t-87 -103.5t-31 -156.5q0 -94 32 -164.5t89 -110t133 -39.5 q90 0 151 37.5t83 105.5l27 -12q-9 -32 -15 -68t-8 -66q-126 -46 -241 -46zM437 752h-37l-104 195l30 5l92 -114l93 114l30 -5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccaron",
    unicode: "\u010D",
    horizAdvX: 443,
    d: "M409 90l12 -33q-34 -27 -77.5 -46.5t-99.5 -19.5q-70 0 -116.5 29.5t-69 80.5t-22.5 114q0 45 14.5 88.5t43 79t71 56.5t99.5 21q43 0 77 -14.5t54 -31t20 -22.5q0 -13 -6 -34.5t-18 -38.5h-24q-6 17 -20 37t-37 35t-57 15q-44 0 -73 -27.5t-42.5 -70t-13.5 -86.5 q0 -91 41 -131.5t105 -40.5q32 0 70 10.5t69 29.5zM273 522h-37l-104 195l30 5l92 -114l93 114l30 -5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dcaron",
    unicode: "\u010E",
    horizAdvX: 769,
    d: "M173 685h178q66 0 131.5 -17.5t119.5 -55t86 -98.5t32 -149q0 -102 -42 -185t-127.5 -131.5t-216.5 -48.5h-161q-78 0 -141 -3l-3 29q45 9 66 16.5t23 26.5l2 23.5t4 83t2 166.5q0 108 -2 167.5t-4 83l-2 23.5q-2 19 -19.5 26.5t-62.5 16.5l3 29q32 -1 64.5 -2t69.5 -1z M227 60q27 -6 51 -9t52 -3q77 0 129 23t83 60t47 78.5t21 79t5 61.5q0 50 -12.5 101.5t-47 95t-98.5 70t-168 26.5q-37 0 -48 -4t-14 -17l-2.5 -25t-5.5 -86t-3 -168q0 -108 3 -169.5t5.5 -87.5zM374 752h-37l-104 195l30 5l92 -114l93 114l30 -5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcaron",
    unicode: "\u010F",
    horizAdvX: 544,
    d: "M377 56q-35 -33 -75.5 -49t-78.5 -16q-50 0 -92 25.5t-67 76t-25 124.5q0 80 30 134t79.5 82t107.5 28q32 0 59 -7.5t61 -27.5q0 78 -1.5 126t-3 72.5t-2.5 33.5l-1 9l-64 19l-2 26q18 0 42.5 2.5t48.5 7t41 8.5l19 -9l-1 -93t-1 -276q0 -121 1 -181t2 -86q1 -18 13 -27 t29 -11.5t34 -3.5l-3 -29q-27 -2 -55 -7.5t-54 -10.5l-16.5 12.5t-24.5 47.5zM376 382q-26 9 -48.5 13.5t-45.5 4.5q-56 0 -90 -26t-49 -67t-15 -88q0 -70 31.5 -117.5t98.5 -47.5q35 0 66 14t47 26q1 16 2 59.5t2 103.5t1 125zM480 708q0 23 16 35t38 12q26 0 50 -20.5 t24 -65.5q0 -39 -25 -74.5t-69 -59.5l-15 21q26 22 42.5 49.5t16.5 55.5v10t-2 10q-4 -7 -14 -11.5t-19 -4.5q-20 0 -31.5 13.5t-11.5 29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dcroat",
    unicode: "\u0110",
    horizAdvX: 769,
    d: "M173 685h178q66 0 131.5 -17.5t119.5 -55t86 -98.5t32 -149q0 -102 -42 -185t-127.5 -131.5t-216.5 -48.5h-161q-78 0 -141 -3l-3 29q45 9 66 16.5t23 26.5l2 21.5t4 75t2 150.5h-88v53h88q0 97 -2 150.5t-4 75l-2 21.5q-2 19 -19.5 26.5t-62.5 16.5l3 29q32 -1 64.5 -2 t69.5 -1zM227 60q27 -6 51 -9t52 -3q77 0 129 23t83 60t47 78.5t21 79t5 61.5q0 50 -12.5 101.5t-47 95t-98.5 70t-168 26.5q-37 0 -48 -4t-14 -17l-2.5 -23t-5.5 -78t-3 -152h204v-54l-204 1q1 -97 3.5 -153t5 -79.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcroat",
    unicode: "\u0111",
    horizAdvX: 544,
    d: "M377 56q-35 -33 -75.5 -49t-78.5 -16q-50 0 -92 25.5t-67 76t-25 124.5q0 80 30 134t79.5 82t107.5 28q32 0 59 -7.5t61 -27.5q0 36 -0.5 65t-0.5 52h-139l13 42h124q-1 51 -3 66.5l-2 15.5l-64 19l-2 26q18 0 42.5 2.5t48.5 7t41 8.5l19 -9l-0.5 -34t-0.5 -102h91 l-13 -42h-79v-87v-104q0 -121 1 -181t2 -86q1 -18 13 -27t29 -11.5t34 -3.5l-3 -29q-27 -2 -55 -7.5t-54 -10.5l-16.5 12.5t-24.5 47.5zM376 382q-26 9 -48.5 13.5t-45.5 4.5q-56 0 -90 -26t-49 -67t-15 -88q0 -70 31.5 -117.5t98.5 -47.5q35 0 66 14t47 26q1 16 2 59.5 t2 103.5t1 125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Emacron",
    unicode: "\u0112",
    horizAdvX: 608,
    d: "M453 236l-35 -5q-10 50 -17 67t-26 21q-12 3 -38 4.5t-58 2.5t-64 1q0 -103 3 -159t5.5 -78l2.5 -22q5 -18 37 -25t64 -7q52 0 94 7t74 35.5t52 92.5l27 -12q-6 -18 -11 -49t-8.5 -61.5t-4.5 -48.5h-400q-37 0 -62.5 -0.5t-57.5 -2.5l-3 29q45 9 66 16.5t23 26.5l2 23.5 t4.5 82.5t2.5 167t-2 167.5t-4 83l-2 23.5q-2 19 -19.5 26.5t-62.5 16.5l3 29q32 -1 54 -2t59 -1h137.5t137 1.5t105.5 4.5v-15q0 -21 1.5 -49t4.5 -54.5t6 -43.5l-27 -12q-13 42 -27.5 67.5t-36 38t-54 16.5t-80.5 4q-36 0 -62.5 -3t-29.5 -19l-2.5 -24t-5 -79.5 t-3.5 -150.5q32 0 64 1t58 2.5t38 4.5q19 5 26 21.5t17 66.5l35 -4q-4 -27 -6 -55t-2 -56t2 -56t6 -56zM462 850l-39 -46q-34 2 -68.5 3t-69.5 1q-34 0 -68 -1t-69 -3l-8 16l39 46q38 -2 75 -3.5t74 -1.5q32 0 63.5 1t62.5 3z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emacron",
    unicode: "\u0113",
    horizAdvX: 459,
    d: "M403 83l12 -30q-31 -25 -72.5 -43.5t-91.5 -18.5q-74 0 -121.5 29.5t-70 78.5t-22.5 108q0 48 13.5 93t41.5 81t74 57.5t110 21.5q36 0 71 -17t58 -54.5t23 -99.5l-34 -41q-4 1 -13.5 1h-23.5q-25 0 -59 -0.5t-69 -1.5t-64 -2.5t-43 -2.5v-9q0 -94 39.5 -138t102.5 -44 q37 0 70 8t69 24zM338 320q0 34 -13.5 53.5t-33 28.5t-37.5 9q-49 0 -82 -38.5t-44 -89.5l207 8q3 15 3 29zM414 618l-39 -46q-34 2 -68.5 3t-69.5 1q-34 0 -68 -1t-69 -3l-8 16l39 46q38 -2 75 -3.5t74 -1.5q32 0 63.5 1t62.5 3z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ebreve",
    unicode: "\u0114",
    horizAdvX: 608,
    d: "M453 236l-35 -5q-10 50 -17 67t-26 21q-12 3 -38 4.5t-58 2.5t-64 1q0 -103 3 -159t5.5 -78l2.5 -22q5 -18 37 -25t64 -7q52 0 94 7t74 35.5t52 92.5l27 -12q-6 -18 -11 -49t-8.5 -61.5t-4.5 -48.5h-400q-37 0 -62.5 -0.5t-57.5 -2.5l-3 29q45 9 66 16.5t23 26.5l2 23.5 t4.5 82.5t2.5 167t-2 167.5t-4 83l-2 23.5q-2 19 -19.5 26.5t-62.5 16.5l3 29q32 -1 54 -2t59 -1h137.5t137 1.5t105.5 4.5v-15q0 -21 1.5 -49t4.5 -54.5t6 -43.5l-27 -12q-13 42 -27.5 67.5t-36 38t-54 16.5t-80.5 4q-36 0 -62.5 -3t-29.5 -19l-2.5 -24t-5 -79.5 t-3.5 -150.5q32 0 64 1t58 2.5t38 4.5q19 5 26 21.5t17 66.5l35 -4q-4 -27 -6 -55t-2 -56t2 -56t6 -56zM175 891l37 5q5 -27 33 -40t59 -13q32 0 60 13t33 40l37 -5q-7 -54 -46 -81t-84 -27q-44 0 -82.5 27t-46.5 81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ebreve",
    unicode: "\u0115",
    horizAdvX: 459,
    d: "M403 83l12 -30q-31 -25 -72.5 -43.5t-91.5 -18.5q-74 0 -121.5 29.5t-70 78.5t-22.5 108q0 48 13.5 93t41.5 81t74 57.5t110 21.5q36 0 71 -17t58 -54.5t23 -99.5l-34 -41q-4 1 -13.5 1h-23.5q-25 0 -59 -0.5t-69 -1.5t-64 -2.5t-43 -2.5v-9q0 -94 39.5 -138t102.5 -44 q37 0 70 8t69 24zM338 320q0 34 -13.5 53.5t-33 28.5t-37.5 9q-49 0 -82 -38.5t-44 -89.5l207 8q3 15 3 29zM123 659l37 5q5 -27 33 -40t59 -13q32 0 60 13t33 40l37 -5q-7 -54 -46 -81t-84 -27q-44 0 -82.5 27t-46.5 81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edotaccent",
    unicode: "\u0116",
    horizAdvX: 608,
    d: "M453 236l-35 -5q-10 50 -17 67t-26 21q-12 3 -38 4.5t-58 2.5t-64 1q0 -103 3 -159t5.5 -78l2.5 -22q5 -18 37 -25t64 -7q52 0 94 7t74 35.5t52 92.5l27 -12q-6 -18 -11 -49t-8.5 -61.5t-4.5 -48.5h-400q-37 0 -62.5 -0.5t-57.5 -2.5l-3 29q45 9 66 16.5t23 26.5l2 23.5 t4.5 82.5t2.5 167t-2 167.5t-4 83l-2 23.5q-2 19 -19.5 26.5t-62.5 16.5l3 29q32 -1 54 -2t59 -1h137.5t137 1.5t105.5 4.5v-15q0 -21 1.5 -49t4.5 -54.5t6 -43.5l-27 -12q-13 42 -27.5 67.5t-36 38t-54 16.5t-80.5 4q-36 0 -62.5 -3t-29.5 -19l-2.5 -24t-5 -79.5 t-3.5 -150.5q32 0 64 1t58 2.5t38 4.5q19 5 26 21.5t17 66.5l35 -4q-4 -27 -6 -55t-2 -56t2 -56t6 -56zM304 793q-22 0 -37 15.5t-15 38.5q0 22 15 37t37 15t37 -15t15 -37q0 -23 -15 -38.5t-37 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edotaccent",
    unicode: "\u0117",
    horizAdvX: 459,
    d: "M403 83l12 -30q-31 -25 -72.5 -43.5t-91.5 -18.5q-74 0 -121.5 29.5t-70 78.5t-22.5 108q0 48 13.5 93t41.5 81t74 57.5t110 21.5q36 0 71 -17t58 -54.5t23 -99.5l-34 -41q-4 1 -13.5 1h-23.5q-25 0 -59 -0.5t-69 -1.5t-64 -2.5t-43 -2.5v-9q0 -94 39.5 -138t102.5 -44 q37 0 70 8t69 24zM338 320q0 34 -13.5 53.5t-33 28.5t-37.5 9q-49 0 -82 -38.5t-44 -89.5l207 8q3 15 3 29zM253 563q-22 0 -37 15.5t-15 38.5q0 22 15 37t37 15t37 -15t15 -37q0 -23 -15 -38.5t-37 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eogonek",
    unicode: "\u0118",
    horizAdvX: 608,
    d: "M453 236l-35 -5q-10 50 -17 67t-26 21q-12 3 -38 4.5t-58 2.5t-64 1q0 -103 3 -159t5.5 -78l2.5 -22q5 -18 37 -25t64 -7q52 0 94 7t74 35.5t52 92.5l27 -12q-6 -18 -11 -49t-8.5 -61.5t-4.5 -48.5h-400q-37 0 -62.5 -0.5t-57.5 -2.5l-3 29q45 9 66 16.5t23 26.5l2 23.5 t4.5 82.5t2.5 167t-2 167.5t-4 83l-2 23.5q-2 19 -19.5 26.5t-62.5 16.5l3 29q32 -1 54 -2t59 -1h137.5t137 1.5t105.5 4.5v-15q0 -21 1.5 -49t4.5 -54.5t6 -43.5l-27 -12q-13 42 -27.5 67.5t-36 38t-54 16.5t-80.5 4q-36 0 -62.5 -3t-29.5 -19l-2.5 -24t-5 -79.5 t-3.5 -150.5q32 0 64 1t58 2.5t38 4.5q19 5 26 21.5t17 66.5l35 -4q-4 -27 -6 -55t-2 -56t2 -56t6 -56zM426 -144l6 -32q-41 -27 -87 -27q-42 0 -62.5 22.5t-20.5 54.5q0 29 15.5 59.5t47 55.5t79.5 37v-26q-46 -16 -61.5 -45t-15.5 -52q0 -29 16 -42.5t40 -13.5q21 0 43 9z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eogonek",
    unicode: "\u0119",
    horizAdvX: 459,
    d: "M403 83l12 -30q-31 -25 -72.5 -43.5t-91.5 -18.5q-74 0 -121.5 29.5t-70 78.5t-22.5 108q0 48 13.5 93t41.5 81t74 57.5t110 21.5q36 0 71 -17t58 -54.5t23 -99.5l-34 -41q-4 1 -13.5 1h-23.5q-25 0 -59 -0.5t-69 -1.5t-64 -2.5t-43 -2.5v-9q0 -94 39.5 -138t102.5 -44 q37 0 70 8t69 24zM338 320q0 34 -13.5 53.5t-33 28.5t-37.5 9q-49 0 -82 -38.5t-44 -89.5l207 8q3 15 3 29zM337 -144l6 -32q-41 -27 -87 -27q-42 0 -62.5 22.5t-20.5 54.5q0 29 15.5 59.5t47 55.5t79.5 37v-26q-46 -16 -61.5 -45t-15.5 -52q0 -29 16 -42.5t40 -13.5 q21 0 43 9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecaron",
    unicode: "\u011A",
    horizAdvX: 608,
    d: "M453 236l-35 -5q-10 50 -17 67t-26 21q-12 3 -38 4.5t-58 2.5t-64 1q0 -103 3 -159t5.5 -78l2.5 -22q5 -18 37 -25t64 -7q52 0 94 7t74 35.5t52 92.5l27 -12q-6 -18 -11 -49t-8.5 -61.5t-4.5 -48.5h-400q-37 0 -62.5 -0.5t-57.5 -2.5l-3 29q45 9 66 16.5t23 26.5l2 23.5 t4.5 82.5t2.5 167t-2 167.5t-4 83l-2 23.5q-2 19 -19.5 26.5t-62.5 16.5l3 29q32 -1 54 -2t59 -1h137.5t137 1.5t105.5 4.5v-15q0 -21 1.5 -49t4.5 -54.5t6 -43.5l-27 -12q-13 42 -27.5 67.5t-36 38t-54 16.5t-80.5 4q-36 0 -62.5 -3t-29.5 -19l-2.5 -24t-5 -79.5 t-3.5 -150.5q32 0 64 1t58 2.5t38 4.5q19 5 26 21.5t17 66.5l35 -4q-4 -27 -6 -55t-2 -56t2 -56t6 -56zM322 752h-37l-104 195l30 5l92 -114l93 114l30 -5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecaron",
    unicode: "\u011B",
    horizAdvX: 459,
    d: "M403 83l12 -30q-31 -25 -72.5 -43.5t-91.5 -18.5q-74 0 -121.5 29.5t-70 78.5t-22.5 108q0 48 13.5 93t41.5 81t74 57.5t110 21.5q36 0 71 -17t58 -54.5t23 -99.5l-34 -41q-4 1 -13.5 1h-23.5q-25 0 -59 -0.5t-69 -1.5t-64 -2.5t-43 -2.5v-9q0 -94 39.5 -138t102.5 -44 q37 0 70 8t69 24zM338 320q0 34 -13.5 53.5t-33 28.5t-37.5 9q-49 0 -82 -38.5t-44 -89.5l207 8q3 15 3 29zM271 522h-37l-104 195l30 5l92 -114l93 114l30 -5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gcircumflex",
    unicode: "\u011C",
    horizAdvX: 759,
    d: "M407 37q53 0 102 11t76 25q-1 72 -4 117l-3 45q-2 19 -19.5 26.5t-62.5 16.5l3 29q32 -1 64.5 -2t69.5 -1q25 0 40 0.5t28.5 1t34.5 1.5l3 -29q-30 -6 -40.5 -11t-11.5 -12t-3 -20l-7 -180q-79 -34 -144 -50.5t-129 -16.5q-107 0 -187 39t-124.5 116t-44.5 191 q0 72 24 136.5t71 115t116 79.5t159 29q65 0 107 -7.5t79 -7.5q24 0 49 6v-15q0 -20 1.5 -46.5t4.5 -52t6 -42.5l-28 -12q-16 51 -51 79.5t-79.5 40t-92.5 11.5q-67 0 -126.5 -31.5t-97 -97t-37.5 -168.5q0 -55 14 -111t44 -101.5t78.5 -73.5t117.5 -28zM405 946h37l94 -194 l-30 -5l-83 104l-82 -104l-30 5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gcircumflex",
    unicode: "\u011D",
    horizAdvX: 490,
    d: "M354 429q6 9 19.5 25t30 29t30.5 13q5 0 15.5 -10.5t21 -26.5t14.5 -33l-15 -19q-7 4 -18.5 6.5t-25.5 2.5q-10 0 -22 -2.5t-24 -8.5q17 -20 26 -48.5t9 -68.5q0 -39 -18.5 -77t-58.5 -63t-105 -25q-23 0 -44 3q-17 -22 -27 -38.5t-10 -27.5q0 -13 15.5 -18t49.5 -5h75 q96 0 142.5 -32t46.5 -90q0 -41 -32 -82.5t-94 -68.5t-152 -27q-45 0 -86.5 10t-68.5 31t-27 53q0 28 25 66t78 81q-31 7 -47 20t-16 29q0 20 26.5 48t63.5 58q-48 15 -74.5 53t-26.5 108q0 39 19 77t59.5 63t104.5 25q36 0 67 -6.5t54 -23.5zM329 278q0 33 -7 65 t-27.5 53.5t-60.5 21.5q-31 0 -51 -14t-30 -34.5t-14 -41t-4 -34.5q0 -30 8.5 -60t29.5 -50t57 -20q39 0 60 20t29.5 47t9.5 47zM105 -136q0 -37 28 -62t86 -25q54 0 94 20.5t62 51t22 58.5t-24 48t-83 20h-135q-25 -28 -37.5 -56.5t-12.5 -54.5zM226 717h37l94 -194l-30 -5 l-83 104l-82 -104l-30 5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gbreve",
    unicode: "\u011E",
    horizAdvX: 759,
    d: "M407 37q53 0 102 11t76 25q-1 72 -4 117l-3 45q-2 19 -19.5 26.5t-62.5 16.5l3 29q32 -1 64.5 -2t69.5 -1q25 0 40 0.5t28.5 1t34.5 1.5l3 -29q-30 -6 -40.5 -11t-11.5 -12t-3 -20l-7 -180q-79 -34 -144 -50.5t-129 -16.5q-107 0 -187 39t-124.5 116t-44.5 191 q0 72 24 136.5t71 115t116 79.5t159 29q65 0 107 -7.5t79 -7.5q24 0 49 6v-15q0 -20 1.5 -46.5t4.5 -52t6 -42.5l-28 -12q-16 51 -51 79.5t-79.5 40t-92.5 11.5q-67 0 -126.5 -31.5t-97 -97t-37.5 -168.5q0 -55 14 -111t44 -101.5t78.5 -73.5t117.5 -28zM294 891l37 5 q5 -27 33 -40t59 -13q32 0 60 13t33 40l37 -5q-7 -54 -46 -81t-84 -27q-44 0 -82.5 27t-46.5 81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gbreve",
    unicode: "\u011F",
    horizAdvX: 490,
    d: "M354 429q6 9 19.5 25t30 29t30.5 13q5 0 15.5 -10.5t21 -26.5t14.5 -33l-15 -19q-7 4 -18.5 6.5t-25.5 2.5q-10 0 -22 -2.5t-24 -8.5q17 -20 26 -48.5t9 -68.5q0 -39 -18.5 -77t-58.5 -63t-105 -25q-23 0 -44 3q-17 -22 -27 -38.5t-10 -27.5q0 -13 15.5 -18t49.5 -5h75 q96 0 142.5 -32t46.5 -90q0 -41 -32 -82.5t-94 -68.5t-152 -27q-45 0 -86.5 10t-68.5 31t-27 53q0 28 25 66t78 81q-31 7 -47 20t-16 29q0 20 26.5 48t63.5 58q-48 15 -74.5 53t-26.5 108q0 39 19 77t59.5 63t104.5 25q36 0 67 -6.5t54 -23.5zM329 278q0 33 -7 65 t-27.5 53.5t-60.5 21.5q-31 0 -51 -14t-30 -34.5t-14 -41t-4 -34.5q0 -30 8.5 -60t29.5 -50t57 -20q39 0 60 20t29.5 47t9.5 47zM105 -136q0 -37 28 -62t86 -25q54 0 94 20.5t62 51t22 58.5t-24 48t-83 20h-135q-25 -28 -37.5 -56.5t-12.5 -54.5zM115 659l37 5q5 -27 33 -40 t59 -13q32 0 60 13t33 40l37 -5q-7 -54 -46 -81t-84 -27q-44 0 -82.5 27t-46.5 81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gdotaccent",
    unicode: "\u0120",
    horizAdvX: 759,
    d: "M407 37q53 0 102 11t76 25q-1 72 -4 117l-3 45q-2 19 -19.5 26.5t-62.5 16.5l3 29q32 -1 64.5 -2t69.5 -1q25 0 40 0.5t28.5 1t34.5 1.5l3 -29q-30 -6 -40.5 -11t-11.5 -12t-3 -20l-7 -180q-79 -34 -144 -50.5t-129 -16.5q-107 0 -187 39t-124.5 116t-44.5 191 q0 72 24 136.5t71 115t116 79.5t159 29q65 0 107 -7.5t79 -7.5q24 0 49 6v-15q0 -20 1.5 -46.5t4.5 -52t6 -42.5l-28 -12q-16 51 -51 79.5t-79.5 40t-92.5 11.5q-67 0 -126.5 -31.5t-97 -97t-37.5 -168.5q0 -55 14 -111t44 -101.5t78.5 -73.5t117.5 -28zM423 793 q-22 0 -37 15.5t-15 38.5q0 22 15 37t37 15t37 -15t15 -37q0 -23 -15 -38.5t-37 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gdotaccent",
    unicode: "\u0121",
    horizAdvX: 490,
    d: "M354 429q6 9 19.5 25t30 29t30.5 13q5 0 15.5 -10.5t21 -26.5t14.5 -33l-15 -19q-7 4 -18.5 6.5t-25.5 2.5q-10 0 -22 -2.5t-24 -8.5q17 -20 26 -48.5t9 -68.5q0 -39 -18.5 -77t-58.5 -63t-105 -25q-23 0 -44 3q-17 -22 -27 -38.5t-10 -27.5q0 -13 15.5 -18t49.5 -5h75 q96 0 142.5 -32t46.5 -90q0 -41 -32 -82.5t-94 -68.5t-152 -27q-45 0 -86.5 10t-68.5 31t-27 53q0 28 25 66t78 81q-31 7 -47 20t-16 29q0 20 26.5 48t63.5 58q-48 15 -74.5 53t-26.5 108q0 39 19 77t59.5 63t104.5 25q36 0 67 -6.5t54 -23.5zM329 278q0 33 -7 65 t-27.5 53.5t-60.5 21.5q-31 0 -51 -14t-30 -34.5t-14 -41t-4 -34.5q0 -30 8.5 -60t29.5 -50t57 -20q39 0 60 20t29.5 47t9.5 47zM105 -136q0 -37 28 -62t86 -25q54 0 94 20.5t62 51t22 58.5t-24 48t-83 20h-135q-25 -28 -37.5 -56.5t-12.5 -54.5zM245 563q-22 0 -37 15.5 t-15 38.5q0 22 15 37t37 15t37 -15t15 -37q0 -23 -15 -38.5t-37 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0122",
    unicode: "\u0122",
    horizAdvX: 759,
    d: "M407 37q53 0 102 11t76 25q-1 72 -4 117l-3 45q-2 19 -19.5 26.5t-62.5 16.5l3 29q32 -1 64.5 -2t69.5 -1q25 0 40 0.5t28.5 1t34.5 1.5l3 -29q-30 -6 -40.5 -11t-11.5 -12t-3 -20l-7 -180q-79 -34 -144 -50.5t-129 -16.5q-107 0 -187 39t-124.5 116t-44.5 191 q0 72 24 136.5t71 115t116 79.5t159 29q65 0 107 -7.5t79 -7.5q24 0 49 6v-15q0 -20 1.5 -46.5t4.5 -52t6 -42.5l-28 -12q-16 51 -51 79.5t-79.5 40t-92.5 11.5q-67 0 -126.5 -31.5t-97 -97t-37.5 -168.5q0 -55 14 -111t44 -101.5t78.5 -73.5t117.5 -28zM339 -92q0 23 16 35 t38 12q26 0 50 -20.5t24 -65.5q0 -39 -25 -74.5t-69 -59.5l-15 21q26 22 42.5 49.5t16.5 55.5v10t-2 10q-4 -7 -14 -11.5t-19 -4.5q-20 0 -31.5 13.5t-11.5 29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0123",
    unicode: "\u0123",
    horizAdvX: 490,
    d: "M354 429q6 9 19.5 25t30 29t30.5 13q5 0 15.5 -10.5t21 -26.5t14.5 -33l-15 -19q-7 4 -18.5 6.5t-25.5 2.5q-10 0 -22 -2.5t-24 -8.5q17 -20 26 -48.5t9 -68.5q0 -39 -18.5 -77t-58.5 -63t-105 -25q-23 0 -44 3q-17 -22 -27 -38.5t-10 -27.5q0 -13 15.5 -18t49.5 -5h75 q96 0 142.5 -32t46.5 -90q0 -41 -32 -82.5t-94 -68.5t-152 -27q-45 0 -86.5 10t-68.5 31t-27 53q0 28 25 66t78 81q-31 7 -47 20t-16 29q0 20 26.5 48t63.5 58q-48 15 -74.5 53t-26.5 108q0 39 19 77t59.5 63t104.5 25q36 0 67 -6.5t54 -23.5zM329 278q0 33 -7 65 t-27.5 53.5t-60.5 21.5q-31 0 -51 -14t-30 -34.5t-14 -41t-4 -34.5q0 -30 8.5 -60t29.5 -50t57 -20q39 0 60 20t29.5 47t9.5 47zM105 -136q0 -37 28 -62t86 -25q54 0 94 20.5t62 51t22 58.5t-24 48t-83 20h-135q-25 -28 -37.5 -56.5t-12.5 -54.5zM299 558q0 -22 -16 -34.5 t-38 -12.5q-26 0 -50 20.5t-24 65.5q0 39 25.5 74.5t68.5 59.5l15 -21q-25 -22 -42 -49.5t-17 -55.5q0 -5 0.5 -10t1.5 -10q5 8 14.5 12t18.5 4q20 0 31.5 -13t11.5 -30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hcircumflex",
    unicode: "\u0124",
    horizAdvX: 803,
    d: "M587 384q0 93 -2 143t-4 69.5l-2 19.5q-2 19 -19.5 26.5t-62.5 16.5l3 29q32 -1 64.5 -2t69.5 -1q38 0 68.5 1t61.5 2l3 -29q-45 -9 -62.5 -16.5t-19.5 -26.5l-2 -23.5t-4 -83t-2 -167.5t2 -167t4 -82.5l2 -23.5q2 -19 21 -26.5t64 -16.5l-3 -29q-31 2 -63 2.5t-70 0.5 q-78 0 -141 -3l-3 29q45 9 66 16.5t23 26.5l2 22t4 78t2 159l-16 1.5t-56 2.5t-114 1q-73 0 -113 -1t-56 -2.5l-16 -1.5q0 -103 2 -159.5t4 -78l2 -21.5q2 -19 21 -26.5t64 -16.5l-3 -29q-31 2 -63 2.5t-70 0.5q-78 0 -141 -3l-3 29q45 9 66 16.5t23 26.5l2 23.5t4 83 t2 166.5q0 108 -2 167.5t-4 83l-2 23.5q-2 19 -19.5 26.5t-62.5 16.5l3 29q32 -1 64.5 -2t69.5 -1q38 0 68.5 1t61.5 2l3 -29q-45 -9 -62.5 -16.5t-19.5 -26.5l-2 -19.5t-3.5 -70t-2.5 -142.5l16 -1t56 -2.5t113 -1.5q74 0 114 1.5t56 2.5zM384 946h37l94 -194l-30 -5 l-83 104l-82 -104l-30 5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hcircumflex",
    unicode: "\u0125",
    horizAdvX: 558,
    d: "M95 883l37 -1l126 -134l-30 -18l-115 83l-114 -83l-30 18zM166 362q0 -99 1.5 -160.5t3.5 -94.5t4 -45.5t2 -13.5q1 -5 12.5 -10t26.5 -8t25 -4l-3 -29q-24 2 -53 2.5t-55 0.5q-25 0 -56.5 -0.5t-55.5 -2.5l3 29q11 1 25 4t25.5 8t12.5 10l1 14.5t2.5 50t2.5 98t1 158.5 q0 97 -1 156t-3 90t-3 41.5l-1 10.5l-64 19l-2 26q18 0 42.5 2.5t48.5 7t41 8.5l19 -9l-1 -83.5t-1 -235.5q21 12 55 25.5t72.5 23t72.5 9.5q43 0 72.5 -20.5t29.5 -74.5v-136q0 -73 2.5 -112t5 -54l2.5 -15q1 -5 12.5 -10t26.5 -8t25 -4l-3 -29q-24 2 -53 2.5t-55 0.5 q-25 0 -56.5 -0.5t-55.5 -2.5l3 29q11 1 25 4t25.5 8t12.5 10l2 15t4 54t2 112v105q0 37 -21.5 50.5t-53.5 13.5q-25 0 -54.5 -6.5t-55.5 -14.5t-42 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hbar",
    unicode: "\u0126",
    horizAdvX: 803,
    d: "M761 519l-13 -42h-70q0 -27 -0.5 -60.5t-0.5 -74.5q0 -108 2 -167t4 -82.5l2 -23.5q2 -19 21 -26.5t64 -16.5l-3 -29q-31 2 -63 2.5t-70 0.5q-78 0 -141 -3l-3 29q45 9 66 16.5t23 26.5l2 22t4 78t2 159l-16 1.5t-56 2.5t-114 1q-73 0 -113 -1t-56 -2.5l-16 -1.5 q0 -103 2 -159.5t4 -78l2 -21.5q2 -19 21 -26.5t64 -16.5l-3 -29q-31 2 -63 2.5t-70 0.5q-78 0 -141 -3l-3 29q45 9 66 16.5t23 26.5l2 23.5t4 83t2 166.5q0 41 -0.5 74.5t-0.5 60.5h-84l13 42h70q-2 55 -4 76l-2 21q-2 19 -19.5 26.5t-62.5 16.5l3 29q32 -1 64.5 -2 t69.5 -1q38 0 68.5 1t61.5 2l3 -29q-45 -9 -62.5 -16.5t-19.5 -26.5l-2 -20.5t-4 -76.5h367q-2 56 -4 76.5l-2 20.5q-2 19 -19.5 26.5t-62.5 16.5l3 29q32 -1 64.5 -2t69.5 -1q38 0 68.5 1t61.5 2l3 -29q-45 -9 -62.5 -16.5t-19.5 -26.5l-2 -21t-4 -76h82zM587 384 q0 27 -0.5 50t-0.5 43h-369q0 -20 -0.5 -43t-0.5 -50l16 -1t56 -2.5t113 -1.5q74 0 114 1.5t56 2.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hbar",
    unicode: "\u0127",
    horizAdvX: 558,
    d: "M166 362q0 -99 1.5 -160.5t3.5 -94.5t4 -45.5t2 -13.5q1 -5 12.5 -10t26.5 -8t25 -4l-3 -29q-24 2 -53 2.5t-55 0.5q-25 0 -56.5 -0.5t-55.5 -2.5l3 29q11 1 25 4t25.5 8t12.5 10l1 14.5t2.5 50t2.5 98t1 158.5q0 56 -0.5 99t-1.5 75h-89l13 42h75q-2 51 -3.5 66.5 l-1.5 15.5l-64 19l-2 26q18 0 42.5 2.5t48.5 7t41 8.5l19 -9q-1 -2 -1 -136h140l-13 -42h-128v-66v-75q21 12 55 25.5t72.5 23t72.5 9.5q43 0 72.5 -20.5t29.5 -74.5v-136q0 -73 2.5 -112t5 -54l2.5 -15q1 -5 12.5 -10t26.5 -8t25 -4l-3 -29q-24 2 -53 2.5t-55 0.5 q-25 0 -56.5 -0.5t-55.5 -2.5l3 29q11 1 25 4t25.5 8t12.5 10l2 15t4 54t2 112v105q0 37 -21.5 50.5t-53.5 13.5q-25 0 -54.5 -6.5t-55.5 -14.5t-42 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Itilde",
    unicode: "\u0128",
    horizAdvX: 342,
    d: "M216 342q0 -108 2 -167t4 -82.5l2 -23.5q2 -19 21 -26.5t64 -16.5l-3 -29q-31 2 -63 2.5t-70 0.5q-78 0 -141 -3l-3 29q45 9 66 16.5t23 26.5l2 23.5t4 83t2 166.5q0 108 -2 167.5t-4 83l-2 23.5q-2 19 -19.5 26.5t-62.5 16.5l3 29q32 -1 64.5 -2t69.5 -1q38 0 68.5 1 t61.5 2l3 -29q-45 -9 -62.5 -16.5t-19.5 -26.5l-2 -23.5t-4 -83t-2 -167.5zM309 893l26 -8q-15 -50 -34 -72.5t-40.5 -27t-44.5 2.5t-47 17t-47.5 15.5t-46 -1t-42.5 -34.5l-26 8q15 50 34 72.5t40.5 27t44.5 -2.5t47 -17t47.5 -15.5t46 1t42.5 34.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "itilde",
    unicode: "\u0129",
    horizAdvX: 275,
    d: "M161 459l19 -9q0 -13 -0.5 -40t-0.5 -59.5t-0.5 -65t-0.5 -56.5q0 -73 2.5 -112t5 -54l2.5 -15q1 -5 14.5 -10t30 -8t26.5 -4l-3 -29q-24 2 -56.5 2.5t-58.5 0.5q-25 0 -60 -0.5t-59 -2.5l3 29q11 1 27 4t29 8t14 10l2 15t4 54t2 112t-2 108.5t-4 47l-2 11.5l-64 19 l-2 26q18 0 42.5 2.5t48.5 7t41 8.5zM279 664l26 -8q-15 -50 -34 -72.5t-40.5 -27t-44.5 2.5t-47 17t-47.5 15.5t-46 -1t-42.5 -34.5l-26 8q15 50 34 72.5t40.5 27t44.5 -2.5t47 -17t47.5 -15.5t46 1t42.5 34.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Imacron",
    unicode: "\u012A",
    horizAdvX: 342,
    d: "M216 342q0 -108 2 -167t4 -82.5l2 -23.5q2 -19 21 -26.5t64 -16.5l-3 -29q-31 2 -63 2.5t-70 0.5q-78 0 -141 -3l-3 29q45 9 66 16.5t23 26.5l2 23.5t4 83t2 166.5q0 108 -2 167.5t-4 83l-2 23.5q-2 19 -19.5 26.5t-62.5 16.5l3 29q32 -1 64.5 -2t69.5 -1q38 0 68.5 1 t61.5 2l3 -29q-45 -9 -62.5 -16.5t-19.5 -26.5l-2 -23.5t-4 -83t-2 -167.5zM329 850l-39 -46q-34 2 -68.5 3t-69.5 1q-34 0 -68 -1t-69 -3l-8 16l39 46q38 -2 75 -3.5t74 -1.5q32 0 63.5 1t62.5 3z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "imacron",
    unicode: "\u012B",
    horizAdvX: 275,
    d: "M161 459l19 -9q0 -13 -0.5 -40t-0.5 -59.5t-0.5 -65t-0.5 -56.5q0 -73 2.5 -112t5 -54l2.5 -15q1 -5 14.5 -10t30 -8t26.5 -4l-3 -29q-24 2 -56.5 2.5t-58.5 0.5q-25 0 -60 -0.5t-59 -2.5l3 29q11 1 27 4t29 8t14 10l2 15t4 54t2 112t-2 108.5t-4 47l-2 11.5l-64 19 l-2 26q18 0 42.5 2.5t48.5 7t41 8.5zM299 618l-39 -46q-34 2 -68.5 3t-69.5 1q-34 0 -68 -1t-69 -3l-8 16l39 46q38 -2 75 -3.5t74 -1.5q32 0 63.5 1t62.5 3z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ibreve",
    unicode: "\u012C",
    horizAdvX: 342,
    d: "M216 342q0 -108 2 -167t4 -82.5l2 -23.5q2 -19 21 -26.5t64 -16.5l-3 -29q-31 2 -63 2.5t-70 0.5q-78 0 -141 -3l-3 29q45 9 66 16.5t23 26.5l2 23.5t4 83t2 166.5q0 108 -2 167.5t-4 83l-2 23.5q-2 19 -19.5 26.5t-62.5 16.5l3 29q32 -1 64.5 -2t69.5 -1q38 0 68.5 1 t61.5 2l3 -29q-45 -9 -62.5 -16.5t-19.5 -26.5l-2 -23.5t-4 -83t-2 -167.5zM42 891l37 5q5 -27 33 -40t59 -13q32 0 60 13t33 40l37 -5q-7 -54 -46 -81t-84 -27q-44 0 -82.5 27t-46.5 81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ibreve",
    unicode: "\u012D",
    horizAdvX: 275,
    d: "M161 459l19 -9q0 -13 -0.5 -40t-0.5 -59.5t-0.5 -65t-0.5 -56.5q0 -73 2.5 -112t5 -54l2.5 -15q1 -5 14.5 -10t30 -8t26.5 -4l-3 -29q-24 2 -56.5 2.5t-58.5 0.5q-25 0 -60 -0.5t-59 -2.5l3 29q11 1 27 4t29 8t14 10l2 15t4 54t2 112t-2 108.5t-4 47l-2 11.5l-64 19 l-2 26q18 0 42.5 2.5t48.5 7t41 8.5zM8 659l37 5q5 -27 33 -40t59 -13q32 0 60 13t33 40l37 -5q-7 -54 -46 -81t-84 -27q-44 0 -82.5 27t-46.5 81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iogonek",
    unicode: "\u012E",
    horizAdvX: 342,
    d: "M216 342q0 -108 2 -167t4 -82.5l2 -23.5q2 -19 21 -26.5t64 -16.5l-3 -29q-31 2 -63 2.5t-70 0.5q-78 0 -141 -3l-3 29q45 9 66 16.5t23 26.5l2 23.5t4 83t2 166.5q0 108 -2 167.5t-4 83l-2 23.5q-2 19 -19.5 26.5t-62.5 16.5l3 29q32 -1 64.5 -2t69.5 -1q38 0 68.5 1 t61.5 2l3 -29q-45 -9 -62.5 -16.5t-19.5 -26.5l-2 -23.5t-4 -83t-2 -167.5zM239 -144l6 -32q-41 -27 -87 -27q-42 0 -62.5 22.5t-20.5 54.5q0 29 15.5 59.5t47 55.5t79.5 37v-26q-46 -16 -61.5 -45t-15.5 -52q0 -29 16 -42.5t40 -13.5q21 0 43 9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iogonek",
    unicode: "\u012F",
    horizAdvX: 275,
    d: "M161 459l19 -9q0 -13 -0.5 -40t-0.5 -59.5t-0.5 -65t-0.5 -56.5q0 -73 2.5 -112t5 -54l2.5 -15q1 -5 14.5 -10t30 -8t26.5 -4l-3 -29q-24 2 -56.5 2.5t-58.5 0.5q-25 0 -60 -0.5t-59 -2.5l3 29q11 1 27 4t29 8t14 10l2 15t4 54t2 112t-2 108.5t-4 47l-2 11.5l-64 19 l-2 26q18 0 42.5 2.5t48.5 7t41 8.5zM138 563q-22 0 -37 15.5t-15 38.5q0 22 15 37t37 15t37 -15t15 -37q0 -23 -15 -38.5t-37 -15.5zM278 -147l6 -32q-41 -27 -87 -27q-42 0 -62.5 22.5t-20.5 54.5q0 29 15.5 59.5t47 55.5t79.5 37v-26q-46 -16 -61.5 -45t-15.5 -52 q0 -29 16 -42.5t40 -13.5q21 0 43 9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idotaccent",
    unicode: "\u0130",
    horizAdvX: 342,
    d: "M216 342q0 -108 2 -167t4 -82.5l2 -23.5q2 -19 21 -26.5t64 -16.5l-3 -29q-31 2 -63 2.5t-70 0.5q-78 0 -141 -3l-3 29q45 9 66 16.5t23 26.5l2 23.5t4 83t2 166.5q0 108 -2 167.5t-4 83l-2 23.5q-2 19 -19.5 26.5t-62.5 16.5l3 29q32 -1 64.5 -2t69.5 -1q38 0 68.5 1 t61.5 2l3 -29q-45 -9 -62.5 -16.5t-19.5 -26.5l-2 -23.5t-4 -83t-2 -167.5zM171 793q-22 0 -37 15.5t-15 38.5q0 22 15 37t37 15t37 -15t15 -37q0 -23 -15 -38.5t-37 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotlessi",
    unicode: "\u0131",
    horizAdvX: 275,
    d: "M161 459l19 -9q0 -13 -0.5 -40t-0.5 -59.5t-0.5 -65t-0.5 -56.5q0 -73 2.5 -112t5 -54l2.5 -15q1 -5 14.5 -10t30 -8t26.5 -4l-3 -29q-24 2 -56.5 2.5t-58.5 0.5q-25 0 -60 -0.5t-59 -2.5l3 29q11 1 27 4t29 8t14 10l2 15t4 54t2 112t-2 108.5t-4 47l-2 11.5l-64 19 l-2 26q18 0 42.5 2.5t48.5 7t41 8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "IJ",
    unicode: "\u0132",
    horizAdvX: 694,
    d: "M216 342q0 -108 2 -167t4 -82.5l2 -23.5q2 -19 21 -26.5t64 -16.5l-3 -29q-31 2 -63 2.5t-70 0.5q-78 0 -141 -3l-3 29q45 9 66 16.5t23 26.5l2 23.5t4 83t2 166.5q0 108 -2 167.5t-4 83l-2 23.5q-2 19 -19.5 26.5t-62.5 16.5l3 29q32 -1 64.5 -2t69.5 -1q38 0 68.5 1 t61.5 2l3 -29q-45 -9 -62.5 -16.5t-19.5 -26.5l-2 -23.5t-4 -83t-2 -167.5zM371 -178q-5 0 -18 11t-26 28t-18 34l16 20q10 -7 30 -13.5t39 -6.5q18 0 33 7.5t26.5 30t19.5 66.5t12 117.5t4 182.5q0 161 -4 239l-4 78q-2 19 -19.5 26.5t-62.5 16.5l3 29q32 -1 64.5 -2 t69.5 -1q38 0 68.5 1t61.5 2l3 -29q-45 -9 -64 -16.5t-21 -26.5l-1 -32t-1.5 -88t-1.5 -128t-1 -153q0 -97 -22 -171t-55 -123t-68.5 -74t-62.5 -25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ij",
    unicode: "\u0133",
    horizAdvX: 533,
    d: "M161 459l19 -9q0 -13 -0.5 -40t-0.5 -59.5t-0.5 -65t-0.5 -56.5q0 -73 2.5 -112t5 -54l2.5 -15q1 -5 14.5 -10t30 -8t26.5 -4l-3 -29q-24 2 -56.5 2.5t-58.5 0.5q-25 0 -60 -0.5t-59 -2.5l3 29q11 1 27 4t29 8t14 10l2 15t4 54t2 112t-2 108.5t-4 47l-2 11.5l-64 19 l-2 26q18 0 42.5 2.5t48.5 7t41 8.5zM138 563q-22 0 -37 15.5t-15 38.5q0 22 15 37t37 15t37 -15t15 -37q0 -23 -15 -38.5t-37 -15.5zM380 15q0 137 -2 221t-4 122l-2 38l-64 19l-2 26q18 0 42.5 2.5t48.5 7t41 8.5l19 -9l-0.5 -48t-1 -137t-0.5 -211q0 -79 -15 -134 t-37.5 -91t-46.5 -56t-42 -28t-24 -8q-5 0 -15.5 10.5t-20.5 27t-15 32.5l15 19q10 -6 26 -12.5t34 -6.5q16 0 31 15.5t25 60.5t10 132zM416 563q-22 0 -37 15.5t-15 38.5q0 22 15 37t37 15t37 -15t15 -37q0 -23 -15 -38.5t-37 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Jcircumflex",
    unicode: "\u0134",
    horizAdvX: 352,
    d: "M29 -178q-5 0 -18 11t-26 28t-18 34l16 20q10 -7 30 -13.5t39 -6.5q18 0 33 7.5t26.5 30t19.5 66.5t12 117.5t4 182.5q0 161 -4 239l-4 78q-2 19 -19.5 26.5t-62.5 16.5l3 29q32 -1 64.5 -2t69.5 -1q38 0 68.5 1t61.5 2l3 -29q-45 -9 -64 -16.5t-21 -26.5l-1 -32 t-1.5 -88t-1.5 -128t-1 -153q0 -97 -22 -171t-55 -123t-68.5 -74t-62.5 -25zM175 946h37l94 -194l-30 -5l-83 104l-82 -104l-30 5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "jcircumflex",
    unicode: "\u0135",
    horizAdvX: 258,
    d: "M105 15q0 137 -2 221t-4 122l-2 38l-64 19l-2 26q18 0 42.5 2.5t48.5 7t41 8.5l19 -9l-0.5 -48t-1 -137t-0.5 -211q0 -79 -15 -134t-37.5 -91t-46.5 -56t-42 -28t-24 -8q-5 0 -15.5 10.5t-20.5 27t-15 32.5l15 19q10 -6 26 -12.5t34 -6.5q16 0 31 15.5t25 60.5t10 132z M122 717h37l94 -194l-30 -5l-83 104l-82 -104l-30 5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0136",
    unicode: "\u0136",
    horizAdvX: 696,
    d: "M224 69q2 -19 21 -26.5t64 -16.5l-3 -29q-31 2 -63 2.5t-70 0.5q-78 0 -141 -3l-3 29q45 9 66 16.5t23 26.5l2 23.5t4 83t2 166.5q0 108 -2 167.5t-4 83l-2 23.5q-2 19 -19.5 26.5t-62.5 16.5l3 29q32 -1 64.5 -2t69.5 -1q38 0 68.5 1t61.5 2l3 -29q-45 -9 -62.5 -16.5 t-19.5 -26.5l-2 -22t-4 -76.5t-2 -152.5l264 253q4 3 4 7q0 19 -74 34l3 29l64 -2t69 -1q38 0 60.5 1t53.5 2l3 -29q-45 -9 -72 -21.5t-42 -26.5l-215 -204l278 -364l19 -6.5t64 -10.5l-3 -29q-24 0 -52.5 -1t-55 -2t-43 -2l-16.5 -1l-256 355l-53 -50q1 -88 2.5 -137.5 t3.5 -69.5zM284 -92q0 23 16 35t38 12q26 0 50 -20.5t24 -65.5q0 -39 -25 -74.5t-69 -59.5l-15 21q26 22 42.5 49.5t16.5 55.5v10t-2 10q-4 -7 -14 -11.5t-19 -4.5q-20 0 -31.5 13.5t-11.5 29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0137",
    unicode: "\u0137",
    horizAdvX: 517,
    d: "M517 26l-3 -29q-17 0 -43 -1t-50 -2.5t-36 -2.5l-185 258l-31 -23q2 -98 5 -137t3 -41q1 -5 12.5 -10t26.5 -8t25 -4l-3 -29q-24 2 -53 2.5t-55 0.5q-25 0 -56.5 -0.5t-55.5 -2.5l3 29q11 1 25 4t25.5 8t12.5 10l1.5 14.5t3 50t3 98t1.5 158.5q0 97 -1 156t-3 90t-3 41.5 l-1 10.5l-64 19l-2 26q18 0 42.5 2.5t48.5 7t41 8.5l19 -9l-1 -93t-1 -276v-80l160 120q7 6 7 12q0 8 -14 15t-46 8l3 29q21 -1 34 -1.5t27.5 -1t38.5 -0.5q37 0 58.5 1t52.5 2l3 -29q-41 -6 -65.5 -18t-40.5 -23l-124 -92l188 -251q9 -13 30 -14t37 -3zM195 -92q0 23 16 35 t38 12q26 0 50 -20.5t24 -65.5q0 -39 -25 -74.5t-69 -59.5l-15 21q26 22 42.5 49.5t16.5 55.5v10t-2 10q-4 -7 -14 -11.5t-19 -4.5q-20 0 -31.5 13.5t-11.5 29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "kgreenlandic",
    unicode: "\u0138",
    horizAdvX: 511,
    d: "M162 459l19 -9q0 -17 -0.5 -55t-1 -81t-0.5 -76l167 157q5 4 5 9t-10 11.5t-31 10.5l2 29q23 -1 44.5 -1.5t48.5 -0.5t44 0.5t39 1.5l2 -29q-31 -5 -49 -13.5t-29 -17.5l-140 -129l173 -232l12.5 -4t43.5 -6l-2 -29q-22 0 -50 -1t-49 -2l-21 -1l-163 225l-37 -35 q2 -79 6 -106l4 -27q1 -5 12 -10t24.5 -8t21.5 -4l-3 -29q-21 2 -50 2.5t-52 0.5q-25 0 -60 -0.5t-59 -2.5l3 29q11 1 27 4t29 8t14 10l2 15t4 54t2 112t-2 108.5t-4 47l-2 11.5l-64 19l-2 26q18 0 42.5 2.5t48.5 7t41 8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lacute",
    unicode: "\u0139",
    horizAdvX: 580,
    d: "M346 846l-227 -73l-24 19l212 125q18 -10 29.5 -27t11.5 -32q0 -3 -0.5 -6t-1.5 -6zM224 69q1 -10 16 -17.5t37.5 -11.5t43.5 -4q52 0 94 7t74 35.5t52 92.5l27 -12q-6 -18 -11 -49t-8.5 -61.5t-4.5 -48.5h-393q-37 0 -62.5 -0.5t-57.5 -2.5l-3 29q45 9 66 16.5t23 26.5 l2 23.5t4.5 82.5t2.5 167t-2 167.5t-4 83l-2 23.5q-2 19 -19.5 26.5t-62.5 16.5l3 29q32 -1 64.5 -2t69.5 -1q38 0 68.5 1t61.5 2l3 -29q-45 -9 -62.5 -16.5t-19.5 -26.5l-2 -23.5t-4 -83t-2 -167.5t2 -167t4 -82.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lacute",
    unicode: "\u013A",
    horizAdvX: 272,
    d: "M274 823l-227 -73l-24 19l212 125q18 -10 29.5 -27t11.5 -32q0 -3 -0.5 -6t-1.5 -6zM173 352q0 -90 1.5 -147t3.5 -90t3.5 -47.5t2.5 -19.5t14 -10t29.5 -8t26.5 -4l-3 -29q-24 2 -56 2.5t-58 0.5q-25 0 -59.5 -0.5t-58.5 -2.5l3 29q11 1 26.5 4t28.5 8t14 10l1 14.5 t2.5 50t2.5 98t1 159.5q0 96 -1 155t-3 90t-3 41.5l-1 10.5l-64 19l-2 26q18 0 42.5 2.5t48.5 7t41 8.5l19 -9l-1 -93t-1 -276z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni013B",
    unicode: "\u013B",
    horizAdvX: 580,
    d: "M224 69q1 -10 16 -17.5t37.5 -11.5t43.5 -4q52 0 94 7t74 35.5t52 92.5l27 -12q-6 -18 -11 -49t-8.5 -61.5t-4.5 -48.5h-393q-37 0 -62.5 -0.5t-57.5 -2.5l-3 29q45 9 66 16.5t23 26.5l2 23.5t4.5 82.5t2.5 167t-2 167.5t-4 83l-2 23.5q-2 19 -19.5 26.5t-62.5 16.5l3 29 q32 -1 64.5 -2t69.5 -1q38 0 68.5 1t61.5 2l3 -29q-45 -9 -62.5 -16.5t-19.5 -26.5l-2 -23.5t-4 -83t-2 -167.5t2 -167t4 -82.5zM226 -92q0 23 16 35t38 12q26 0 50 -20.5t24 -65.5q0 -39 -25 -74.5t-69 -59.5l-15 21q26 22 42.5 49.5t16.5 55.5v10t-2 10q-4 -7 -14 -11.5 t-19 -4.5q-20 0 -31.5 13.5t-11.5 29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni013C",
    unicode: "\u013C",
    horizAdvX: 272,
    d: "M173 352q0 -90 1.5 -147t3.5 -90t3.5 -47.5t2.5 -19.5t14 -10t29.5 -8t26.5 -4l-3 -29q-24 2 -56 2.5t-58 0.5q-25 0 -59.5 -0.5t-58.5 -2.5l3 29q11 1 26.5 4t28.5 8t14 10l1 14.5t2.5 50t2.5 98t1 159.5q0 96 -1 155t-3 90t-3 41.5l-1 10.5l-64 19l-2 26q18 0 42.5 2.5 t48.5 7t41 8.5l19 -9l-1 -93t-1 -276zM72 -92q0 23 16 35t38 12q26 0 50 -20.5t24 -65.5q0 -39 -25 -74.5t-69 -59.5l-15 21q26 22 42.5 49.5t16.5 55.5v10t-2 10q-4 -7 -14 -11.5t-19 -4.5q-20 0 -31.5 13.5t-11.5 29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lcaron",
    unicode: "\u013D",
    horizAdvX: 580,
    d: "M224 69q1 -10 16 -17.5t37.5 -11.5t43.5 -4q52 0 94 7t74 35.5t52 92.5l27 -12q-6 -18 -11 -49t-8.5 -61.5t-4.5 -48.5h-393q-37 0 -62.5 -0.5t-57.5 -2.5l-3 29q45 9 66 16.5t23 26.5l2 23.5t4.5 82.5t2.5 167t-2 167.5t-4 83l-2 23.5q-2 19 -19.5 26.5t-62.5 16.5l3 29 q32 -1 64.5 -2t69.5 -1q38 0 68.5 1t61.5 2l3 -29q-45 -9 -62.5 -16.5t-19.5 -26.5l-2 -23.5t-4 -83t-2 -167.5t2 -167t4 -82.5zM339 708q0 23 16 35t38 12q26 0 50 -20.5t24 -65.5q0 -39 -25 -74.5t-69 -59.5l-15 21q26 22 42.5 49.5t16.5 55.5v10t-2 10q-4 -7 -14 -11.5 t-19 -4.5q-20 0 -31.5 13.5t-11.5 29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lcaron",
    unicode: "\u013E",
    horizAdvX: 272,
    d: "M173 352q0 -90 1.5 -147t3.5 -90t3.5 -47.5t2.5 -19.5t14 -10t29.5 -8t26.5 -4l-3 -29q-24 2 -56 2.5t-58 0.5q-25 0 -59.5 -0.5t-58.5 -2.5l3 29q11 1 26.5 4t28.5 8t14 10l1 14.5t2.5 50t2.5 98t1 159.5q0 96 -1 155t-3 90t-3 41.5l-1 10.5l-64 19l-2 26q18 0 42.5 2.5 t48.5 7t41 8.5l19 -9l-1 -93t-1 -276zM201 708q0 23 16 35t38 12q26 0 50 -20.5t24 -65.5q0 -39 -25 -74.5t-69 -59.5l-15 21q26 22 42.5 49.5t16.5 55.5v10t-2 10q-4 -7 -14 -11.5t-19 -4.5q-20 0 -31.5 13.5t-11.5 29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ldot",
    unicode: "\u013F",
    horizAdvX: 580,
    d: "M224 69q1 -10 16 -17.5t37.5 -11.5t43.5 -4q52 0 94 7t74 35.5t52 92.5l27 -12q-6 -18 -11 -49t-8.5 -61.5t-4.5 -48.5h-393q-37 0 -62.5 -0.5t-57.5 -2.5l-3 29q45 9 66 16.5t23 26.5l2 23.5t4.5 82.5t2.5 167t-2 167.5t-4 83l-2 23.5q-2 19 -19.5 26.5t-62.5 16.5l3 29 q32 -1 64.5 -2t69.5 -1q38 0 68.5 1t61.5 2l3 -29q-45 -9 -62.5 -16.5t-19.5 -26.5l-2 -23.5t-4 -83t-2 -167.5t2 -167t4 -82.5zM356 294q-22 0 -37 15t-15 40q0 23 15 37.5t37 14.5t37.5 -14.5t15.5 -37.5q0 -25 -15.5 -40t-37.5 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ldot",
    unicode: "\u0140",
    horizAdvX: 272,
    d: "M173 352q0 -90 1.5 -147t3.5 -90t3.5 -47.5t2.5 -19.5t14 -10t29.5 -8t26.5 -4l-3 -29q-24 2 -56 2.5t-58 0.5q-25 0 -59.5 -0.5t-58.5 -2.5l3 29q11 1 26.5 4t28.5 8t14 10l1 14.5t2.5 50t2.5 98t1 159.5q0 96 -1 155t-3 90t-3 41.5l-1 10.5l-64 19l-2 26q18 0 42.5 2.5 t48.5 7t41 8.5l19 -9l-1 -93t-1 -276zM251 294q-22 0 -37 15t-15 40q0 23 15 37.5t37 14.5t37.5 -14.5t15.5 -37.5q0 -25 -15.5 -40t-37.5 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lslash",
    unicode: "\u0141",
    horizAdvX: 580,
    d: "M224 69q1 -10 16 -17.5t37.5 -11.5t43.5 -4q52 0 94 7t74 35.5t52 92.5l27 -12q-6 -18 -11 -49t-8.5 -61.5t-4.5 -48.5h-393q-37 0 -62.5 -0.5t-57.5 -2.5l-3 29q45 9 66 16.5t23 26.5l2 17t4 59.5t3 118.5l-88 -64v61l88 64v17q0 108 -2 167.5t-4 83l-2 23.5 q-2 19 -19.5 26.5t-62.5 16.5l3 29q32 -1 64.5 -2t69.5 -1q38 0 68.5 1t61.5 2l3 -29q-45 -9 -62.5 -16.5t-19.5 -26.5l-1.5 -19.5t-3.5 -68.5t-3 -137l204 149v-61l-204 -149q0 -103 2 -159.5t4 -79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lslash",
    unicode: "\u0142",
    horizAdvX: 272,
    d: "M173 352q0 -90 1.5 -147t3.5 -90t3.5 -47.5t2.5 -19.5t14 -10t29.5 -8t26.5 -4l-3 -29q-24 2 -56 2.5t-58 0.5q-25 0 -59.5 -0.5t-58.5 -2.5l3 29q11 1 26.5 4t28.5 7.5t14 10.5l1.5 22.5t3 80.5t2.5 164l-73 -53v57l73 53q0 96 -1 154.5t-3 89t-3 41l-1 10.5l-64 19 l-2 26q18 0 42.5 2.5t48.5 7t41 8.5l19 -9l-1 -74t-1 -220l77 56v-57l-77 -56v-18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Nacute",
    unicode: "\u0143",
    horizAdvX: 785,
    d: "M603 132h5q2 42 2 96v114q0 108 -2.5 167.5t-4.5 83l-2 23.5q-2 19 -25.5 26.5t-68.5 16.5l3 29q32 -1 68.5 -2t73.5 -1q25 0 41 0.5t30.5 1t35.5 1.5l3 -29q-45 -9 -62.5 -16.5t-19.5 -26.5l-2.5 -23.5t-5 -83t-2.5 -167.5q0 -161 5.5 -251.5l5.5 -90.5l-80 -9l-406 546 h-5q-1 -33 -2.5 -82t-1.5 -113q0 -108 3 -167t5.5 -82.5l2.5 -23.5q2 -19 25.5 -26.5t68.5 -16.5l-3 -29q-31 2 -67.5 2.5t-74.5 0.5q-37 0 -63.5 -0.5t-58.5 -2.5l-3 29q45 8 70 16t27 27l2 23.5t4 82.5t2 167t-2 167.5t-4 83l-2 23.5q-2 19 -19.5 26.5t-62.5 16.5l3 29 q32 -1 72 -2t77 -1zM544 909l-173 -162l-30 5l134 199q25 0 46 -12.5t23 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nacute",
    unicode: "\u0144",
    horizAdvX: 560,
    d: "M155 459l19 -9v-48q21 12 53 25.5t69 23t71 9.5q43 0 72.5 -20.5t29.5 -74.5v-136q0 -73 2.5 -112t5 -54l2.5 -15q1 -5 12.5 -10t26.5 -8t25 -4l-3 -29q-24 2 -53 2.5t-55 0.5q-25 0 -56.5 -0.5t-55.5 -2.5l3 29q11 1 25 4t25.5 8t12.5 10l2 15t4 54t2 112v105 q0 37 -21.5 50.5t-53.5 13.5q-25 0 -52.5 -6.5t-52.5 -14.5t-41 -15q0 -25 -0.5 -57t-0.5 -76q0 -73 2.5 -112t5 -54l2.5 -15q1 -5 12.5 -10t26.5 -8t25 -4l-3 -29q-24 2 -53 2.5t-55 0.5q-25 0 -56.5 -0.5t-55.5 -2.5l3 29q11 1 25 4t25.5 8t12.5 10l2 15t4 54t2 112 t-2 108.5t-4 47l-2 11.5l-64 19l-2 26q18 0 42.5 2.5t48.5 7t41 8.5zM426 680l-173 -162l-30 5l134 199q25 0 46 -12.5t23 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0145",
    unicode: "\u0145",
    horizAdvX: 785,
    d: "M603 132h5q2 42 2 96v114q0 108 -2.5 167.5t-4.5 83l-2 23.5q-2 19 -25.5 26.5t-68.5 16.5l3 29q32 -1 68.5 -2t73.5 -1q25 0 41 0.5t30.5 1t35.5 1.5l3 -29q-45 -9 -62.5 -16.5t-19.5 -26.5l-2.5 -23.5t-5 -83t-2.5 -167.5q0 -161 5.5 -251.5l5.5 -90.5l-80 -9l-406 546 h-5q-1 -33 -2.5 -82t-1.5 -113q0 -108 3 -167t5.5 -82.5l2.5 -23.5q2 -19 25.5 -26.5t68.5 -16.5l-3 -29q-31 2 -67.5 2.5t-74.5 0.5q-37 0 -63.5 -0.5t-58.5 -2.5l-3 29q45 8 70 16t27 27l2 23.5t4 82.5t2 167t-2 167.5t-4 83l-2 23.5q-2 19 -19.5 26.5t-62.5 16.5l3 29 q32 -1 72 -2t77 -1zM341 -92q0 23 16 35t38 12q26 0 50 -20.5t24 -65.5q0 -39 -25 -74.5t-69 -59.5l-15 21q26 22 42.5 49.5t16.5 55.5v10t-2 10q-4 -7 -14 -11.5t-19 -4.5q-20 0 -31.5 13.5t-11.5 29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0146",
    unicode: "\u0146",
    horizAdvX: 560,
    d: "M155 459l19 -9v-48q21 12 53 25.5t69 23t71 9.5q43 0 72.5 -20.5t29.5 -74.5v-136q0 -73 2.5 -112t5 -54l2.5 -15q1 -5 12.5 -10t26.5 -8t25 -4l-3 -29q-24 2 -53 2.5t-55 0.5q-25 0 -56.5 -0.5t-55.5 -2.5l3 29q11 1 25 4t25.5 8t12.5 10l2 15t4 54t2 112v105 q0 37 -21.5 50.5t-53.5 13.5q-25 0 -52.5 -6.5t-52.5 -14.5t-41 -15q0 -25 -0.5 -57t-0.5 -76q0 -73 2.5 -112t5 -54l2.5 -15q1 -5 12.5 -10t26.5 -8t25 -4l-3 -29q-24 2 -53 2.5t-55 0.5q-25 0 -56.5 -0.5t-55.5 -2.5l3 29q11 1 25 4t25.5 8t12.5 10l2 15t4 54t2 112 t-2 108.5t-4 47l-2 11.5l-64 19l-2 26q18 0 42.5 2.5t48.5 7t41 8.5zM216 -92q0 23 16 35t38 12q26 0 50 -20.5t24 -65.5q0 -39 -25 -74.5t-69 -59.5l-15 21q26 22 42.5 49.5t16.5 55.5v10t-2 10q-4 -7 -14 -11.5t-19 -4.5q-20 0 -31.5 13.5t-11.5 29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ncaron",
    unicode: "\u0147",
    horizAdvX: 785,
    d: "M603 132h5q2 42 2 96v114q0 108 -2.5 167.5t-4.5 83l-2 23.5q-2 19 -25.5 26.5t-68.5 16.5l3 29q32 -1 68.5 -2t73.5 -1q25 0 41 0.5t30.5 1t35.5 1.5l3 -29q-45 -9 -62.5 -16.5t-19.5 -26.5l-2.5 -23.5t-5 -83t-2.5 -167.5q0 -161 5.5 -251.5l5.5 -90.5l-80 -9l-406 546 h-5q-1 -33 -2.5 -82t-1.5 -113q0 -108 3 -167t5.5 -82.5l2.5 -23.5q2 -19 25.5 -26.5t68.5 -16.5l-3 -29q-31 2 -67.5 2.5t-74.5 0.5q-37 0 -63.5 -0.5t-58.5 -2.5l-3 29q45 8 70 16t27 27l2 23.5t4 82.5t2 167t-2 167.5t-4 83l-2 23.5q-2 19 -19.5 26.5t-62.5 16.5l3 29 q32 -1 72 -2t77 -1zM431 752h-37l-104 195l30 5l92 -114l93 114l30 -5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ncaron",
    unicode: "\u0148",
    horizAdvX: 560,
    d: "M155 459l19 -9v-48q21 12 53 25.5t69 23t71 9.5q43 0 72.5 -20.5t29.5 -74.5v-136q0 -73 2.5 -112t5 -54l2.5 -15q1 -5 12.5 -10t26.5 -8t25 -4l-3 -29q-24 2 -53 2.5t-55 0.5q-25 0 -56.5 -0.5t-55.5 -2.5l3 29q11 1 25 4t25.5 8t12.5 10l2 15t4 54t2 112v105 q0 37 -21.5 50.5t-53.5 13.5q-25 0 -52.5 -6.5t-52.5 -14.5t-41 -15q0 -25 -0.5 -57t-0.5 -76q0 -73 2.5 -112t5 -54l2.5 -15q1 -5 12.5 -10t26.5 -8t25 -4l-3 -29q-24 2 -53 2.5t-55 0.5q-25 0 -56.5 -0.5t-55.5 -2.5l3 29q11 1 25 4t25.5 8t12.5 10l2 15t4 54t2 112 t-2 108.5t-4 47l-2 11.5l-64 19l-2 26q18 0 42.5 2.5t48.5 7t41 8.5zM298 522h-37l-104 195l30 5l92 -114l93 114l30 -5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "napostrophe",
    unicode: "\u0149",
    horizAdvX: 560,
    d: "M71 657q0 23 16 35t38 12q26 0 50 -20.5t24 -65.5q0 -39 -25 -74.5t-69 -59.5l-15 21q26 22 42.5 49.5t16.5 55.5v10t-2 10q-4 -7 -14 -11.5t-19 -4.5q-20 0 -31.5 13.5t-11.5 29.5zM155 459l19 -9v-48q21 12 53 25.5t69 23t71 9.5q43 0 72.5 -20.5t29.5 -74.5v-136 q0 -73 2.5 -112t5 -54l2.5 -15q1 -5 12.5 -10t26.5 -8t25 -4l-3 -29q-24 2 -53 2.5t-55 0.5q-25 0 -56.5 -0.5t-55.5 -2.5l3 29q11 1 25 4t25.5 8t12.5 10l2 15t4 54t2 112v105q0 37 -21.5 50.5t-53.5 13.5q-25 0 -52.5 -6.5t-52.5 -14.5t-41 -15q0 -25 -0.5 -57t-0.5 -76 q0 -73 2.5 -112t5 -54l2.5 -15q1 -5 12.5 -10t26.5 -8t25 -4l-3 -29q-24 2 -53 2.5t-55 0.5q-25 0 -56.5 -0.5t-55.5 -2.5l3 29q11 1 25 4t25.5 8t12.5 10l2 15t4 54t2 112t-2 108.5t-4 47l-2 11.5l-64 19l-2 26q18 0 42.5 2.5t48.5 7t41 8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eng",
    unicode: "\u014A",
    horizAdvX: 785,
    d: "M591 7l-396 530h-5q-1 -33 -2.5 -82t-1.5 -113q0 -108 3 -167t5.5 -82.5l2.5 -23.5q2 -19 25.5 -26.5t68.5 -16.5l-3 -29q-31 2 -67.5 2.5t-74.5 0.5q-37 0 -63.5 -0.5t-58.5 -2.5l-3 29q45 8 70 16t27 27l2 23.5t4 82.5t2 167t-2 167.5t-4 83l-2 23.5q-2 19 -19.5 26.5 t-62.5 16.5l3 29q32 -1 72 -2t77 -1l415 -553h5q2 42 2 96v114q0 108 -2.5 167.5t-4.5 83l-2 23.5q-2 19 -25.5 26.5t-68.5 16.5l3 29q32 -1 68.5 -2t73.5 -1q25 0 41 0.5t30.5 1t35.5 1.5l3 -29q-45 -9 -62.5 -16.5t-19.5 -26.5l-2.5 -23.5t-5 -83t-2.5 -167.5v-342 q0 -79 -13.5 -128.5t-34.5 -77.5t-43 -40t-39 -14.5t-23 -2.5q-5 0 -15.5 10.5t-20.5 27t-15 32.5l15 19q10 -6 26 -12.5t34 -6.5q20 0 36.5 17.5t27 45t10.5 58.5q0 20 -5.5 41t-18.5 38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eng",
    unicode: "\u014B",
    horizAdvX: 547,
    d: "M471 365v-311q0 -79 -15 -134t-38 -91t-47 -56t-43 -28t-25 -8q-5 0 -15.5 10.5t-20.5 27t-15 32.5l15 19q10 -6 26 -12.5t34 -6.5q16 0 31.5 15.5t25.5 60.5t10 132v319q0 37 -21.5 50.5t-53.5 13.5q-25 0 -52.5 -6.5t-52.5 -14.5t-41 -15q0 -25 -0.5 -57t-0.5 -76 q0 -73 2.5 -112t5 -54l2.5 -15q1 -5 12.5 -10t26.5 -8t25 -4l-3 -29q-24 2 -53 2.5t-55 0.5q-25 0 -56.5 -0.5t-55.5 -2.5l3 29q11 1 25 4t25.5 8t12.5 10l2 15t4 54t2 112t-2 108.5t-4 47l-2 11.5l-64 19l-2 26q18 0 42.5 2.5t48.5 7t41 8.5l19 -9v-48q21 12 53 25.5t69 23 t71 9.5q43 0 73.5 -20.5t30.5 -74.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omacron",
    unicode: "\u014C",
    horizAdvX: 786,
    d: "M737 369q0 -72 -20.5 -141t-64 -124t-113 -87.5t-167.5 -32.5q-113 0 -184.5 42t-105 116.5t-33.5 171.5q0 72 20.5 140.5t64 123.5t113 87.5t167.5 32.5q114 0 185 -41.5t104.5 -115.5t33.5 -172zM632 312q0 65 -10 125t-35.5 108.5t-71 76.5t-117.5 28 q-61 0 -103.5 -22.5t-70 -58t-43 -76.5t-21.5 -79t-6 -64q0 -62 11.5 -119t38.5 -102t72 -71t112 -26q55 0 96.5 19.5t69.5 51.5t45.5 69.5t25 74t7.5 65.5zM551 850l-39 -46q-34 2 -68.5 3t-69.5 1q-34 0 -68 -1t-69 -3l-8 16l39 46q38 -2 75 -3.5t74 -1.5q32 0 63.5 1 t62.5 3z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "omacron",
    unicode: "\u014D",
    horizAdvX: 529,
    d: "M490 243q0 -48 -13.5 -93t-41.5 -81t-73.5 -57t-110.5 -21q-112 0 -162 59.5t-50 155.5q0 48 13.5 93t41.5 81.5t74 58t110 21.5q75 0 121.5 -27.5t68.5 -76.5t22 -113zM404 206q0 51 -11.5 98t-41 77t-84.5 30q-44 0 -72 -20.5t-43 -50.5t-21 -60t-6 -50q0 -49 13 -92.5 t43 -71t81 -27.5q40 0 67.5 17.5t44 44.5t23.5 55.5t7 49.5zM435 618l-39 -46q-34 2 -68.5 3t-69.5 1q-34 0 -68 -1t-69 -3l-8 16l39 46q38 -2 75 -3.5t74 -1.5q32 0 63.5 1t62.5 3z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Obreve",
    unicode: "\u014E",
    horizAdvX: 786,
    d: "M737 369q0 -72 -20.5 -141t-64 -124t-113 -87.5t-167.5 -32.5q-113 0 -184.5 42t-105 116.5t-33.5 171.5q0 72 20.5 140.5t64 123.5t113 87.5t167.5 32.5q114 0 185 -41.5t104.5 -115.5t33.5 -172zM632 312q0 65 -10 125t-35.5 108.5t-71 76.5t-117.5 28 q-61 0 -103.5 -22.5t-70 -58t-43 -76.5t-21.5 -79t-6 -64q0 -62 11.5 -119t38.5 -102t72 -71t112 -26q55 0 96.5 19.5t69.5 51.5t45.5 69.5t25 74t7.5 65.5zM264 891l37 5q5 -27 33 -40t59 -13q32 0 60 13t33 40l37 -5q-7 -54 -46 -81t-84 -27q-44 0 -82.5 27t-46.5 81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "obreve",
    unicode: "\u014F",
    horizAdvX: 529,
    d: "M490 243q0 -48 -13.5 -93t-41.5 -81t-73.5 -57t-110.5 -21q-112 0 -162 59.5t-50 155.5q0 48 13.5 93t41.5 81.5t74 58t110 21.5q75 0 121.5 -27.5t68.5 -76.5t22 -113zM404 206q0 51 -11.5 98t-41 77t-84.5 30q-44 0 -72 -20.5t-43 -50.5t-21 -60t-6 -50q0 -49 13 -92.5 t43 -71t81 -27.5q40 0 67.5 17.5t44 44.5t23.5 55.5t7 49.5zM144 659l37 5q5 -27 33 -40t59 -13q32 0 60 13t33 40l37 -5q-7 -54 -46 -81t-84 -27q-44 0 -82.5 27t-46.5 81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ohungarumlaut",
    unicode: "\u0150",
    horizAdvX: 786,
    d: "M737 369q0 -72 -20.5 -141t-64 -124t-113 -87.5t-167.5 -32.5q-113 0 -184.5 42t-105 116.5t-33.5 171.5q0 72 20.5 140.5t64 123.5t113 87.5t167.5 32.5q114 0 185 -41.5t104.5 -115.5t33.5 -172zM632 312q0 65 -10 125t-35.5 108.5t-71 76.5t-117.5 28 q-61 0 -103.5 -22.5t-70 -58t-43 -76.5t-21.5 -79t-6 -64q0 -62 11.5 -119t38.5 -102t72 -71t112 -26q55 0 96.5 19.5t69.5 51.5t45.5 69.5t25 74t7.5 65.5zM639 912l-173 -162l-30 5l134 199q25 0 46 -12.5t23 -29.5zM468 912l-173 -162l-30 5l134 199q25 0 46 -12.5 t23 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ohungarumlaut",
    unicode: "\u0151",
    horizAdvX: 529,
    d: "M490 243q0 -48 -13.5 -93t-41.5 -81t-73.5 -57t-110.5 -21q-112 0 -162 59.5t-50 155.5q0 48 13.5 93t41.5 81.5t74 58t110 21.5q75 0 121.5 -27.5t68.5 -76.5t22 -113zM404 206q0 51 -11.5 98t-41 77t-84.5 30q-44 0 -72 -20.5t-43 -50.5t-21 -60t-6 -50q0 -49 13 -92.5 t43 -71t81 -27.5q40 0 67.5 17.5t44 44.5t23.5 55.5t7 49.5zM518 680l-173 -162l-30 5l134 199q25 0 46 -12.5t23 -29.5zM347 680l-173 -162l-30 5l134 199q25 0 46 -12.5t23 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "OE",
    unicode: "\u0152",
    horizAdvX: 983,
    d: "M372 -12q-113 0 -184.5 41.5t-105 115t-33.5 169.5q0 72 20.5 138.5t64 120t113 84.5t167.5 31q52 -3 118 -4.5t133 -1.5q71 0 134.5 2.5t106.5 6.5v-15q0 -21 1.5 -49.5t4.5 -54.5t6 -43l-27 -12q-15 47 -31.5 72.5t-41.5 37t-64.5 14t-100.5 2.5q-22 0 -36 -4t-16 -18 l-2.5 -24t-5 -79.5t-3.5 -150.5q32 0 64 1t58 2.5t38 4.5q19 5 26 21.5t17 66.5l35 -4q-4 -28 -6 -55.5t-2 -56.5q0 -28 2 -56t6 -55l-35 -5q-10 50 -17 67t-26 21q-12 3 -38 4.5t-58 2.5t-64 1q0 -103 3 -159t5.5 -78l2.5 -22q5 -18 37 -25t64 -7q52 0 94 7t74 35.5 t52 92.5l27 -12q-6 -18 -11 -49t-8.5 -61.5t-4.5 -48.5q-110 0 -186 -1t-128.5 -3t-90.5 -4t-72.5 -3t-75.5 -1zM395 32q38 0 66 9t30 28l2 23.5t4.5 82.5t2.5 167t-2 167.5t-4 83l-2 23.5q-2 18 -24 24t-58 6q-60 0 -104 -20.5t-73 -53.5t-46.5 -72.5t-25 -78.5t-7.5 -71 q0 -58 13 -114.5t41.5 -102.5t74.5 -73.5t112 -27.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oe",
    unicode: "\u0153",
    horizAdvX: 824,
    d: "M641 460q36 0 71 -17t58 -54.5t23 -99.5l-34 -41q-4 1 -13.5 1h-23.5q-25 0 -58.5 -0.5t-68 -1.5t-63 -2.5t-42.5 -2.5v-9q0 -48 16.5 -89t49.5 -66t84 -25q38 0 72.5 10t55.5 20l12 -30q-31 -26 -72 -44t-92 -18q-64 0 -108 23t-70 60q-28 -37 -74 -60t-113 -23 q-112 0 -162 59.5t-50 155.5q0 48 13.5 93t41.5 81t74 57.5t110 21.5q65 0 108.5 -21t68.5 -59q29 36 75 58.5t111 22.5zM408 206q0 35 -6 71t-21 66.5t-42 49t-69 18.5q-46 0 -74 -20.5t-43 -50.5t-20.5 -60t-5.5 -50q0 -45 12.5 -89t42.5 -73t83 -29q42 0 69 17.5t43 44.5 t23 55.5t8 49.5zM703 320q0 34 -13.5 53.5t-33 28.5t-37.5 9q-49 0 -81 -38.5t-43 -89.5l205 8q3 15 3 29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Racute",
    unicode: "\u0154",
    horizAdvX: 668,
    d: "M227 69q2 -19 21.5 -26.5t65.5 -16.5l-3 -29q-32 2 -65 2.5t-72 0.5q-79 0 -142 -3l-3 29q45 9 66 16.5t23 26.5l2 23.5t4 83t2 166.5q0 108 -2 167.5t-4 83l-2 23.5q-2 19 -19.5 26.5t-62.5 16.5l3 29q32 -1 64.5 -2t69.5 -1h173q68 0 112 -22.5t65 -59t21 -78.5 q0 -51 -29 -101t-106 -88l176 -293l19 -6.5t64 -10.5l-3 -29q-24 0 -53 -1t-55.5 -2t-43.5 -2l-17 -1l-177 331q-13 -1 -33 -1.5t-70 -0.5q0 -81 1.5 -130.5t4 -75.5t4 -35.5zM373 369q37 23 58.5 63.5t21.5 92.5q0 57 -41.5 87.5t-124.5 30.5q-36 0 -46.5 -4t-14.5 -18 l-2.5 -23.5t-5 -80.5t-2.5 -158q110 0 157 10zM465 909l-173 -162l-30 5l134 199q25 0 46 -12.5t23 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "racute",
    unicode: "\u0155",
    horizAdvX: 377,
    d: "M160 459l19 -9q-1 -11 -1.5 -33.5t-0.5 -48.5q22 37 51.5 58t55 30.5t35.5 9.5q5 0 15.5 -10.5t21 -26.5t14.5 -33l-15 -19q-13 5 -31 9.5t-38 4.5q-26 0 -51 -12.5t-41.5 -42t-16.5 -82.5q0 -82 1.5 -124.5t4 -58.5t3.5 -22q2 -8 30 -14.5t56 -8.5l-3 -29q-16 1 -40 1.5 l-48 1t-41 0.5q-25 0 -57.5 -0.5t-56.5 -2.5l3 29q11 1 25.5 4t26.5 8t13 10l2 15t4 54t2 112t-2 108.5t-4 47l-2 11.5l-64 19l-2 26q18 0 42.5 2.5t48.5 7t41 8.5zM355 680l-173 -162l-30 5l134 199q25 0 46 -12.5t23 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0156",
    unicode: "\u0156",
    horizAdvX: 668,
    d: "M227 69q2 -19 21.5 -26.5t65.5 -16.5l-3 -29q-32 2 -65 2.5t-72 0.5q-79 0 -142 -3l-3 29q45 9 66 16.5t23 26.5l2 23.5t4 83t2 166.5q0 108 -2 167.5t-4 83l-2 23.5q-2 19 -19.5 26.5t-62.5 16.5l3 29q32 -1 64.5 -2t69.5 -1h173q68 0 112 -22.5t65 -59t21 -78.5 q0 -51 -29 -101t-106 -88l176 -293l19 -6.5t64 -10.5l-3 -29q-24 0 -53 -1t-55.5 -2t-43.5 -2l-17 -1l-177 331q-13 -1 -33 -1.5t-70 -0.5q0 -81 1.5 -130.5t4 -75.5t4 -35.5zM373 369q37 23 58.5 63.5t21.5 92.5q0 57 -41.5 87.5t-124.5 30.5q-36 0 -46.5 -4t-14.5 -18 l-2.5 -23.5t-5 -80.5t-2.5 -158q110 0 157 10zM270 -92q0 23 16 35t38 12q26 0 50 -20.5t24 -65.5q0 -39 -25 -74.5t-69 -59.5l-15 21q26 22 42.5 49.5t16.5 55.5v10t-2 10q-4 -7 -14 -11.5t-19 -4.5q-20 0 -31.5 13.5t-11.5 29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0157",
    unicode: "\u0157",
    horizAdvX: 377,
    d: "M160 459l19 -9q-1 -11 -1.5 -33.5t-0.5 -48.5q22 37 51.5 58t55 30.5t35.5 9.5q5 0 15.5 -10.5t21 -26.5t14.5 -33l-15 -19q-13 5 -31 9.5t-38 4.5q-26 0 -51 -12.5t-41.5 -42t-16.5 -82.5q0 -82 1.5 -124.5t4 -58.5t3.5 -22q2 -8 30 -14.5t56 -8.5l-3 -29q-16 1 -40 1.5 l-48 1t-41 0.5q-25 0 -57.5 -0.5t-56.5 -2.5l3 29q11 1 25.5 4t26.5 8t13 10l2 15t4 54t2 112t-2 108.5t-4 47l-2 11.5l-64 19l-2 26q18 0 42.5 2.5t48.5 7t41 8.5zM79 -92q0 23 16 35t38 12q26 0 50 -20.5t24 -65.5q0 -39 -25 -74.5t-69 -59.5l-15 21q26 22 42.5 49.5 t16.5 55.5v10t-2 10q-4 -7 -14 -11.5t-19 -4.5q-20 0 -31.5 13.5t-11.5 29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rcaron",
    unicode: "\u0158",
    horizAdvX: 668,
    d: "M227 69q2 -19 21.5 -26.5t65.5 -16.5l-3 -29q-32 2 -65 2.5t-72 0.5q-79 0 -142 -3l-3 29q45 9 66 16.5t23 26.5l2 23.5t4 83t2 166.5q0 108 -2 167.5t-4 83l-2 23.5q-2 19 -19.5 26.5t-62.5 16.5l3 29q32 -1 64.5 -2t69.5 -1h173q68 0 112 -22.5t65 -59t21 -78.5 q0 -51 -29 -101t-106 -88l176 -293l19 -6.5t64 -10.5l-3 -29q-24 0 -53 -1t-55.5 -2t-43.5 -2l-17 -1l-177 331q-13 -1 -33 -1.5t-70 -0.5q0 -81 1.5 -130.5t4 -75.5t4 -35.5zM373 369q37 23 58.5 63.5t21.5 92.5q0 57 -41.5 87.5t-124.5 30.5q-36 0 -46.5 -4t-14.5 -18 l-2.5 -23.5t-5 -80.5t-2.5 -158q110 0 157 10zM352 752h-37l-104 195l30 5l92 -114l93 114l30 -5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rcaron",
    unicode: "\u0159",
    horizAdvX: 377,
    d: "M160 459l19 -9q-1 -11 -1.5 -33.5t-0.5 -48.5q22 37 51.5 58t55 30.5t35.5 9.5q5 0 15.5 -10.5t21 -26.5t14.5 -33l-15 -19q-13 5 -31 9.5t-38 4.5q-26 0 -51 -12.5t-41.5 -42t-16.5 -82.5q0 -82 1.5 -124.5t4 -58.5t3.5 -22q2 -8 30 -14.5t56 -8.5l-3 -29q-16 1 -40 1.5 l-48 1t-41 0.5q-25 0 -57.5 -0.5t-56.5 -2.5l3 29q11 1 25.5 4t26.5 8t13 10l2 15t4 54t2 112t-2 108.5t-4 47l-2 11.5l-64 19l-2 26q18 0 42.5 2.5t48.5 7t41 8.5zM227 522h-37l-104 195l30 5l92 -114l93 114l30 -5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Sacute",
    unicode: "\u015A",
    horizAdvX: 528,
    d: "M443 529l-27 -12q-21 77 -57.5 102t-92.5 25q-58 0 -86.5 -28.5t-28.5 -66.5q0 -29 17 -58t50 -51l158 -103q104 -68 104 -161q0 -45 -25 -88t-75 -70.5t-126 -27.5q-52 0 -109.5 10t-96.5 26q5 27 10.5 63.5t5.5 83.5l27 12q10 -54 27 -85.5t46.5 -45t76.5 -13.5 q46 0 75.5 16.5t44.5 41.5t15 53q0 61 -65 103l-160 105q-47 31 -69.5 71.5t-22.5 82.5q0 46 25 87t71 67t110 26q28 0 47.5 -3.5t36.5 -7.5t37 -4t45 6v-15q0 -20 2 -46.5t4.5 -52t5.5 -42.5zM395 909l-173 -162l-30 5l134 199q25 0 46 -12.5t23 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sacute",
    unicode: "\u015B",
    horizAdvX: 382,
    d: "M193 460q62 0 96.5 -12.5l34.5 -12.5q0 -22 1 -50t5 -49l-26 -9q-13 53 -37 72t-62 19q-34 0 -54.5 -19t-20.5 -45q0 -18 11 -37.5t41 -36.5l102 -56q31 -17 48.5 -43t17.5 -64q0 -30 -16 -59t-51.5 -48t-92.5 -19q-30 0 -68.5 6t-81.5 19q3 15 5.5 36.5t4.5 43t2 35.5 l26 9q9 -35 18 -60.5t28.5 -38.5t59.5 -13q43 0 65 21t22 47q0 19 -11.5 37t-35.5 31l-108 60q-34 18 -50 47t-16 60q0 32 16.5 61.5t48.5 48.5t78 19zM337 680l-173 -162l-30 5l134 199q25 0 46 -12.5t23 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scircumflex",
    unicode: "\u015C",
    horizAdvX: 528,
    d: "M443 529l-27 -12q-21 77 -57.5 102t-92.5 25q-58 0 -86.5 -28.5t-28.5 -66.5q0 -29 17 -58t50 -51l158 -103q104 -68 104 -161q0 -45 -25 -88t-75 -70.5t-126 -27.5q-52 0 -109.5 10t-96.5 26q5 27 10.5 63.5t5.5 83.5l27 12q10 -54 27 -85.5t46.5 -45t76.5 -13.5 q46 0 75.5 16.5t44.5 41.5t15 53q0 61 -65 103l-160 105q-47 31 -69.5 71.5t-22.5 82.5q0 46 25 87t71 67t110 26q28 0 47.5 -3.5t36.5 -7.5t37 -4t45 6v-15q0 -20 2 -46.5t4.5 -52t5.5 -42.5zM246 946h37l94 -194l-30 -5l-83 104l-82 -104l-30 5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scircumflex",
    unicode: "\u015D",
    horizAdvX: 382,
    d: "M193 460q62 0 96.5 -12.5l34.5 -12.5q0 -22 1 -50t5 -49l-26 -9q-13 53 -37 72t-62 19q-34 0 -54.5 -19t-20.5 -45q0 -18 11 -37.5t41 -36.5l102 -56q31 -17 48.5 -43t17.5 -64q0 -30 -16 -59t-51.5 -48t-92.5 -19q-30 0 -68.5 6t-81.5 19q3 15 5.5 36.5t4.5 43t2 35.5 l26 9q9 -35 18 -60.5t28.5 -38.5t59.5 -13q43 0 65 21t22 47q0 19 -11.5 37t-35.5 31l-108 60q-34 18 -50 47t-16 60q0 32 16.5 61.5t48.5 48.5t78 19zM172 717h37l94 -194l-30 -5l-83 104l-82 -104l-30 5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scedilla",
    unicode: "\u015E",
    horizAdvX: 528,
    d: "M443 529l-27 -12q-21 77 -57.5 102t-92.5 25q-58 0 -86.5 -28.5t-28.5 -66.5q0 -29 17 -58t50 -51l158 -103q104 -68 104 -161q0 -45 -25 -88t-75 -70.5t-126 -27.5q-52 0 -109.5 10t-96.5 26q5 27 10.5 63.5t5.5 83.5l27 12q10 -54 27 -85.5t46.5 -45t76.5 -13.5 q46 0 75.5 16.5t44.5 41.5t15 53q0 61 -65 103l-160 105q-47 31 -69.5 71.5t-22.5 82.5q0 46 25 87t71 67t110 26q28 0 47.5 -3.5t36.5 -7.5t37 -4t45 6v-15q0 -20 2 -46.5t4.5 -52t5.5 -42.5zM260 11h26q-9 -14 -11 -21.5t-2 -13.5q0 -12 12 -23t27 -22t27 -24.5t12 -31.5 q0 -34 -39 -69t-119 -65q-16 13 -16 33q0 13 6.5 25.5t16.5 20.5q46 2 71.5 11.5t25.5 23.5q0 12 -10 21.5t-23.5 19t-23.5 21.5t-10 30q0 12 7 28t23 36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scedilla",
    unicode: "\u015F",
    horizAdvX: 382,
    d: "M193 460q62 0 96.5 -12.5l34.5 -12.5q0 -22 1 -50t5 -49l-26 -9q-13 53 -37 72t-62 19q-34 0 -54.5 -19t-20.5 -45q0 -18 11 -37.5t41 -36.5l102 -56q31 -17 48.5 -43t17.5 -64q0 -30 -16 -59t-51.5 -48t-92.5 -19q-30 0 -68.5 6t-81.5 19q3 15 5.5 36.5t4.5 43t2 35.5 l26 9q9 -35 18 -60.5t28.5 -38.5t59.5 -13q43 0 65 21t22 47q0 19 -11.5 37t-35.5 31l-108 60q-34 18 -50 47t-16 60q0 32 16.5 61.5t48.5 48.5t78 19zM187 11h26q-9 -14 -11 -21.5t-2 -13.5q0 -12 12 -23t27 -22t27 -24.5t12 -31.5q0 -34 -39 -69t-119 -65q-16 13 -16 33 q0 13 6.5 25.5t16.5 20.5q46 2 71.5 11.5t25.5 23.5q0 12 -10 21.5t-23.5 19t-23.5 21.5t-10 30q0 12 7 28t23 36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scaron",
    unicode: "\u0160",
    horizAdvX: 528,
    d: "M443 529l-27 -12q-21 77 -57.5 102t-92.5 25q-58 0 -86.5 -28.5t-28.5 -66.5q0 -29 17 -58t50 -51l158 -103q104 -68 104 -161q0 -45 -25 -88t-75 -70.5t-126 -27.5q-52 0 -109.5 10t-96.5 26q5 27 10.5 63.5t5.5 83.5l27 12q10 -54 27 -85.5t46.5 -45t76.5 -13.5 q46 0 75.5 16.5t44.5 41.5t15 53q0 61 -65 103l-160 105q-47 31 -69.5 71.5t-22.5 82.5q0 46 25 87t71 67t110 26q28 0 47.5 -3.5t36.5 -7.5t37 -4t45 6v-15q0 -20 2 -46.5t4.5 -52t5.5 -42.5zM282 752h-37l-104 195l30 5l92 -114l93 114l30 -5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scaron",
    unicode: "\u0161",
    horizAdvX: 382,
    d: "M193 460q62 0 96.5 -12.5l34.5 -12.5q0 -22 1 -50t5 -49l-26 -9q-13 53 -37 72t-62 19q-34 0 -54.5 -19t-20.5 -45q0 -18 11 -37.5t41 -36.5l102 -56q31 -17 48.5 -43t17.5 -64q0 -30 -16 -59t-51.5 -48t-92.5 -19q-30 0 -68.5 6t-81.5 19q3 15 5.5 36.5t4.5 43t2 35.5 l26 9q9 -35 18 -60.5t28.5 -38.5t59.5 -13q43 0 65 21t22 47q0 19 -11.5 37t-35.5 31l-108 60q-34 18 -50 47t-16 60q0 32 16.5 61.5t48.5 48.5t78 19zM209 522h-37l-104 195l30 5l92 -114l93 114l30 -5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0162",
    unicode: "\u0162",
    horizAdvX: 642,
    d: "M322 685q97 0 166.5 1t130.5 5v-15q0 -21 1.5 -49t4.5 -54.5t6 -43.5l-27 -12q-13 42 -27.5 67.5t-36 38t-54 16.5t-80.5 4q-12 0 -21.5 -4t-11.5 -23l-2 -23.5t-4 -83t-2 -167.5t2 -167t4 -82.5l2 -23.5q2 -19 21 -26.5t64 -16.5l-3 -29q-31 2 -63 2.5t-70 0.5 q-78 0 -141 -3l-3 29q45 9 66 16.5t23 26.5l2 23.5t4 83t2 166.5q0 108 -2 167.5t-4 83l-2 23.5q-2 19 -11 23t-20 4q-48 0 -80.5 -4t-53.5 -16.5t-36 -38t-28 -67.5l-27 12q3 17 6 43.5t4.5 54.5t1.5 49v15q62 -4 132 -5t167 -1zM315 11h26q-9 -14 -11 -21.5t-2 -13.5 q0 -12 12 -23t27 -22t27 -24.5t12 -31.5q0 -34 -39 -69t-119 -65q-16 13 -16 33q0 13 6.5 25.5t16.5 20.5q46 2 71.5 11.5t25.5 23.5q0 12 -10 21.5t-23.5 19t-23.5 21.5t-10 30q0 12 7 28t23 36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0163",
    unicode: "\u0163",
    horizAdvX: 327,
    d: "M311 71l12 -33q-34 -22 -65 -34.5t-63 -12.5q-43 0 -73.5 21t-30.5 79l0.5 24.5t0.5 60v67.5q0 50 -0.5 91.5t-1.5 71.5q-30 -1 -47 -1h-17l-3 11l23 39l10.5 -1.5t31.5 -2.5q0 20 -1 41.5t-2 36l-1 14.5l66 59l19 -9l-0.5 -21.5t-1 -53.5t-0.5 -66q68 0 107.5 0.5 l39.5 0.5l5 -12l-36 -40l-27 2t-89 3v-134q0 -60 0.5 -99t2.5 -80q2 -25 17 -35t36 -10q23 0 47.5 8t40.5 15zM163 11h26q-9 -14 -11 -21.5t-2 -13.5q0 -12 12 -23t27 -22t27 -24.5t12 -31.5q0 -34 -39 -69t-119 -65q-16 13 -16 33q0 13 6.5 25.5t16.5 20.5q46 2 71.5 11.5 t25.5 23.5q0 12 -10 21.5t-23.5 19t-23.5 21.5t-10 30q0 12 7 28t23 36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tcaron",
    unicode: "\u0164",
    horizAdvX: 642,
    d: "M322 685q97 0 166.5 1t130.5 5v-15q0 -21 1.5 -49t4.5 -54.5t6 -43.5l-27 -12q-13 42 -27.5 67.5t-36 38t-54 16.5t-80.5 4q-12 0 -21.5 -4t-11.5 -23l-2 -23.5t-4 -83t-2 -167.5t2 -167t4 -82.5l2 -23.5q2 -19 21 -26.5t64 -16.5l-3 -29q-31 2 -63 2.5t-70 0.5 q-78 0 -141 -3l-3 29q45 9 66 16.5t23 26.5l2 23.5t4 83t2 166.5q0 108 -2 167.5t-4 83l-2 23.5q-2 19 -11 23t-20 4q-48 0 -80.5 -4t-53.5 -16.5t-36 -38t-28 -67.5l-27 12q3 17 6 43.5t4.5 54.5t1.5 49v15q62 -4 132 -5t167 -1zM339 752h-37l-104 195l30 5l92 -114l93 114 l30 -5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tcaron",
    unicode: "\u0165",
    horizAdvX: 327,
    d: "M311 71l12 -33q-34 -22 -65 -34.5t-63 -12.5q-43 0 -73.5 21t-30.5 79l0.5 24.5t0.5 60v67.5q0 50 -0.5 91.5t-1.5 71.5q-30 -1 -47 -1h-17l-3 11l23 39l10.5 -1.5t31.5 -2.5q0 20 -1 41.5t-2 36l-1 14.5l66 59l19 -9l-0.5 -21.5t-1 -53.5t-0.5 -66q68 0 107.5 0.5 l39.5 0.5l5 -12l-36 -40l-27 2t-89 3v-134q0 -60 0.5 -99t2.5 -80q2 -25 17 -35t36 -10q23 0 47.5 8t40.5 15zM209 708q0 23 16 35t38 12q26 0 50 -20.5t24 -65.5q0 -39 -25 -74.5t-69 -59.5l-15 21q26 22 42.5 49.5t16.5 55.5v10t-2 10q-4 -7 -14 -11.5t-19 -4.5 q-20 0 -31.5 13.5t-11.5 29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tbar",
    unicode: "\u0166",
    horizAdvX: 642,
    d: "M543 335l-13 -42h-165q1 -88 3 -136.5t3.5 -68l1.5 -19.5q2 -19 21 -26.5t64 -16.5l-3 -29q-31 2 -63 2.5t-70 0.5q-78 0 -141 -3l-3 29q45 9 66 16.5t23 26.5l1.5 19.5t3.5 68.5t3 136h-177l13 42h164v7q0 108 -2 167.5t-4 83l-2 23.5q-2 19 -11 23t-20 4 q-48 0 -80.5 -4t-53.5 -16.5t-36 -38t-28 -67.5l-27 12q3 17 6 43.5t4.5 54.5t1.5 49v15q62 -4 132 -5t167 -1t166.5 1t130.5 5v-15q0 -21 1.5 -49t4.5 -54.5t6 -43.5l-27 -12q-13 42 -27.5 67.5t-36 38t-54 16.5t-80.5 4q-12 0 -21.5 -4t-11.5 -23l-2 -23.5t-4 -83 t-2 -167.5v-7h178z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tbar",
    unicode: "\u0167",
    horizAdvX: 327,
    d: "M31 219l13 42h48q0 44 -0.5 81t-1.5 64q-30 -1 -47 -1h-17l-3 11l23 39l10.5 -1.5t31.5 -2.5q0 20 -1 41.5t-2 36l-1 14.5l66 59l19 -9l-0.5 -21.5t-1 -53.5t-0.5 -66q68 0 107.5 0.5l39.5 0.5l5 -12l-36 -40l-27 2t-89 3v-134v-11h113l-13 -42h-100q0 -37 0.5 -66 t2.5 -60q2 -25 17 -35t36 -10q23 0 47.5 8t40.5 15l12 -33q-34 -22 -65 -34.5t-63 -12.5q-43 0 -73.5 21t-30.5 79v19.5t0.5 49t0.5 59.5h-61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Utilde",
    unicode: "\u0168",
    horizAdvX: 760,
    d: "M584 616q-2 19 -25.5 26.5t-68.5 16.5l3 29q32 -1 68.5 -2t73.5 -1q25 0 41 0.5t30.5 1t35.5 1.5l3 -29q-45 -9 -63 -16.5t-19 -26.5q-4 -92 -6 -184.5t-5 -184.5q-2 -71 -28.5 -130t-85.5 -94t-158 -35q-84 0 -143.5 20t-91.5 73.5t-34 154.5q-1 95 -3 190l-4 190 q0 19 -18.5 26.5t-63.5 16.5l3 29q32 -1 64.5 -2t69.5 -1q38 0 68.5 1t61.5 2l3 -29q-45 -9 -62.5 -16.5t-19.5 -26.5l-2.5 -26t-4.5 -89.5t-2 -178.5q0 -64 3.5 -115.5t20 -87.5t53 -55t102.5 -19q68 0 109.5 21t64 60t30.5 93t8 120q0 108 -2 168t-4 84.5zM540 893l26 -8 q-15 -50 -34 -72.5t-40.5 -27t-44.5 2.5t-47 17t-47.5 15.5t-46 -1t-42.5 -34.5l-26 8q15 50 34 72.5t40.5 27t44.5 -2.5t47 -17t47.5 -15.5t46 1t42.5 34.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "utilde",
    unicode: "\u0169",
    horizAdvX: 550,
    d: "M458 85q1 -18 12.5 -27t29 -11.5t34.5 -3.5l-3 -29q-27 -2 -55 -7.5t-54 -10.5l-16.5 12.5t-24.5 47.5q-40 -27 -92 -46t-102 -19q-44 0 -73 22.5t-29 81.5v134q0 73 -1.5 108.5t-3.5 47l-2 11.5l-59 19l-2 26q27 0 64.5 5.5t62.5 12.5l19 -9l-0.5 -30t-1 -79.5t-1 -107 t-0.5 -113.5q0 -37 20.5 -52t60.5 -15q37 0 75.5 14t59.5 28q2 20 3 48t1 86q0 73 -2 108.5t-4 47l-2 11.5l-63 19l-2 26q18 0 42.5 2.5t48.5 7t41 8.5l19 -9l-1.5 -59t-1.5 -189q0 -63 1.5 -90zM416 664l26 -8q-15 -50 -34 -72.5t-40.5 -27t-44.5 2.5t-47 17t-47.5 15.5 t-46 -1t-42.5 -34.5l-26 8q15 50 34 72.5t40.5 27t44.5 -2.5t47 -17t47.5 -15.5t46 1t42.5 34.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Umacron",
    unicode: "\u016A",
    horizAdvX: 760,
    d: "M584 616q-2 19 -25.5 26.5t-68.5 16.5l3 29q32 -1 68.5 -2t73.5 -1q25 0 41 0.5t30.5 1t35.5 1.5l3 -29q-45 -9 -63 -16.5t-19 -26.5q-4 -92 -6 -184.5t-5 -184.5q-2 -71 -28.5 -130t-85.5 -94t-158 -35q-84 0 -143.5 20t-91.5 73.5t-34 154.5q-1 95 -3 190l-4 190 q0 19 -18.5 26.5t-63.5 16.5l3 29q32 -1 64.5 -2t69.5 -1q38 0 68.5 1t61.5 2l3 -29q-45 -9 -62.5 -16.5t-19.5 -26.5l-2.5 -26t-4.5 -89.5t-2 -178.5q0 -64 3.5 -115.5t20 -87.5t53 -55t102.5 -19q68 0 109.5 21t64 60t30.5 93t8 120q0 108 -2 168t-4 84.5zM560 850 l-39 -46q-34 2 -68.5 3t-69.5 1q-34 0 -68 -1t-69 -3l-8 16l39 46q38 -2 75 -3.5t74 -1.5q32 0 63.5 1t62.5 3z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "umacron",
    unicode: "\u016B",
    horizAdvX: 550,
    d: "M458 85q1 -18 12.5 -27t29 -11.5t34.5 -3.5l-3 -29q-27 -2 -55 -7.5t-54 -10.5l-16.5 12.5t-24.5 47.5q-40 -27 -92 -46t-102 -19q-44 0 -73 22.5t-29 81.5v134q0 73 -1.5 108.5t-3.5 47l-2 11.5l-59 19l-2 26q27 0 64.5 5.5t62.5 12.5l19 -9l-0.5 -30t-1 -79.5t-1 -107 t-0.5 -113.5q0 -37 20.5 -52t60.5 -15q37 0 75.5 14t59.5 28q2 20 3 48t1 86q0 73 -2 108.5t-4 47l-2 11.5l-63 19l-2 26q18 0 42.5 2.5t48.5 7t41 8.5l19 -9l-1.5 -59t-1.5 -189q0 -63 1.5 -90zM436 618l-39 -46q-34 2 -68.5 3t-69.5 1q-34 0 -68 -1t-69 -3l-8 16l39 46 q38 -2 75 -3.5t74 -1.5q32 0 63.5 1t62.5 3z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ubreve",
    unicode: "\u016C",
    horizAdvX: 760,
    d: "M584 616q-2 19 -25.5 26.5t-68.5 16.5l3 29q32 -1 68.5 -2t73.5 -1q25 0 41 0.5t30.5 1t35.5 1.5l3 -29q-45 -9 -63 -16.5t-19 -26.5q-4 -92 -6 -184.5t-5 -184.5q-2 -71 -28.5 -130t-85.5 -94t-158 -35q-84 0 -143.5 20t-91.5 73.5t-34 154.5q-1 95 -3 190l-4 190 q0 19 -18.5 26.5t-63.5 16.5l3 29q32 -1 64.5 -2t69.5 -1q38 0 68.5 1t61.5 2l3 -29q-45 -9 -62.5 -16.5t-19.5 -26.5l-2.5 -26t-4.5 -89.5t-2 -178.5q0 -64 3.5 -115.5t20 -87.5t53 -55t102.5 -19q68 0 109.5 21t64 60t30.5 93t8 120q0 108 -2 168t-4 84.5zM273 891l37 5 q5 -27 33 -40t59 -13q32 0 60 13t33 40l37 -5q-7 -54 -46 -81t-84 -27q-44 0 -82.5 27t-46.5 81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ubreve",
    unicode: "\u016D",
    horizAdvX: 550,
    d: "M458 85q1 -18 12.5 -27t29 -11.5t34.5 -3.5l-3 -29q-27 -2 -55 -7.5t-54 -10.5l-16.5 12.5t-24.5 47.5q-40 -27 -92 -46t-102 -19q-44 0 -73 22.5t-29 81.5v134q0 73 -1.5 108.5t-3.5 47l-2 11.5l-59 19l-2 26q27 0 64.5 5.5t62.5 12.5l19 -9l-0.5 -30t-1 -79.5t-1 -107 t-0.5 -113.5q0 -37 20.5 -52t60.5 -15q37 0 75.5 14t59.5 28q2 20 3 48t1 86q0 73 -2 108.5t-4 47l-2 11.5l-63 19l-2 26q18 0 42.5 2.5t48.5 7t41 8.5l19 -9l-1.5 -59t-1.5 -189q0 -63 1.5 -90zM145 659l37 5q5 -27 33 -40t59 -13q32 0 60 13t33 40l37 -5q-7 -54 -46 -81 t-84 -27q-44 0 -82.5 27t-46.5 81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uring",
    unicode: "\u016E",
    horizAdvX: 760,
    d: "M584 616q-2 19 -25.5 26.5t-68.5 16.5l3 29q32 -1 68.5 -2t73.5 -1q25 0 41 0.5t30.5 1t35.5 1.5l3 -29q-45 -9 -63 -16.5t-19 -26.5q-4 -92 -6 -184.5t-5 -184.5q-2 -71 -28.5 -130t-85.5 -94t-158 -35q-84 0 -143.5 20t-91.5 73.5t-34 154.5q-1 95 -3 190l-4 190 q0 19 -18.5 26.5t-63.5 16.5l3 29q32 -1 64.5 -2t69.5 -1q38 0 68.5 1t61.5 2l3 -29q-45 -9 -62.5 -16.5t-19.5 -26.5l-2.5 -26t-4.5 -89.5t-2 -178.5q0 -64 3.5 -115.5t20 -87.5t53 -55t102.5 -19q68 0 109.5 21t64 60t30.5 93t8 120q0 108 -2 168t-4 84.5zM297 848 q0 44 31 74.5t74 30.5q44 0 74 -30.5t30 -74.5q0 -43 -30 -73.5t-74 -30.5q-43 0 -74 30.5t-31 73.5zM399 923q-20 0 -35 -14.5t-15 -55.5q0 -30 12 -54.5t40 -24.5q20 0 34.5 15t14.5 55q0 31 -11 55t-40 24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uring",
    unicode: "\u016F",
    horizAdvX: 550,
    d: "M458 85q1 -18 12.5 -27t29 -11.5t34.5 -3.5l-3 -29q-27 -2 -55 -7.5t-54 -10.5l-16.5 12.5t-24.5 47.5q-40 -27 -92 -46t-102 -19q-44 0 -73 22.5t-29 81.5v134q0 73 -1.5 108.5t-3.5 47l-2 11.5l-59 19l-2 26q27 0 64.5 5.5t62.5 12.5l19 -9l-0.5 -30t-1 -79.5t-1 -107 t-0.5 -113.5q0 -37 20.5 -52t60.5 -15q37 0 75.5 14t59.5 28q2 20 3 48t1 86q0 73 -2 108.5t-4 47l-2 11.5l-63 19l-2 26q18 0 42.5 2.5t48.5 7t41 8.5l19 -9l-1.5 -59t-1.5 -189q0 -63 1.5 -90zM170 619q0 44 31 74.5t74 30.5q44 0 74 -30.5t30 -74.5q0 -43 -30 -73.5 t-74 -30.5q-43 0 -74 30.5t-31 73.5zM272 694q-20 0 -35 -14.5t-15 -55.5q0 -30 12 -54.5t40 -24.5q20 0 34.5 15t14.5 55q0 31 -11 55t-40 24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uhungarumlaut",
    unicode: "\u0170",
    horizAdvX: 760,
    d: "M584 616q-2 19 -25.5 26.5t-68.5 16.5l3 29q32 -1 68.5 -2t73.5 -1q25 0 41 0.5t30.5 1t35.5 1.5l3 -29q-45 -9 -63 -16.5t-19 -26.5q-4 -92 -6 -184.5t-5 -184.5q-2 -71 -28.5 -130t-85.5 -94t-158 -35q-84 0 -143.5 20t-91.5 73.5t-34 154.5q-1 95 -3 190l-4 190 q0 19 -18.5 26.5t-63.5 16.5l3 29q32 -1 64.5 -2t69.5 -1q38 0 68.5 1t61.5 2l3 -29q-45 -9 -62.5 -16.5t-19.5 -26.5l-2.5 -26t-4.5 -89.5t-2 -178.5q0 -64 3.5 -115.5t20 -87.5t53 -55t102.5 -19q68 0 109.5 21t64 60t30.5 93t8 120q0 108 -2 168t-4 84.5zM648 912 l-173 -162l-30 5l134 199q25 0 46 -12.5t23 -29.5zM477 912l-173 -162l-30 5l134 199q25 0 46 -12.5t23 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uhungarumlaut",
    unicode: "\u0171",
    horizAdvX: 550,
    d: "M458 85q1 -18 12.5 -27t29 -11.5t34.5 -3.5l-3 -29q-27 -2 -55 -7.5t-54 -10.5l-16.5 12.5t-24.5 47.5q-40 -27 -92 -46t-102 -19q-44 0 -73 22.5t-29 81.5v134q0 73 -1.5 108.5t-3.5 47l-2 11.5l-59 19l-2 26q27 0 64.5 5.5t62.5 12.5l19 -9l-0.5 -30t-1 -79.5t-1 -107 t-0.5 -113.5q0 -37 20.5 -52t60.5 -15q37 0 75.5 14t59.5 28q2 20 3 48t1 86q0 73 -2 108.5t-4 47l-2 11.5l-63 19l-2 26q18 0 42.5 2.5t48.5 7t41 8.5l19 -9l-1.5 -59t-1.5 -189q0 -63 1.5 -90zM519 680l-173 -162l-30 5l134 199q25 0 46 -12.5t23 -29.5zM348 680 l-173 -162l-30 5l134 199q25 0 46 -12.5t23 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uogonek",
    unicode: "\u0172",
    horizAdvX: 760,
    d: "M584 616q-2 19 -25.5 26.5t-68.5 16.5l3 29q32 -1 68.5 -2t73.5 -1q25 0 41 0.5t30.5 1t35.5 1.5l3 -29q-45 -9 -63 -16.5t-19 -26.5q-4 -92 -6 -184.5t-5 -184.5q-2 -71 -28.5 -130t-85.5 -94t-158 -35q-84 0 -143.5 20t-91.5 73.5t-34 154.5q-1 95 -3 190l-4 190 q0 19 -18.5 26.5t-63.5 16.5l3 29q32 -1 64.5 -2t69.5 -1q38 0 68.5 1t61.5 2l3 -29q-45 -9 -62.5 -16.5t-19.5 -26.5l-2.5 -26t-4.5 -89.5t-2 -178.5q0 -64 3.5 -115.5t20 -87.5t53 -55t102.5 -19q68 0 109.5 21t64 60t30.5 93t8 120q0 108 -2 168t-4 84.5zM395 -144l6 -32 q-41 -27 -87 -27q-42 0 -62.5 22.5t-20.5 54.5q0 29 15.5 59.5t47 55.5t79.5 37v-26q-46 -16 -61.5 -45t-15.5 -52q0 -29 16 -42.5t40 -13.5q21 0 43 9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uogonek",
    unicode: "\u0173",
    horizAdvX: 550,
    d: "M458 85q1 -18 12.5 -27t29 -11.5t34.5 -3.5l-3 -29q-27 -2 -55 -7.5t-54 -10.5l-16.5 12.5t-24.5 47.5q-40 -27 -92 -46t-102 -19q-44 0 -73 22.5t-29 81.5v134q0 73 -1.5 108.5t-3.5 47l-2 11.5l-59 19l-2 26q27 0 64.5 5.5t62.5 12.5l19 -9l-0.5 -30t-1 -79.5t-1 -107 t-0.5 -113.5q0 -37 20.5 -52t60.5 -15q37 0 75.5 14t59.5 28q2 20 3 48t1 86q0 73 -2 108.5t-4 47l-2 11.5l-63 19l-2 26q18 0 42.5 2.5t48.5 7t41 8.5l19 -9l-1.5 -59t-1.5 -189q0 -63 1.5 -90zM517 -134l6 -32q-41 -27 -87 -27q-42 0 -62.5 22.5t-20.5 54.5 q0 29 15.5 59.5t47 55.5t79.5 37v-26q-46 -16 -61.5 -45t-15.5 -52q0 -29 16 -42.5t40 -13.5q21 0 43 9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wcircumflex",
    unicode: "\u0174",
    horizAdvX: 990,
    d: "M491 531h-4l-149 -531l-92 -9l-163 625q-7 17 -23.5 25.5t-61.5 17.5l3 29l64 -2t69 -1q72 0 135 3l3 -29q-40 -8 -64 -15.5t-24 -21.5q0 -3 10 -46.5t27.5 -115.5t39.5 -162.5t45 -188.5h5q25 82 48.5 164.5t43.5 156t35 131.5t23.5 91l8.5 33h65l176 -576h5 q13 56 28.5 121l31 130t27.5 120.5t19.5 93t7.5 47.5q0 14 -22.5 22t-63.5 16l3 29l64 -2t69 -1q38 0 60.5 1t53.5 2l3 -29q-45 -9 -65 -19.5t-25 -29.5l-7.5 -30.5t-20.5 -82t-29.5 -116t-34.5 -133.5t-35 -133t-31 -115l-92 -9zM487 946h37l94 -194l-30 -5l-83 104 l-82 -104l-30 5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wcircumflex",
    unicode: "\u0175",
    horizAdvX: 725,
    d: "M604 396q0 11 -17 19t-46 12l-3 29l26 -1.5t54 -1.5q19 0 42.5 1t41.5 1.5l18 0.5l3 -29q-32 -4 -45.5 -13.5t-17.5 -23.5l-111 -390l-79 -9l-110 288l-103 -279l-78 -9l-112 395q-3 11 -15.5 23.5t-45.5 17.5l-3 29l18 -0.5t42 -1.5t42 -1q19 0 45.5 1t46.5 1.5l20 0.5 l3 -29q-38 -5 -52.5 -15.5t-14.5 -18.5q0 -2 5.5 -26t14.5 -60.5t19.5 -79.5t21 -85.5t18.5 -75.5l136 384h22l132 -384q8 34 18.5 76t22 85t20.5 80.5t15 61.5t6 27zM364 717h37l94 -194l-30 -5l-83 104l-82 -104l-30 5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ycircumflex",
    unicode: "\u0176",
    horizAdvX: 641,
    d: "M336 331q45 83 73.5 136.5t44.5 84.5t23 45.5t8.5 19t1.5 6.5q0 12 -26 20t-66 16l3 29l64 -2t69 -1q38 0 60.5 1t53.5 2l3 -29q-45 -9 -62.5 -20t-27.5 -29l-193 -347q1 -77 2.5 -119t3.5 -58.5l2 -16.5q2 -19 21 -26.5t64 -16.5l-3 -29q-31 2 -63 2.5t-70 0.5 q-78 0 -141 -3l-3 29q45 9 66 16.5t23 26.5l1.5 17t3.5 59.5t2 116.5l-193 354q-9 17 -24.5 25.5t-60.5 17.5l3 29l64 -2t69 -1q78 0 141 3l3 -29q-40 -7 -64.5 -15t-24.5 -21q0 -2 0.5 -4t1.5 -4zM319 946h37l94 -194l-30 -5l-83 104l-82 -104l-30 5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ycircumflex",
    unicode: "\u0177",
    horizAdvX: 482,
    d: "M228 0l-35 21l-130 365q-4 11 -16 23.5t-45 17.5l-3 29l18 -0.5t42 -1.5t42 -1q19 0 42 1t39.5 1.5l16.5 0.5l3 -29q-33 -4 -46.5 -13t-13.5 -17q0 -4 29 -88.5t81 -244.5q56 158 84 241.5t28 92.5q0 22 -55 29l-3 29l22 -1.5t50 -1.5q18 0 42 1t42 1.5l18 0.5l3 -29 q-31 -4 -43.5 -11.5t-17 -21.5t-14.5 -40l-133 -354q-36 -96 -68 -150t-57.5 -78t-44.5 -29.5t-30 -5.5q-5 0 -15.5 10.5t-20.5 27t-15 32.5l15 19q19 -9 45 -9q16 0 38 14t49 53.5t57 115.5zM236 717h37l94 -194l-30 -5l-83 104l-82 -104l-30 5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ydieresis",
    unicode: "\u0178",
    horizAdvX: 641,
    d: "M336 331q45 83 73.5 136.5t44.5 84.5t23 45.5t8.5 19t1.5 6.5q0 12 -26 20t-66 16l3 29l64 -2t69 -1q38 0 60.5 1t53.5 2l3 -29q-45 -9 -62.5 -20t-27.5 -29l-193 -347q1 -77 2.5 -119t3.5 -58.5l2 -16.5q2 -19 21 -26.5t64 -16.5l-3 -29q-31 2 -63 2.5t-70 0.5 q-78 0 -141 -3l-3 29q45 9 66 16.5t23 26.5l1.5 17t3.5 59.5t2 116.5l-193 354q-9 17 -24.5 25.5t-60.5 17.5l3 29l64 -2t69 -1q78 0 141 3l3 -29q-40 -7 -64.5 -15t-24.5 -21q0 -2 0.5 -4t1.5 -4zM427 792q-22 0 -37 15.5t-15 38.5q0 22 15 37t37 15t37 -15t15 -37 q0 -23 -15 -38.5t-37 -15.5zM247 792q-22 0 -37 15.5t-15 38.5q0 22 15 37t37 15t37 -15t15 -37q0 -23 -15 -38.5t-37 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zacute",
    unicode: "\u0179",
    horizAdvX: 640,
    d: "M598 652l-447 -599h116q83 0 139 3t91 14.5t56 35t34 65.5l27 -12q-6 -18 -11 -49t-8.5 -61.5t-4.5 -48.5h-536l-24 35l448 596q-105 0 -172.5 -1t-107.5 -6.5t-61 -17.5t-32 -33.5t-22 -55.5l-27 12q3 17 6 43.5t4.5 54.5t1.5 49v15q41 -3 105.5 -4.5t137.5 -1.5h137 h132zM451 909l-173 -162l-30 5l134 199q25 0 46 -12.5t23 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zacute",
    unicode: "\u017A",
    horizAdvX: 444,
    d: "M398 0h-352l-20 30l287 380q-76 0 -119.5 -1.5t-66 -9.5t-33.5 -25.5t-21 -49.5l-26 9q3 19 6 51.5t3 57.5v13q23 -2 65.5 -3t92.5 -1.5t99 -0.5h85l15 -28l-283 -377q89 0 141 6t80 28t42 68l26 -9q-5 -15 -9.5 -42t-7.5 -53.5t-4 -42.5zM378 680l-173 -162l-30 5 l134 199q25 0 46 -12.5t23 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zdotaccent",
    unicode: "\u017B",
    horizAdvX: 640,
    d: "M598 652l-447 -599h116q83 0 139 3t91 14.5t56 35t34 65.5l27 -12q-6 -18 -11 -49t-8.5 -61.5t-4.5 -48.5h-536l-24 35l448 596q-105 0 -172.5 -1t-107.5 -6.5t-61 -17.5t-32 -33.5t-22 -55.5l-27 12q3 17 6 43.5t4.5 54.5t1.5 49v15q41 -3 105.5 -4.5t137.5 -1.5h137 h132zM320 793q-22 0 -37 15.5t-15 38.5q0 22 15 37t37 15t37 -15t15 -37q0 -23 -15 -38.5t-37 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zdotaccent",
    unicode: "\u017C",
    horizAdvX: 444,
    d: "M398 0h-352l-20 30l287 380q-76 0 -119.5 -1.5t-66 -9.5t-33.5 -25.5t-21 -49.5l-26 9q3 19 6 51.5t3 57.5v13q23 -2 65.5 -3t92.5 -1.5t99 -0.5h85l15 -28l-283 -377q89 0 141 6t80 28t42 68l26 -9q-5 -15 -9.5 -42t-7.5 -53.5t-4 -42.5zM232 563q-22 0 -37 15.5 t-15 38.5q0 22 15 37t37 15t37 -15t15 -37q0 -23 -15 -38.5t-37 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zcaron",
    unicode: "\u017D",
    horizAdvX: 640,
    d: "M598 652l-447 -599h116q83 0 139 3t91 14.5t56 35t34 65.5l27 -12q-6 -18 -11 -49t-8.5 -61.5t-4.5 -48.5h-536l-24 35l448 596q-105 0 -172.5 -1t-107.5 -6.5t-61 -17.5t-32 -33.5t-22 -55.5l-27 12q3 17 6 43.5t4.5 54.5t1.5 49v15q41 -3 105.5 -4.5t137.5 -1.5h137 h132zM338 752h-37l-104 195l30 5l92 -114l93 114l30 -5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zcaron",
    unicode: "\u017E",
    horizAdvX: 444,
    d: "M398 0h-352l-20 30l287 380q-76 0 -119.5 -1.5t-66 -9.5t-33.5 -25.5t-21 -49.5l-26 9q3 19 6 51.5t3 57.5v13q23 -2 65.5 -3t92.5 -1.5t99 -0.5h85l15 -28l-283 -377q89 0 141 6t80 28t42 68l26 -9q-5 -15 -9.5 -42t-7.5 -53.5t-4 -42.5zM250 522h-37l-104 195l30 5 l92 -114l93 114l30 -5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "florin",
    unicode: "\u0192",
    horizAdvX: 523,
    d: "M204 509q6 53 25.5 79t49.5 34t65 8q20 0 42 -1t44 -1q8 0 18 1.5t21 3.5q0 -17 1.5 -42.5t4 -51t5.5 -43.5l-24 -11q-12 45 -30 68t-37 31t-38 8q-25 0 -43 -15.5t-23 -62.5l-18 -182h143l-6 -43h-141l-25 -250q-9 -87 -25 -137t-36 -74t-41 -31t-40 -7 q-55 0 -93.5 17.5t-72.5 44.5l14 29q35 -16 59.5 -23t51.5 -7q19 0 39 10t36 44t23 107l29 277h-110l6 43h108q5 47 9 87l6.5 65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01CD",
    unicode: "\u01CD",
    horizAdvX: 694,
    d: "M3 -3l-3 29q47 9 67 19.5t26 29.5l199 609l84 10l233 -625q7 -17 23.5 -26t61.5 -17l-3 -29q-33 2 -65 2.5t-68 0.5q-79 0 -141 -3l-3 29q52 10 70 18t18 20l-55 178h-226l-54 -178q0 -12 19 -20t67 -18l-3 -29q-33 2 -65 2.5t-68 0.5q-31 0 -53 -0.5t-61 -2.5zM235 288 h196l-101 302h-4zM365 752h-37l-104 195l30 5l92 -114l93 114l30 -5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01CE",
    unicode: "\u01CE",
    horizAdvX: 457,
    d: "M437 52l10 -26q-38 -35 -83 -35q-25 0 -45 15.5t-25 49.5q-37 -28 -73.5 -46.5t-78.5 -18.5q-40 0 -71.5 25t-31.5 79q0 36 23 70.5t78.5 59t150.5 30.5v93q0 29 -21.5 43.5t-51.5 14.5q-44 0 -65 -21t-21 -52q0 -12 3 -27l-22 -10q-21 11 -38 30.5t-17 27.5q0 7 12.5 24 t37.5 36t61 32.5t83 13.5q31 0 56.5 -9t40.5 -32t15 -66q0 -10 0.5 -36t1.5 -60t1.5 -68.5t1.5 -60.5t1 -36q1 -27 11.5 -37.5t24.5 -10.5q6 0 14 2t17 6zM291 94v116q-88 -2 -128 -33t-40 -66q0 -30 18 -45t47 -15q22 0 48.5 10.5t54.5 32.5zM247 522h-37l-104 195l30 5 l92 -114l93 114l30 -5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aringacute",
    unicode: "\u01FA",
    horizAdvX: 694,
    d: "M451 1035l-160 -143l-30 5l121 180q25 0 46 -12.5t23 -29.5zM3 -3l-3 29q47 9 67 19.5t26 29.5l198 606q-27 12 -44 37t-17 57q0 44 31 74.5t74 30.5q44 0 74 -30.5t30 -74.5q0 -31 -16 -56t-42 -38l228 -612q7 -17 23.5 -26t61.5 -17l-3 -29q-33 2 -65 2.5t-68 0.5 q-79 0 -141 -3l-3 29q52 10 70 18t18 20l-55 178h-226l-54 -178q0 -12 19 -20t67 -18l-3 -29q-33 2 -65 2.5t-68 0.5q-31 0 -53 -0.5t-61 -2.5zM332 850q-20 0 -35 -14.5t-15 -55.5q0 -30 12 -54.5t40 -24.5q20 0 34.5 15t14.5 55q0 31 -11 55t-40 24zM235 288h196l-101 302 h-4z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aringacute",
    unicode: "\u01FB",
    horizAdvX: 457,
    d: "M345 841l-160 -143l-30 5l121 180q25 0 46 -12.5t23 -29.5zM119 579q0 44 31 74.5t74 30.5q44 0 74 -30.5t30 -74.5q0 -43 -30 -73.5t-74 -30.5q-43 0 -74 30.5t-31 73.5zM221 654q-20 0 -35 -14.5t-15 -55.5q0 -30 12 -54.5t40 -24.5q20 0 34.5 15t14.5 55q0 31 -11 55 t-40 24zM437 52l10 -26q-38 -35 -83 -35q-25 0 -45 15.5t-25 49.5q-37 -28 -73.5 -46.5t-78.5 -18.5q-40 0 -71.5 25t-31.5 79q0 36 23 70.5t78.5 59t150.5 30.5v93q0 29 -21.5 43.5t-51.5 14.5q-44 0 -65 -21t-21 -52q0 -12 3 -27l-22 -10q-21 11 -38 30.5t-17 27.5 q0 7 12.5 24t37.5 36t61 32.5t83 13.5q31 0 56.5 -9t40.5 -32t15 -66q0 -10 0.5 -36t1.5 -60t1.5 -68.5t1.5 -60.5t1 -36q1 -27 11.5 -37.5t24.5 -10.5q6 0 14 2t17 6zM291 94v116q-88 -2 -128 -33t-40 -66q0 -30 18 -45t47 -15q22 0 48.5 10.5t54.5 32.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "AEacute",
    unicode: "\u01FC",
    horizAdvX: 967,
    d: "M475 69l2 22.5t4.5 78.5t2.5 157h-207q-29 -67 -55 -124.5t-42.5 -94.5t-16.5 -45q5 -13 27 -21t64 -16l-3 -29q-31 2 -63 2.5t-70 0.5q-37 0 -60 -0.5t-55 -2.5l-3 29q45 9 63.5 19.5t26.5 29.5l281 610h217q86 0 167 2t135 4v-11q0 -23 1.5 -51.5t4.5 -55t6 -44.5 l-27 -12q-14 47 -30.5 73t-41.5 37.5t-65 14t-101 2.5q-22 0 -36 -4t-16 -19l-2.5 -24t-5 -79.5t-3.5 -150.5q32 0 64 1t58 2.5t38 4.5q19 5 26 21.5t17 66.5l35 -4q-4 -27 -6 -55t-2 -56t2 -56t6 -56l-35 -5q-10 50 -17 67t-26 21q-12 3 -38 4.5t-58 2.5t-64 1 q0 -103 3 -159t5.5 -78l2.5 -22q5 -18 37 -25t64 -7q52 0 94 7t74 35.5t52 92.5l27 -12q-6 -18 -11 -49t-8.5 -61.5t-4.5 -48.5h-400q-37 0 -62.5 -0.5t-57.5 -2.5l-3 29q45 9 66 16.5t23 26.5zM420 646l-125 -279h189q0 97 -1.5 151t-2.5 76l-1 22q-2 19 -16 24.5t-43 5.5z M744 909l-173 -162l-30 5l134 199q25 0 46 -12.5t23 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aeacute",
    unicode: "\u01FD",
    horizAdvX: 700,
    d: "M284 255v96q0 30 -21.5 43t-51.5 13q-44 0 -65 -20.5t-21 -52.5q0 -13 3 -28l-22 -10q-21 11 -38 30.5t-17 27.5q0 7 12.5 24t37.5 36t61 32.5t83 13.5q38 0 68.5 -9.5t40.5 -47.5q29 26 69 41.5t94 15.5q36 0 71 -18t58 -56.5t23 -100.5l-34 -41q-55 -6 -99 -10 t-84.5 -7t-85.5 -7q0 -44 12.5 -82.5t45 -61.5t92.5 -23q38 0 72.5 10t55.5 20l12 -30q-31 -26 -72 -44t-92 -18q-60 0 -102 19.5t-68 52.5q-49 -41 -92 -56.5t-88 -15.5q-40 0 -71.5 25t-31.5 79q0 36 22.5 70.5t76 59t146.5 30.5zM579 316q0 34 -13.5 54.5t-33 30.5 t-37.5 10q-49 0 -81 -39.5t-43 -109.5q62 7 108.5 12t96.5 13q3 15 3 29zM284 213q-86 -7 -123.5 -37t-37.5 -65q0 -30 18 -45t47 -15q22 0 54.5 10.5t60.5 28.5q-9 29 -14 58t-5 65zM522 680l-173 -162l-30 5l134 199q25 0 46 -12.5t23 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oslashacute",
    unicode: "\u01FE",
    horizAdvX: 786,
    d: "M737 369q0 -72 -20.5 -141t-64 -124t-113 -87.5t-167.5 -32.5q-113 0 -184.5 42t-105 116.5t-33.5 171.5q0 72 20.5 140.5t64 123.5t113 87.5t167.5 32.5q114 0 185 -41.5t104.5 -115.5t33.5 -172zM632 312q0 65 -10 125t-35.5 108.5t-71 76.5t-117.5 28 q-61 0 -103.5 -22.5t-70 -58t-43 -76.5t-21.5 -79t-6 -64q0 -62 11.5 -119t38.5 -102t72 -71t112 -26q55 0 96.5 19.5t69.5 51.5t45.5 69.5t25 74t7.5 65.5zM268 -80l185 841h65l-185 -841h-65zM524 909l-173 -162l-30 5l134 199q25 0 46 -12.5t23 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oslashacute",
    unicode: "\u01FF",
    horizAdvX: 529,
    d: "M490 243q0 -48 -13.5 -93t-41.5 -81t-73.5 -57t-110.5 -21q-112 0 -162 59.5t-50 155.5q0 48 13.5 93t41.5 81.5t74 58t110 21.5q75 0 121.5 -27.5t68.5 -76.5t22 -113zM404 206q0 51 -11.5 98t-41 77t-84.5 30q-44 0 -72 -20.5t-43 -50.5t-21 -60t-6 -50q0 -49 13 -92.5 t43 -71t81 -27.5q40 0 67.5 17.5t44 44.5t23.5 55.5t7 49.5zM170 -90l139 631h49l-139 -631h-49zM420 680l-173 -162l-30 5l134 199q25 0 46 -12.5t23 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0218",
    unicode: "\u0218",
    horizAdvX: 528,
    d: "M443 529l-27 -12q-21 77 -57.5 102t-92.5 25q-58 0 -86.5 -28.5t-28.5 -66.5q0 -29 17 -58t50 -51l158 -103q104 -68 104 -161q0 -45 -25 -88t-75 -70.5t-126 -27.5q-52 0 -109.5 10t-96.5 26q5 27 10.5 63.5t5.5 83.5l27 12q10 -54 27 -85.5t46.5 -45t76.5 -13.5 q46 0 75.5 16.5t44.5 41.5t15 53q0 61 -65 103l-160 105q-47 31 -69.5 71.5t-22.5 82.5q0 46 25 87t71 67t110 26q28 0 47.5 -3.5t36.5 -7.5t37 -4t45 6v-15q0 -20 2 -46.5t4.5 -52t5.5 -42.5zM200 -92q0 23 16 35t38 12q26 0 50 -20.5t24 -65.5q0 -39 -25 -74.5t-69 -59.5 l-15 21q26 22 42.5 49.5t16.5 55.5v10t-2 10q-4 -7 -14 -11.5t-19 -4.5q-20 0 -31.5 13.5t-11.5 29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0219",
    unicode: "\u0219",
    horizAdvX: 382,
    d: "M193 460q62 0 96.5 -12.5l34.5 -12.5q0 -22 1 -50t5 -49l-26 -9q-13 53 -37 72t-62 19q-34 0 -54.5 -19t-20.5 -45q0 -18 11 -37.5t41 -36.5l102 -56q31 -17 48.5 -43t17.5 -64q0 -30 -16 -59t-51.5 -48t-92.5 -19q-30 0 -68.5 6t-81.5 19q3 15 5.5 36.5t4.5 43t2 35.5 l26 9q9 -35 18 -60.5t28.5 -38.5t59.5 -13q43 0 65 21t22 47q0 19 -11.5 37t-35.5 31l-108 60q-34 18 -50 47t-16 60q0 32 16.5 61.5t48.5 48.5t78 19zM127 -92q0 23 16 35t38 12q26 0 50 -20.5t24 -65.5q0 -39 -25 -74.5t-69 -59.5l-15 21q26 22 42.5 49.5t16.5 55.5v10 t-2 10q-4 -7 -14 -11.5t-19 -4.5q-20 0 -31.5 13.5t-11.5 29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni021A",
    unicode: "\u021A",
    horizAdvX: 642,
    d: "M322 685q97 0 166.5 1t130.5 5v-15q0 -21 1.5 -49t4.5 -54.5t6 -43.5l-27 -12q-13 42 -27.5 67.5t-36 38t-54 16.5t-80.5 4q-12 0 -21.5 -4t-11.5 -23l-2 -23.5t-4 -83t-2 -167.5t2 -167t4 -82.5l2 -23.5q2 -19 21 -26.5t64 -16.5l-3 -29q-31 2 -63 2.5t-70 0.5 q-78 0 -141 -3l-3 29q45 9 66 16.5t23 26.5l2 23.5t4 83t2 166.5q0 108 -2 167.5t-4 83l-2 23.5q-2 19 -11 23t-20 4q-48 0 -80.5 -4t-53.5 -16.5t-36 -38t-28 -67.5l-27 12q3 17 6 43.5t4.5 54.5t1.5 49v15q62 -4 132 -5t167 -1zM255 -92q0 23 16 35t38 12q26 0 50 -20.5 t24 -65.5q0 -39 -25 -74.5t-69 -59.5l-15 21q26 22 42.5 49.5t16.5 55.5v10t-2 10q-4 -7 -14 -11.5t-19 -4.5q-20 0 -31.5 13.5t-11.5 29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni021B",
    unicode: "\u021B",
    horizAdvX: 327,
    d: "M311 71l12 -33q-34 -22 -65 -34.5t-63 -12.5q-43 0 -73.5 21t-30.5 79l0.5 24.5t0.5 60v67.5q0 50 -0.5 91.5t-1.5 71.5q-30 -1 -47 -1h-17l-3 11l23 39l10.5 -1.5t31.5 -2.5q0 20 -1 41.5t-2 36l-1 14.5l66 59l19 -9l-0.5 -21.5t-1 -53.5t-0.5 -66q68 0 107.5 0.5 l39.5 0.5l5 -12l-36 -40l-27 2t-89 3v-134q0 -60 0.5 -99t2.5 -80q2 -25 17 -35t36 -10q23 0 47.5 8t40.5 15zM103 -92q0 23 16 35t38 12q26 0 50 -20.5t24 -65.5q0 -39 -25 -74.5t-69 -59.5l-15 21q26 22 42.5 49.5t16.5 55.5v10t-2 10q-4 -7 -14 -11.5t-19 -4.5 q-20 0 -31.5 13.5t-11.5 29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0237",
    unicode: "\u0237",
    horizAdvX: 258,
    d: "M105 15q0 137 -2 221t-4 122l-2 38l-64 19l-2 26q18 0 42.5 2.5t48.5 7t41 8.5l19 -9l-0.5 -48t-1 -137t-0.5 -211q0 -79 -15 -134t-37.5 -91t-46.5 -56t-42 -28t-24 -8q-5 0 -15.5 10.5t-20.5 27t-15 32.5l15 19q10 -6 26 -12.5t34 -6.5q16 0 31 15.5t25 60.5t10 132z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "circumflex",
    unicode: "\u02C6",
    d: "M-19 717h37l94 -194l-30 -5l-83 104l-82 -104l-30 5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "caron",
    unicode: "\u02C7",
    d: "M19 522h-37l-104 195l30 5l92 -114l93 114l30 -5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "breve",
    unicode: "\u02D8",
    d: "M-129 659l37 5q5 -27 33 -40t59 -13q32 0 60 13t33 40l37 -5q-7 -54 -46 -81t-84 -27q-44 0 -82.5 27t-46.5 81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotaccent",
    unicode: "\u02D9",
    d: "M0 563q-22 0 -37 15.5t-15 38.5q0 22 15 37t37 15t37 -15t15 -37q0 -23 -15 -38.5t-37 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ring",
    unicode: "\u02DA",
    d: "M-104 619q0 44 31 74.5t74 30.5q44 0 74 -30.5t30 -74.5q0 -43 -30 -73.5t-74 -30.5q-43 0 -74 30.5t-31 73.5zM-2 694q-20 0 -35 -14.5t-15 -55.5q0 -30 12 -54.5t40 -24.5q20 0 34.5 15t14.5 55q0 31 -11 55t-40 24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ogonek",
    unicode: "\u02DB",
    horizAdvX: 459,
    d: "M214 -144l6 -32q-41 -27 -87 -27q-42 0 -62.5 22.5t-20.5 54.5q0 29 15.5 59.5t47 55.5t79.5 37v-26q-46 -16 -61.5 -45t-15.5 -52q0 -29 16 -42.5t40 -13.5q21 0 43 9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tilde",
    unicode: "\u02DC",
    d: "M141 664l26 -8q-15 -50 -34 -72.5t-40.5 -27t-44.5 2.5t-47 17t-47.5 15.5t-46 -1t-42.5 -34.5l-26 8q15 50 34 72.5t40.5 27t44.5 -2.5t47 -17t47.5 -15.5t46 1t42.5 34.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hungarumlaut",
    unicode: "\u02DD",
    d: "M243 680l-173 -162l-30 5l134 199q25 0 46 -12.5t23 -29.5zM72 680l-173 -162l-30 5l134 199q25 0 46 -12.5t23 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gravecomb",
    unicode: "\u0300",
    d: "M32 518l-173 162q2 17 23 29.5t46 12.5l134 -199z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acutecomb",
    unicode: "\u0301",
    d: "M147 680l-173 -162l-30 5l134 199q25 0 46 -12.5t23 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0302",
    unicode: "\u0302",
    d: "M-19 717h37l94 -194l-30 -5l-83 104l-82 -104l-30 5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tildecomb",
    unicode: "\u0303",
    d: "M141 664l26 -8q-15 -50 -34 -72.5t-40.5 -27t-44.5 2.5t-47 17t-47.5 15.5t-46 -1t-42.5 -34.5l-26 8q15 50 34 72.5t40.5 27t44.5 -2.5t47 -17t47.5 -15.5t46 1t42.5 34.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0304",
    unicode: "\u0304",
    d: "M160 618l-39 -46q-34 2 -68.5 3t-69.5 1q-34 0 -68 -1t-69 -3l-8 16l39 46q38 -2 75 -3.5t74 -1.5q32 0 63.5 1t62.5 3z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0306",
    unicode: "\u0306",
    d: "M-129 659l37 5q5 -27 33 -40t59 -13q32 0 60 13t33 40l37 -5q-7 -54 -46 -81t-84 -27q-44 0 -82.5 27t-46.5 81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0307",
    unicode: "\u0307",
    d: "M0 563q-22 0 -37 15.5t-15 38.5q0 22 15 37t37 15t37 -15t15 -37q0 -23 -15 -38.5t-37 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0308",
    unicode: "\u0308",
    d: "M90 563q-22 0 -37 15.5t-15 38.5q0 22 15 37t37 15t37 -15t15 -37q0 -23 -15 -38.5t-37 -15.5zM-90 563q-22 0 -37 15.5t-15 38.5q0 22 15 37t37 15t37 -15t15 -37q0 -23 -15 -38.5t-37 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030A",
    unicode: "\u030A",
    d: "M-104 619q0 44 31 74.5t74 30.5q44 0 74 -30.5t30 -74.5q0 -43 -30 -73.5t-74 -30.5q-43 0 -74 30.5t-31 73.5zM-2 694q-20 0 -35 -14.5t-15 -55.5q0 -30 12 -54.5t40 -24.5q20 0 34.5 15t14.5 55q0 31 -11 55t-40 24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030B",
    unicode: "\u030B",
    d: "M243 680l-173 -162l-30 5l134 199q25 0 46 -12.5t23 -29.5zM72 680l-173 -162l-30 5l134 199q25 0 46 -12.5t23 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030C",
    unicode: "\u030C",
    d: "M19 522h-37l-104 195l30 5l92 -114l93 114l30 -5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0312",
    unicode: "\u0312",
    d: "M57 558q0 -22 -16 -34.5t-38 -12.5q-26 0 -50 20.5t-24 65.5q0 39 25.5 74.5t68.5 59.5l15 -21q-25 -22 -42 -49.5t-17 -55.5q0 -5 0.5 -10t1.5 -10q5 8 14.5 12t18.5 4q20 0 31.5 -13t11.5 -30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0326",
    unicode: "\u0326",
    d: "M62 -92q0 23 16 35t38 12q26 0 50 -20.5t24 -65.5q0 -39 -25 -74.5t-69 -59.5l-15 21q26 22 42.5 49.5t16.5 55.5v10t-2 10q-4 -7 -14 -11.5t-19 -4.5q-20 0 -31.5 13.5t-11.5 29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0327",
    unicode: "\u0327",
    d: "M221 11h26q-9 -14 -11 -21.5t-2 -13.5q0 -12 12 -23t27 -22t27 -24.5t12 -31.5q0 -34 -39 -69t-119 -65q-16 13 -16 33q0 13 6.5 25.5t16.5 20.5q46 2 71.5 11.5t25.5 23.5q0 12 -10 21.5t-23.5 19t-23.5 21.5t-10 30q0 12 7 28t23 36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0328",
    unicode: "\u0328",
    d: "M214 -144l6 -32q-41 -27 -87 -27q-42 0 -62.5 22.5t-20.5 54.5q0 29 15.5 59.5t47 55.5t79.5 37v-26q-46 -16 -61.5 -45t-15.5 -52q0 -29 16 -42.5t40 -13.5q21 0 43 9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0394",
    unicode: "\u0394",
    horizAdvX: 615,
    d: "M321 691h11l283 -691h-615zM488 50l-198 478l-223 -478h421z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni03A9",
    unicode: "\u03A9",
    horizAdvX: 816,
    d: "M294 89l-24 -89h-226q-1 18 -4.5 48.5t-8.5 61.5t-11 49l27 12q18 -55 47.5 -87.5t85.5 -32.5q22 0 50 6l5 18q-76 45 -121.5 120t-45.5 165q0 69 26.5 129t73 105.5t108.5 71t132 25.5q71 0 132.5 -25.5t108 -71t73 -105.5t26.5 -129q0 -90 -45 -165t-122 -120l5 -18 q29 -6 50 -6q56 0 85.5 32.5t47.5 87.5l27 -12q-6 -18 -11 -49t-8.5 -61.5t-4.5 -48.5h-226l-24 89q39 25 65.5 72.5t39.5 104t13 106.5q0 74 -31.5 134.5t-84 96t-116.5 35.5t-116.5 -35.5t-84 -96t-31.5 -134.5q0 -50 13 -106.5t39.5 -104t65.5 -72.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni03BC",
    unicode: "\u03BC",
    horizAdvX: 550,
    d: "M217 -9q-28 0 -51.5 10.5t-31.5 35.5h-4v-58q0 -40 6 -75.5t21.5 -57.5t44.5 -22q14 0 14 -13q0 -16 -8 -32.5t-20 -27t-23 -10.5q-15 0 -29 11t-25.5 44.5t-18.5 101t-7 180.5q0 77 -1 133.5t-2.5 100.5t-3.5 84l-59 19l-2 26q27 0 64.5 5.5t62.5 12.5l19 -9l-0.5 -27.5 t-1 -73.5t-1 -101t-0.5 -110q0 -52 22 -66t58 -14q37 0 76 12t60 25q2 20 3 48t1 86q0 73 -2 108.5t-4 47l-2 11.5l-63 19l-2 26q18 0 42.5 2.5t48.5 7t41 8.5l19 -9l-1.5 -59t-1.5 -189q0 -63 1.5 -86.5l1.5 -23.5q1 -27 11 -37.5t24 -10.5q17 0 38 12l3 -30 q-18 -16 -40 -26t-43 -10q-25 0 -45 16t-25 50q-16 -16 -44 -31t-59.5 -24.5t-60.5 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "pi",
    unicode: "\u03C0",
    horizAdvX: 539,
    d: "M263 456l150 2q26 0 49.5 6.5t36.5 12.5l15 -19q-4 -16 -14.5 -34t-21 -30t-15.5 -12q-19 0 -34.5 0.5t-29.5 1.5v-291q0 -20 7.5 -29.5t16.5 -9.5q14 0 31 16t29 37l29 -18q-25 -46 -59 -72t-64 -26q-28 0 -48.5 24t-20.5 76v294h-139q0 -107 -4.5 -178.5t-12.5 -115 t-18 -65t-21.5 -28.5t-23.5 -7q-11 0 -23 10.5t-20 27t-8 32.5q0 13 14 13q21 0 35.5 8.5t22.5 38.5t11.5 92.5t3.5 171.5h-19q-26 0 -49 -6.5t-37 -12.5l-15 19q5 17 15 34.5t20.5 29.5t15.5 12q61 -3 115.5 -4t79.5 -1z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wgrave",
    unicode: "\u1E80",
    horizAdvX: 990,
    d: "M491 531h-4l-149 -531l-92 -9l-163 625q-7 17 -23.5 25.5t-61.5 17.5l3 29l64 -2t69 -1q72 0 135 3l3 -29q-40 -8 -64 -15.5t-24 -21.5q0 -3 10 -46.5t27.5 -115.5t39.5 -162.5t45 -188.5h5q25 82 48.5 164.5t43.5 156t35 131.5t23.5 91l8.5 33h65l176 -576h5 q13 56 28.5 121l31 130t27.5 120.5t19.5 93t7.5 47.5q0 14 -22.5 22t-63.5 16l3 29l64 -2t69 -1q38 0 60.5 1t53.5 2l3 -29q-45 -9 -65 -19.5t-25 -29.5l-7.5 -30.5t-20.5 -82t-29.5 -116t-34.5 -133.5t-35 -133t-31 -115l-92 -9zM520 747l-173 162q2 17 23 29.5t46 12.5 l134 -199z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wgrave",
    unicode: "\u1E81",
    horizAdvX: 725,
    d: "M604 396q0 11 -17 19t-46 12l-3 29l26 -1.5t54 -1.5q19 0 42.5 1t41.5 1.5l18 0.5l3 -29q-32 -4 -45.5 -13.5t-17.5 -23.5l-111 -390l-79 -9l-110 288l-103 -279l-78 -9l-112 395q-3 11 -15.5 23.5t-45.5 17.5l-3 29l18 -0.5t42 -1.5t42 -1q19 0 45.5 1t46.5 1.5l20 0.5 l3 -29q-38 -5 -52.5 -15.5t-14.5 -18.5q0 -2 5.5 -26t14.5 -60.5t19.5 -79.5t21 -85.5t18.5 -75.5l136 384h22l132 -384q8 34 18.5 76t22 85t20.5 80.5t15 61.5t6 27zM415 518l-173 162q2 17 23 29.5t46 12.5l134 -199z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wacute",
    unicode: "\u1E82",
    horizAdvX: 990,
    d: "M491 531h-4l-149 -531l-92 -9l-163 625q-7 17 -23.5 25.5t-61.5 17.5l3 29l64 -2t69 -1q72 0 135 3l3 -29q-40 -8 -64 -15.5t-24 -21.5q0 -3 10 -46.5t27.5 -115.5t39.5 -162.5t45 -188.5h5q25 82 48.5 164.5t43.5 156t35 131.5t23.5 91l8.5 33h65l176 -576h5 q13 56 28.5 121l31 130t27.5 120.5t19.5 93t7.5 47.5q0 14 -22.5 22t-63.5 16l3 29l64 -2t69 -1q38 0 60.5 1t53.5 2l3 -29q-45 -9 -65 -19.5t-25 -29.5l-7.5 -30.5t-20.5 -82t-29.5 -116t-34.5 -133.5t-35 -133t-31 -115l-92 -9zM636 909l-173 -162l-30 5l134 199 q25 0 46 -12.5t23 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wacute",
    unicode: "\u1E83",
    horizAdvX: 725,
    d: "M604 396q0 11 -17 19t-46 12l-3 29l26 -1.5t54 -1.5q19 0 42.5 1t41.5 1.5l18 0.5l3 -29q-32 -4 -45.5 -13.5t-17.5 -23.5l-111 -390l-79 -9l-110 288l-103 -279l-78 -9l-112 395q-3 11 -15.5 23.5t-45.5 17.5l-3 29l18 -0.5t42 -1.5t42 -1q19 0 45.5 1t46.5 1.5l20 0.5 l3 -29q-38 -5 -52.5 -15.5t-14.5 -18.5q0 -2 5.5 -26t14.5 -60.5t19.5 -79.5t21 -85.5t18.5 -75.5l136 384h22l132 -384q8 34 18.5 76t22 85t20.5 80.5t15 61.5t6 27zM529 680l-173 -162l-30 5l134 199q25 0 46 -12.5t23 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wdieresis",
    unicode: "\u1E84",
    horizAdvX: 990,
    d: "M491 531h-4l-149 -531l-92 -9l-163 625q-7 17 -23.5 25.5t-61.5 17.5l3 29l64 -2t69 -1q72 0 135 3l3 -29q-40 -8 -64 -15.5t-24 -21.5q0 -3 10 -46.5t27.5 -115.5t39.5 -162.5t45 -188.5h5q25 82 48.5 164.5t43.5 156t35 131.5t23.5 91l8.5 33h65l176 -576h5 q13 56 28.5 121l31 130t27.5 120.5t19.5 93t7.5 47.5q0 14 -22.5 22t-63.5 16l3 29l64 -2t69 -1q38 0 60.5 1t53.5 2l3 -29q-45 -9 -65 -19.5t-25 -29.5l-7.5 -30.5t-20.5 -82t-29.5 -116t-34.5 -133.5t-35 -133t-31 -115l-92 -9zM595 792q-22 0 -37 15.5t-15 38.5 q0 22 15 37t37 15t37 -15t15 -37q0 -23 -15 -38.5t-37 -15.5zM415 792q-22 0 -37 15.5t-15 38.5q0 22 15 37t37 15t37 -15t15 -37q0 -23 -15 -38.5t-37 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wdieresis",
    unicode: "\u1E85",
    horizAdvX: 725,
    d: "M604 396q0 11 -17 19t-46 12l-3 29l26 -1.5t54 -1.5q19 0 42.5 1t41.5 1.5l18 0.5l3 -29q-32 -4 -45.5 -13.5t-17.5 -23.5l-111 -390l-79 -9l-110 288l-103 -279l-78 -9l-112 395q-3 11 -15.5 23.5t-45.5 17.5l-3 29l18 -0.5t42 -1.5t42 -1q19 0 45.5 1t46.5 1.5l20 0.5 l3 -29q-38 -5 -52.5 -15.5t-14.5 -18.5q0 -2 5.5 -26t14.5 -60.5t19.5 -79.5t21 -85.5t18.5 -75.5l136 384h22l132 -384q8 34 18.5 76t22 85t20.5 80.5t15 61.5t6 27zM473 563q-22 0 -37 15.5t-15 38.5q0 22 15 37t37 15t37 -15t15 -37q0 -23 -15 -38.5t-37 -15.5zM293 563 q-22 0 -37 15.5t-15 38.5q0 22 15 37t37 15t37 -15t15 -37q0 -23 -15 -38.5t-37 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ygrave",
    unicode: "\u1EF2",
    horizAdvX: 641,
    d: "M336 331q45 83 73.5 136.5t44.5 84.5t23 45.5t8.5 19t1.5 6.5q0 12 -26 20t-66 16l3 29l64 -2t69 -1q38 0 60.5 1t53.5 2l3 -29q-45 -9 -62.5 -20t-27.5 -29l-193 -347q1 -77 2.5 -119t3.5 -58.5l2 -16.5q2 -19 21 -26.5t64 -16.5l-3 -29q-31 2 -63 2.5t-70 0.5 q-78 0 -141 -3l-3 29q45 9 66 16.5t23 26.5l1.5 17t3.5 59.5t2 116.5l-193 354q-9 17 -24.5 25.5t-60.5 17.5l3 29l64 -2t69 -1q78 0 141 3l3 -29q-40 -7 -64.5 -15t-24.5 -21q0 -2 0.5 -4t1.5 -4zM352 747l-173 162q2 17 23 29.5t46 12.5l134 -199z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ygrave",
    unicode: "\u1EF3",
    horizAdvX: 482,
    d: "M228 0l-35 21l-130 365q-4 11 -16 23.5t-45 17.5l-3 29l18 -0.5t42 -1.5t42 -1q19 0 42 1t39.5 1.5l16.5 0.5l3 -29q-33 -4 -46.5 -13t-13.5 -17q0 -4 29 -88.5t81 -244.5q56 158 84 241.5t28 92.5q0 22 -55 29l-3 29l22 -1.5t50 -1.5q18 0 42 1t42 1.5l18 0.5l3 -29 q-31 -4 -43.5 -11.5t-17 -21.5t-14.5 -40l-133 -354q-36 -96 -68 -150t-57.5 -78t-44.5 -29.5t-30 -5.5q-5 0 -15.5 10.5t-20.5 27t-15 32.5l15 19q19 -9 45 -9q16 0 38 14t49 53.5t57 115.5zM287 518l-173 162q2 17 23 29.5t46 12.5l134 -199z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "endash",
    unicode: "\u2013",
    horizAdvX: 560,
    d: "M37 294q61 -3 121.5 -4t121.5 -1q71 0 140.5 1t139.5 4l7 -15l-44 -48q-61 2 -121.5 3t-121.5 1q-70 0 -140 -1t-140 -4l-7 16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emdash",
    unicode: "\u2014",
    horizAdvX: 838,
    d: "M37 294q91 -2 181.5 -4t180.5 -2q110 0 220 2t219 4l7 -15l-44 -48q-90 2 -180 2h-181q-109 0 -219.5 -0.5t-220.5 -2.5l-7 16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteleft",
    unicode: "\u2018",
    horizAdvX: 215,
    d: "M103 442q-31 0 -52 25t-21 61q0 40 33.5 83.5t112.5 68.5l9 -22q-45 -20 -76.5 -53.5t-31.5 -78.5q8 9 17.5 12t16.5 3q20 0 33.5 -14t13.5 -35q0 -24 -17 -37t-38 -13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteright",
    unicode: "\u2019",
    horizAdvX: 215,
    d: "M112 682q32 0 52.5 -25t20.5 -61q0 -40 -33 -83t-113 -69l-9 22q45 20 76.5 53.5t31.5 78.5q-8 -9 -17 -12t-17 -3q-19 0 -33 14t-14 35q0 24 17 37t38 13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesinglbase",
    unicode: "\u201A",
    horizAdvX: 214,
    d: "M112 91q32 0 52.5 -25t20.5 -61q0 -40 -33 -83t-113 -69l-9 22q45 20 76.5 53.5t31.5 78.5q-8 -9 -17 -12t-17 -3q-19 0 -33 14t-14 35q0 24 17 37t38 13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblleft",
    unicode: "\u201C",
    horizAdvX: 378,
    d: "M103 442q-31 0 -52 25t-21 61q0 40 33.5 83.5t112.5 68.5l9 -22q-45 -20 -76.5 -53.5t-31.5 -78.5q8 9 17.5 12t16.5 3q20 0 33.5 -14t13.5 -35q0 -24 -17 -37t-38 -13zM266 442q-31 0 -52 25t-21 61q0 40 33.5 83.5t112.5 68.5l9 -22q-45 -20 -76.5 -53.5t-31.5 -78.5 q8 9 17.5 12t16.5 3q20 0 33.5 -14t13.5 -35q0 -24 -17 -37t-38 -13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblright",
    unicode: "\u201D",
    horizAdvX: 378,
    d: "M275 682q32 0 52.5 -25t20.5 -61q0 -40 -33 -83t-113 -69l-9 22q45 20 76.5 53.5t31.5 78.5q-8 -9 -17 -12t-17 -3q-19 0 -33 14t-14 35q0 24 17 37t38 13zM112 682q32 0 52.5 -25t20.5 -61q0 -40 -33 -83t-113 -69l-9 22q45 20 76.5 53.5t31.5 78.5q-8 -9 -17 -12 t-17 -3q-19 0 -33 14t-14 35q0 24 17 37t38 13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblbase",
    unicode: "\u201E",
    horizAdvX: 378,
    d: "M275 91q32 0 52.5 -25t20.5 -61q0 -40 -33 -83t-113 -69l-9 22q45 20 76.5 53.5t31.5 78.5q-8 -9 -17 -12t-17 -3q-19 0 -33 14t-14 35q0 24 17 37t38 13zM112 91q32 0 52.5 -25t20.5 -61q0 -40 -33 -83t-113 -69l-9 22q45 20 76.5 53.5t31.5 78.5q-8 -9 -17 -12t-17 -3 q-19 0 -33 14t-14 35q0 24 17 37t38 13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dagger",
    unicode: "\u2020",
    horizAdvX: 418,
    d: "M148 672h122q-8 -45 -13.5 -86.5t-9.5 -81.5q72 2 116.5 9l44.5 7l8 -18l-44 -61l-35 4t-94 5q-8 -118 -2 -225t16 -225l-48 -9l-48 9q11 118 16.5 225t-2.5 225q-73 -1 -120.5 -8l-47.5 -7l-7 18l43 61l35 -4t92 -6q-4 40 -9 81.5t-13 86.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "daggerdbl",
    unicode: "\u2021",
    horizAdvX: 418,
    d: "M268 -204h-122q8 45 13.5 86.5t9.5 81.5q-72 -2 -116.5 -9l-44.5 -7l-8 18l44 61l31.5 -3.5t86.5 -5.5q5 51 8.5 109.5t5.5 106.5q-1 58 -6 106.5t-10 109.5q-67 -2 -110 -8.5l-43 -6.5l-7 18l43 61l35 -4t92 -6q-4 40 -9 81.5t-13 86.5h122q-8 -45 -13.5 -86.5 t-9.5 -81.5q72 2 116.5 9l44.5 7l8 -18l-44 -61l-32 3.5t-87 5.5q-4 -51 -8 -109.5t-6 -106.5q2 -58 6.5 -106t9.5 -110q68 2 111 8.5l43 6.5l7 -18l-43 -61l-35 4.5t-92 5.5q4 -40 9.5 -81.5t12.5 -86.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bullet",
    unicode: "\u2022",
    horizAdvX: 398,
    d: "M70 356q0 36 17.5 65t47 46.5t64.5 17.5q36 0 65 -17.5t46.5 -46.5t17.5 -65q0 -35 -17.5 -64.5t-46.5 -47t-65 -17.5q-35 0 -64.5 17.5t-47 47t-17.5 64.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ellipsis",
    unicode: "\u2026",
    horizAdvX: 585,
    d: "M292 -9q-22 0 -37 15t-15 40q0 23 15 37.5t37 14.5t37.5 -14.5t15.5 -37.5q0 -25 -15.5 -40t-37.5 -15zM502 -9q-22 0 -37 15t-15 40q0 23 15 37.5t37 14.5t37.5 -14.5t15.5 -37.5q0 -25 -15.5 -40t-37.5 -15zM82 -9q-22 0 -37 15t-15 40q0 23 15 37.5t37 14.5 t37.5 -14.5t15.5 -37.5q0 -25 -15.5 -40t-37.5 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "perthousand",
    unicode: "\u2030",
    horizAdvX: 985,
    d: "M146 -1l412 680h48l-412 -680h-48zM314 509q0 -45 -13 -82t-38.5 -59t-65.5 -22q-39 0 -65 22t-39 59t-13 82t13 82.5t39 59.5t65 22q40 0 65.5 -22t38.5 -59.5t13 -82.5zM197 638q-22 0 -34 -37.5t-12 -90.5q0 -55 12 -91.5t34 -36.5q23 0 34.5 36.5t11.5 91.5 q0 53 -11.5 90.5t-34.5 37.5zM664 154q0 -45 -13 -82t-38.5 -59t-65.5 -22t-65.5 22t-38.5 59t-13 82t13 82.5t38.5 59.5t65.5 22t65.5 -22t38.5 -59.5t13 -82.5zM935 154q0 -45 -13 -82t-38.5 -59t-65.5 -22q-39 0 -65 22t-39 59t-13 82t13 82.5t39 59.5t65 22 q40 0 65.5 -22t38.5 -59.5t13 -82.5zM547 283q-22 0 -34 -37.5t-12 -90.5q0 -55 12 -91.5t34 -36.5q23 0 34.5 36.5t11.5 91.5q0 53 -11.5 90.5t-34.5 37.5zM818 283q-22 0 -34 -37.5t-12 -90.5q0 -55 12 -91.5t34 -36.5q23 0 34.5 36.5t11.5 91.5q0 53 -11.5 90.5 t-34.5 37.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglleft",
    unicode: "\u2039",
    horizAdvX: 371,
    d: "M251 389l20 -17l-104 -149l104 -149l-20 -17l-157 151q-4 8 -4 15t4 15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglright",
    unicode: "\u203A",
    horizAdvX: 371,
    d: "M100 372l20 17l157 -151q4 -8 4 -15t-4 -15l-157 -151l-20 17l104 149z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fraction",
    unicode: "\u2044",
    horizAdvX: 460,
    d: "M0 -1l412 680h48l-412 -680h-48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2070",
    unicode: "\u2070",
    horizAdvX: 320,
    d: "M303 466q0 -56 -15.5 -102.5t-47.5 -74t-81 -27.5t-80.5 27.5t-47 74t-15.5 102.5q0 57 15.5 103.5t47 74t80.5 27.5t81 -27.5t47.5 -74t15.5 -103.5zM159 634q-23 0 -38.5 -22.5t-22.5 -60.5t-7 -85q0 -46 7 -84t22.5 -60.5t38.5 -22.5q24 0 39.5 22.5t22.5 60.5t7 84 q0 47 -7 85t-22.5 60.5t-39.5 22.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2074",
    unicode: "\u2074",
    horizAdvX: 320,
    d: "M260 537v-125h46l4 -11l-23 -34l-26 2q1 -36 2 -44.5l1 -8.5q2 -10 14 -15t37 -10l-2 -26q-40 3 -89 3q-25 0 -53 -0.5t-48 -2.5l-2 26q27 5 46.5 10t20.5 15l1 8.5t2 45.5h-172l-10 31l170 295l70 -6l-177 -279h119v112l4 3.5t18.5 7t46.5 3.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2075",
    unicode: "\u2075",
    horizAdvX: 320,
    d: "M50 509l29 152l198 20l5 -9l-25 -54l-10.5 1.5t-33.5 1.5q-4 0 -12 -0.5t-27 -1.5t-58 -5l-17 -88q66 -2 107.5 -21t61 -48t19.5 -62q0 -37 -24 -72.5t-67.5 -58.5t-103.5 -23q-27 0 -59 6l2 35q26 -3 47 -3q62 0 95 32t33 71q0 40 -37.5 71t-114.5 31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2076",
    unicode: "\u2076",
    horizAdvX: 320,
    d: "M131 430l-3 29q30 13 54 13q56 0 85 -31.5t29 -69.5q0 -27 -14.5 -53t-43.5 -43t-73 -17q-61 0 -101 40t-40 109q0 45 26 99t78 103.5t129 82.5l18 -29q-60 -31 -99 -76.5t-57.5 -94.5t-18.5 -91q0 -49 16 -77.5t44 -28.5q26 0 42.5 22t16.5 52q0 27 -14 47.5t-41 20.5 q-16 0 -33 -7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2077",
    unicode: "\u2077",
    horizAdvX: 320,
    d: "M297 642l-169 -395l-75 6l175 356q-1 9 -14 11.5t-36 2.5q-38 0 -63 -3t-39.5 -16.5t-24.5 -47.5l-29 8q2 13 3.5 33t2.5 39.5t1 32.5q20 -1 61.5 -2t84.5 -1h70.5t49.5 1z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2078",
    unicode: "\u2078",
    horizAdvX: 320,
    d: "M293 368q0 -34 -20 -59t-51.5 -38t-67.5 -13q-53 0 -90.5 27t-37.5 74q0 32 18.5 61t63.5 51q-45 29 -58 56.5t-13 47.5q0 41 36.5 68.5t90.5 27.5q56 0 86.5 -26t30.5 -60q0 -27 -16 -53.5t-55 -48.5q47 -25 65 -53.5t18 -61.5zM159 634q-22 0 -36.5 -13.5t-14.5 -33.5 q0 -29 21 -49t42 -32q20 13 31.5 34.5t11.5 40.5q0 22 -13.5 37.5t-41.5 15.5zM160 297q25 0 43 19t18 44q0 23 -15.5 47t-55.5 42q-24 -13 -38 -38t-14 -50t15.5 -44.5t46.5 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2079",
    unicode: "\u2079",
    horizAdvX: 321,
    d: "M186 481l3 -27q-26 -10 -48 -10q-39 0 -66 16.5t-41 42.5t-14 54q0 29 14.5 55t44 42.5t74.5 16.5q43 0 76 -20.5t52 -55t19 -78.5q0 -47 -25.5 -99.5t-80.5 -102t-146 -88.5l-17 30q69 31 111.5 74.5t62.5 93.5t20 99q0 52 -21 80t-49 28q-26 0 -43.5 -21.5t-17.5 -56.5 q0 -28 16 -52t48 -24q13 0 28 3z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2080",
    unicode: "\u2080",
    horizAdvX: 320,
    d: "M303 39q0 -56 -15.5 -102.5t-47.5 -74t-81 -27.5t-80.5 27.5t-47 74t-15.5 102.5q0 57 15.5 103.5t47 74t80.5 27.5t81 -27.5t47.5 -74t15.5 -103.5zM159 207q-23 0 -38.5 -22.5t-22.5 -60.5t-7 -85q0 -46 7 -84t22.5 -60.5t38.5 -22.5q24 0 39.5 22.5t22.5 60.5t7 84 q0 47 -7 85t-22.5 60.5t-39.5 22.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2081",
    unicode: "\u2081",
    horizAdvX: 320,
    d: "M194 244l14 -6l-1 -48t-1 -145q0 -61 1 -95.5t2 -48l1 -13.5q2 -10 14 -14.5t37 -9.5l-2 -26q-19 1 -40.5 1.5t-44.5 0.5q-28 0 -56.5 -0.5t-53.5 -1.5l-2 26q26 4 46.5 9t21.5 15l1 13.5t2 48t1 95.5q0 62 -1 93t-2 41.5l-1 10.5l-69 13l-2 29q47 0 81.5 4t53.5 8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2082",
    unicode: "\u2082",
    horizAdvX: 320,
    d: "M286 135q0 -37 -18.5 -72.5t-46 -67t-55.5 -56t-48 -39.5t-23 -17l2 -3q61 0 95.5 4t52.5 18t27 45l30 -7q-3 -11 -6 -30.5t-4.5 -38.5t-2.5 -31h-264l-7 30l19.5 16t47.5 42.5t56.5 60t48 69.5t19.5 69q0 38 -21.5 53t-49.5 15q-25 0 -49.5 -8t-36.5 -15l-15 24 q23 19 53.5 33.5t72.5 14.5q32 0 60 -12t45.5 -36t17.5 -61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2083",
    unicode: "\u2083",
    horizAdvX: 320,
    d: "M266 169q0 -31 -22.5 -62.5t-66.5 -49.5v-4q52 -7 80 -38.5t28 -70.5q0 -31 -20 -61t-62.5 -49.5t-108.5 -19.5q-29 0 -64 6l2 37q21 -5 59 -5q41 0 68 14.5t40 36.5t13 45q0 32 -23 56.5t-68 24.5q-10 0 -20.5 -1t-22.5 -5l2 36q64 11 90 38.5t26 52.5q0 26 -15 36.5 t-38 10.5q-21 0 -42 -7.5t-38 -17.5l-14 25q26 21 56 34t67 13q48 0 71 -22t23 -53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2084",
    unicode: "\u2084",
    horizAdvX: 320,
    d: "M260 110v-125h46l4 -11l-23 -34l-26 2q1 -36 2 -44.5l1 -8.5q2 -10 14 -15t37 -10l-2 -26q-40 3 -89 3q-25 0 -53 -0.5t-48 -2.5l-2 26q27 5 46.5 10t20.5 15l1 8.5t2 45.5h-172l-10 31l170 295l70 -6l-177 -279h119v112l4 3.5t18.5 7t46.5 3.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2085",
    unicode: "\u2085",
    horizAdvX: 320,
    d: "M50 82l29 152l198 20l5 -9l-25 -54l-10.5 1.5t-33.5 1.5q-4 0 -12 -0.5t-27 -1.5t-58 -5l-17 -88q66 -2 107.5 -21t61 -48t19.5 -62q0 -37 -24 -72.5t-67.5 -58.5t-103.5 -23q-27 0 -59 6l2 35q26 -3 47 -3q62 0 95 32t33 71q0 40 -37.5 71t-114.5 31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2086",
    unicode: "\u2086",
    horizAdvX: 320,
    d: "M131 3l-3 29q30 13 54 13q56 0 85 -31.5t29 -69.5q0 -27 -14.5 -53t-43.5 -43t-73 -17q-61 0 -101 40t-40 109q0 45 26 99t78 103.5t129 82.5l18 -29q-60 -31 -99 -76.5t-57.5 -94.5t-18.5 -91q0 -49 16 -77.5t44 -28.5q26 0 42.5 22t16.5 52q0 27 -14 47.5t-41 20.5 q-16 0 -33 -7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2087",
    unicode: "\u2087",
    horizAdvX: 320,
    d: "M297 215l-169 -395l-75 6l175 356q-1 9 -14 11.5t-36 2.5q-38 0 -63 -3t-39.5 -16.5t-24.5 -47.5l-29 8q2 13 3.5 33t2.5 39.5t1 32.5q20 -1 61.5 -2t84.5 -1h70.5t49.5 1z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2088",
    unicode: "\u2088",
    horizAdvX: 320,
    d: "M293 -59q0 -34 -20 -59t-51.5 -38t-67.5 -13q-53 0 -90.5 27t-37.5 74q0 32 18.5 61t63.5 51q-45 29 -58 56.5t-13 47.5q0 41 36.5 68.5t90.5 27.5q56 0 86.5 -26t30.5 -60q0 -27 -16 -53.5t-55 -48.5q47 -25 65 -53.5t18 -61.5zM159 207q-22 0 -36.5 -13.5t-14.5 -33.5 q0 -29 21 -49t42 -32q20 13 31.5 34.5t11.5 40.5q0 22 -13.5 37.5t-41.5 15.5zM160 -130q25 0 43 19t18 44q0 23 -15.5 47t-55.5 42q-24 -13 -38 -38t-14 -50t15.5 -44.5t46.5 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2089",
    unicode: "\u2089",
    horizAdvX: 320,
    d: "M186 54l3 -27q-26 -10 -48 -10q-39 0 -66 16.5t-41 42.5t-14 54q0 29 14.5 55t44 42.5t74.5 16.5q43 0 76 -20.5t52 -55t19 -78.5q0 -47 -25.5 -99.5t-80.5 -102t-146 -88.5l-17 30q69 31 111.5 74.5t62.5 93.5t20 99q0 52 -21 80t-49 28q-26 0 -43.5 -21.5t-17.5 -56.5 q0 -28 16 -52t48 -24q13 0 28 3z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "franc",
    unicode: "\u20A3",
    horizAdvX: 554,
    d: "M360 151h-141q1 -46 3 -64l2 -18q2 -19 21 -26.5t64 -16.5l-3 -29q-31 2 -63 2.5t-70 0.5q-78 0 -141 -3l-3 29q45 9 66 16.5t23 26.5l1.5 18t3.5 64h-83l6 43h78q1 29 1.5 65.5t0.5 82.5q0 108 -2 167.5t-4 83l-2 23.5q-2 19 -19.5 26.5t-62.5 16.5l3 29q21 -1 34 -1.5 t27 -1t39 -0.5h137.5t137 1.5t105.5 4.5v-15q0 -21 1.5 -49t4.5 -54.5t6 -43.5l-27 -12q-13 42 -27.5 67.5t-36 38t-54 16.5t-80.5 4q-36 0 -57.5 -2.5t-23.5 -19.5l-2 -23.5t-4 -79t-3 -151.5q32 0 66 1t62 2.5t40 4.5q17 3 23.5 15t15.5 48l35 -4q-2 -21 -3 -42.5 t-1 -43.5q0 -42 3 -83l-35 -5q-8 34 -14.5 45t-23.5 14q-12 3 -40 4.5t-62 2.5t-66 1q0 -41 0.5 -74t0.5 -59h149z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lira",
    unicode: "\u20A4",
    horizAdvX: 523,
    d: "M46 379h86q-3 36 -8 64t-5 47q0 83 49 117t128 34q37 0 58.5 -6.5t48.5 -6.5q8 0 18 1.5t21 3.5q0 -17 1.5 -42.5t4 -51t5.5 -43.5l-24 -11q-19 68 -51 90t-81 22q-39 0 -58.5 -20.5t-25.5 -54.5t-6 -75q0 -16 0.5 -32.5t1.5 -35.5h157l-6 -43h-150v-4q0 -24 -2 -48h158 l-6 -43h-157q-9 -60 -28 -112t-47 -79q36 -4 67 -6t56 -2q61 0 98.5 11.5t60 35.5t36.5 62l23 -11q-5 -16 -9.5 -43t-7.5 -54t-4 -43h-402l-15 24l45 30q41 70 53 187h-89l6 43h87q1 23 1 48v4h-94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Euro",
    unicode: "\u20AC",
    horizAdvX: 523,
    d: "M327 641q37 0 58.5 -6.5t48.5 -6.5q8 0 18 1.5t21 3.5v-13q0 -27 3.5 -64t7.5 -60l-24 -11q-19 68 -51 90t-81 22q-68 0 -100 -59t-40 -159h187l-6 -43h-183q-1 -13 -1 -25.5v-26.5h190l-6 -43h-183q6 -97 47 -143t119 -46q27 0 59 7t66 23l14 -29q-34 -27 -76.5 -44.5 t-98.5 -17.5q-64 0 -114.5 31t-81.5 87.5t-39 131.5h-50l6 43h41v7q0 11 0.5 22.5t1.5 22.5h-49l6 43h47q12 70 41.5 129.5t79.5 96t122 36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2113",
    unicode: "\u2113",
    horizAdvX: 403,
    d: "M110 79l-1 131q-32 -22 -68 -42l-18 34q47 25 86 56l-1 302q0 52 31.5 88.5t89.5 36.5q59 0 91 -36t31.5 -95t-38 -131t-116.5 -144v-172q0 -55 37.5 -53.5t116.5 78.5l25 -26q-38 -55 -83.5 -86t-87 -35.5t-68.5 18.5t-27 76zM197 563v-221q44 54 65 107t23.5 96 t-9.5 69t-34 26q-27 0 -36 -22.5t-9 -54.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "trademark",
    unicode: "\u2122",
    horizAdvX: 852,
    d: "M297 621h-10q-3 0 -5 -1.5t-3 -8.5l-2 -26.5t-2 -102.5t2 -102.5l2 -26.5q1 -8 10 -11.5t30 -7.5l-1 -17q-16 1 -34 1h-37h-37.5t-35.5 -1l-2 17q22 4 31.5 7.5t10.5 11.5l2 26.5t2 102.5t-2 102.5l-2 26.5q-1 7 -3 8.5t-5 1.5h-10q-23 0 -37.5 -2.5t-23.5 -14t-17 -38.5 l-18 4q2 12 4 34t2 38v7q29 -2 61.5 -3t79.5 -1t79 1t61 3v-7q0 -16 2 -38t4 -34l-18 -4q-8 27 -17 38.5t-23 14t-38 2.5zM716 553h-4l-94 -233l-33 -7l-98 240h-4q0 -25 -0.5 -61.5t-1 -70.5t-0.5 -55q0 -10 10 -18.5t40 -13.5l-2 -17q-16 1 -36.5 1h-40.5h-29t-26 -1 l-2 17q22 4 31 7.5t10 11.5q3 14 4.5 47t3 72t2 72.5t0.5 48.5q0 21 -7 26t-34 11l1 17q10 0 28.5 -0.5t38 -1t30.5 -0.5l104 -261l106 261q12 0 31 0.5t37.5 1t28.5 0.5l2 -17q-22 -4 -30 -7.5t-9 -11.5q-1 -27 -1.5 -59t-0.5 -55q0 -46 2 -78.5t6 -64.5q2 -8 12 -12t31 -8 l-1 -17q-16 1 -34.5 1h-37.5h-37t-35 -1l-2 17q30 5 38 11.5t8 25.5v26.5t-1 48t-1.5 56.5t-2.5 51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2126",
    unicode: "\u2126",
    horizAdvX: 816,
    d: "M294 89l-24 -89h-226q-1 18 -4.5 48.5t-8.5 61.5t-11 49l27 12q18 -55 47.5 -87.5t85.5 -32.5q22 0 50 6l5 18q-76 45 -121.5 120t-45.5 165q0 69 26.5 129t73 105.5t108.5 71t132 25.5q71 0 132.5 -25.5t108 -71t73 -105.5t26.5 -129q0 -90 -45 -165t-122 -120l5 -18 q29 -6 50 -6q56 0 85.5 32.5t47.5 87.5l27 -12q-6 -18 -11 -49t-8.5 -61.5t-4.5 -48.5h-226l-24 89q39 25 65.5 72.5t39.5 104t13 106.5q0 74 -31.5 134.5t-84 96t-116.5 35.5t-116.5 -35.5t-84 -96t-31.5 -134.5q0 -50 13 -106.5t39.5 -104t65.5 -72.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "estimated",
    unicode: "\u212E",
    horizAdvX: 788,
    d: "M755 302h-583q-5 0 -5 -4v-176q0 -12 8 -20q42 -44 99 -70t122 -26q70 0 129.5 29t102.5 78h52q-49 -57 -123.5 -91.5t-161.5 -34.5q-75 0 -140 25t-114.5 69.5t-77.5 103.5t-28 126t28 126t77.5 103.5t114.5 69.5t140 25t140 -25t114.5 -69.5t77.5 -103.5t28 -126v-9z M623 325v178q0 12 -9 21q-42 42 -98 67t-120 25t-121 -25.5t-99 -69.5q-9 -9 -9 -22v-174q0 -5 5 -5h447q4 0 4 5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "partialdiff",
    unicode: "\u2202",
    horizAdvX: 459,
    d: "M332 448l4 2q-21 76 -64.5 123.5t-105.5 47.5q-26 0 -49 -6.5t-37 -12.5l-15 19q5 17 15 33t20.5 26.5t15.5 10.5q47 0 103 -25t106 -75t82 -124t32 -172q0 -51 -19 -104t-54 -98.5t-83.5 -73.5t-108.5 -28q-52 0 -86.5 22.5t-51 60t-16.5 81.5q0 51 18 104t51.5 98.5 t81 73.5t107.5 28q11 0 27.5 -3t26.5 -8zM196 36q36 0 64.5 22.5t49 59t31 80t10.5 84.5q0 53 -21 92.5t-68 39.5q-36 0 -64.5 -22.5t-48.5 -59t-30.5 -80t-10.5 -84.5q0 -53 21 -92.5t67 -39.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2206",
    unicode: "\u2206",
    horizAdvX: 615,
    d: "M321 691h11l283 -691h-615zM488 50l-198 478l-223 -478h421z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "product",
    unicode: "\u220F",
    horizAdvX: 801,
    d: "M580 627h-355l-1 -31.5t-3 -84t-3 -118.5t-1 -135q0 -78 1 -148.5t3 -125.5t3 -86.5l1 -31.5q2 -19 21 -26.5t64 -16.5l-3 -29q-31 2 -63 2.5t-70 0.5q-78 0 -141 -3l-3 29q45 9 66 16.5t23 26.5l1 30.5t3 84.5t3 125t1 151q0 108 -2 188t-4 124.5l-2 44.5 q-2 19 -19.5 26.5t-62.5 16.5l3 29q32 -1 64.5 -2t69.5 -1h461q38 0 68.5 1t61.5 2l3 -29q-45 -9 -62.5 -16.5t-19.5 -26.5l-2 -44.5t-4 -124.5t-2 -188q0 -81 1 -151.5t3 -124.5t3 -84.5l1 -30.5q2 -19 21 -26.5t64 -16.5l-3 -29q-31 2 -63 2.5t-70 0.5q-78 0 -141 -3 l-3 29q45 9 66 16.5t23 26.5l1 32t3 87t3 125.5t1 147.5q0 69 -1 134t-3 117t-3 83.5t-1 34.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "summation",
    unicode: "\u2211",
    horizAdvX: 654,
    d: "M30 -168l295 394l-289 427v30h545v-15q0 -21 1.5 -49t4.5 -54.5t6 -43.5l-27 -12q-17 57 -51 83.5t-83 34.5t-114 8q-24 0 -56.5 -1t-57.5 -5.5t-27 -15.5l234 -354l-280 -379q0 -9 28 -15t73 -9.5t94 -3.5q52 0 105 9t97 34.5t69 72.5l27 -12q-6 -18 -11 -48.5 t-8.5 -61.5t-4.5 -49h-570v35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "minus",
    unicode: "\u2212",
    horizAdvX: 523,
    d: "M24 273v61h475v-61h-475z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "radical",
    unicode: "\u221A",
    horizAdvX: 574,
    d: "M579 691h-130l-187 -691h-29l-139 411l-85 -18l-9 37l162 35l93 -292h5l146 557h173v-39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "infinity",
    unicode: "\u221E",
    horizAdvX: 600,
    d: "M300 372q23 44 60 65.5t77 21.5q36 0 70 -17t55.5 -50t21.5 -80t-21.5 -80t-55.5 -50t-70 -17q-40 0 -77 21.5t-60 65.5q-23 -44 -60 -65.5t-77 -21.5q-36 0 -69.5 17t-55.5 50t-22 80t22 80t55.5 50t69.5 17q40 0 77 -21.5t60 -65.5zM523 312q0 43 -27.5 66t-62.5 23 q-33 0 -61.5 -22.5t-42.5 -66.5q14 -43 42.5 -65.5t61.5 -22.5q35 0 62.5 22.5t27.5 65.5zM77 312q0 -43 28 -65.5t62 -22.5q33 0 61.5 22.5t42.5 65.5q-14 44 -42.5 66.5t-61.5 22.5q-34 0 -62 -23t-28 -66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "integral",
    unicode: "\u222B",
    horizAdvX: 282,
    d: "M102 63v349q0 54 14 104t41 89.5t65.5 62.5t86.5 23q4 0 12 -10.5t16 -26.5t11 -33l-12 -19q-10 6 -28 12.5t-38 6.5q-30 0 -50 -14.5t-30 -58t-10 -131.5v-349q0 -54 -14 -104t-41 -89.5t-65.5 -62.5t-86.5 -23q-3 0 -11 10.5t-16 27t-12 32.5l12 19q10 -6 28 -12.5 t38 -6.5q30 0 50 14.5t30 58t10 131.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "approxequal",
    unicode: "\u2248",
    horizAdvX: 523,
    d: "M499 415v-61q-59 24 -101.5 27.5t-75 -5.5t-61.5 -21.5t-61 -21t-74.5 -5.5t-101.5 26v61q59 -23 101.5 -26t74.5 5.5t61 21t61.5 21.5t75 5.5t101.5 -27.5zM499 253v-61q-59 24 -101.5 27.5t-75 -5.5t-61.5 -21.5t-61 -21t-74.5 -5.5t-101.5 26v61q59 -23 101.5 -26 t74.5 5.5t61 21t61.5 21.5t75 5.5t101.5 -27.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "notequal",
    unicode: "\u2260",
    horizAdvX: 523,
    d: "M24 192v61h170l58 101h-228v61h263l127 223h65l-127 -223h147v-61h-182l-58 -101h240v-61h-275l-114 -201h-65l114 201h-135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lessequal",
    unicode: "\u2264",
    horizAdvX: 523,
    d: "M487 56l-450 247l450 247v-69l-336 -178l336 -178v-69zM34 -60v61h453v-61h-453z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greaterequal",
    unicode: "\u2265",
    horizAdvX: 523,
    d: "M485 303l-450 -247v69l336 178l-336 178v69zM488 1v-61h-453v61h453z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lozenge",
    unicode: "\u25CA",
    horizAdvX: 450,
    d: "M248 0h-47l-161 345l161 346h47l162 -346zM345 345l-120 286l-119 -286l119 -285z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF8FF",
    unicode: "\uF8FF",
    horizAdvX: 923,
    d: "M566 -88q-14 0 -31 -12q-18 -12 -27 -12q-11 0 -23 4t-23 6q-4 1 -9.5 -1t-13.5 -5q-16 -6 -24 -6q-7 0 -25 13q-17 13 -29 12l-24 -2q-16 -2 -33 17l-18 19q-4 5 -11 6t-14 1q-11 0 -22 7q-9 6 -16 23q-3 9 -6.5 14.5t-5.5 7.5q-6 4 -20 10q-15 7 -20 14q-4 7 -7 24 q-1 15 -6 21q-1 3 -5 6t-9 7q-25 18 -22 38l3 25q1 7 -12 27q-13 17 -13 26t6 24t6 23q0 9 -6 21q-6 14 -6 22q0 10 13 30q12 21 12 29l-1 25q0 15 17 30q8 8 13 12.5t6 6.5q2 5 4 21q3 16 6 22q5 7 20 12q15 6 20 11q6 6 12 21q7 14 14 21q6 6 25 9q20 5 25 7q5 3 20 20 q16 19 29 18l26 -2q7 -1 14 2.5t15 9.5q14 11 26 11q11 -1 21.5 -6.5t22.5 -5.5t23 4.5t22 7.5q7 2 14.5 -2t14.5 -10q8 -6 15 -10t13 -3l28 3q16 1 29 -16q15 -18 20 -20q3 -1 8.5 -3t12.5 -4q8 -1 13.5 -3t9.5 -5q6 -3 12 -19q4 -12 11 -19q2 -2 8.5 -6t16.5 -9 q21 -10 25 -19q5 -8 5 -24q0 -15 3 -20q1 -2 6 -6.5t13 -12.5q17 -14 17 -31l-1 -25q0 -13 12 -31t12 -28q0 -4 -1 -9.5t-4 -12.5q-2 -6 -4 -11t-2 -9q0 -6 6 -21q2 -7 3.5 -12.5t1.5 -10.5q0 -7 -13 -20t-12 -27l2 -32q1 -15 -16 -29q-15 -12 -18 -18q-1 -2 -3 -8t-4 -16 q-5 -20 -10 -25q-6 -6 -18 -12q-13 -6 -18 -11q-6 -6 -14 -21q-9 -16 -16 -22q-5 -4 -24 -9q-9 -2 -14.5 -4t-8.5 -4q-6 -4 -18 -16q-14 -14 -29 -14zM462 -6q8 0 16.5 -3.5t16.5 -3.5q5 0 17 7q16 11 27 10l15 -1q6 -1 11.5 2.5t9.5 7.5q5 5 8.5 8t4.5 4q3 3 16 6 q15 3 19 7q5 5 12 16q5 10 10 15t12 7q8 4 13 9q4 4 7 18q3 15 6 18q2 2 5 5.5t8 7.5q11 8 11 23l-1 20q0 12 9 21q10 10 9 15q-2 8 -5 16t-3 16q0 7 3 14t5 14q2 5 -1 10t-8 12q-9 15 -9 23l1 17q0 13 -12 22q-12 11 -14 14t-2 16q0 6 -1 10t-3 7q-2 5 -17 13q-16 8 -19 11 q-5 5 -8 14q-4 9 -9 14q-3 3 -16 6q-8 1 -16 5q-2 2 -5.5 5t-8.5 9q-10 13 -21 12l-20 -2q-4 -1 -9 2t-11 7q-5 5 -10.5 8t-10.5 1q-8 -2 -16.5 -5.5t-16.5 -3.5t-16 3.5t-16 5.5q-7 1 -20 -8q-12 -9 -22 -9l-17 1q-10 0 -21 -12q-10 -12 -15 -15q-2 -1 -6.5 -2t-11.5 -3 q-13 -3 -18 -7q-4 -2 -10 -15q-4 -10 -9 -15q-3 -3 -14 -8q-10 -3 -15 -9q-1 -1 -1.5 -5t-2.5 -10q-2 -12 -4 -16q-2 -3 -14 -14q-12 -10 -12 -22l1 -16q0 -7 -8 -23q-4 -7 -7 -12.5t-2 -10.5q2 -7 5 -14.5t3 -15.5t-3 -16.5t-5 -16.5q-1 -6 9 -20q4 -6 6.5 -11t1.5 -10 l-2 -16q-1 -9 13 -22q6 -6 9.5 -10t4.5 -6q1 -1 2 -5t2 -9q1 -10 5 -17q2 -3 6 -6t8 -5q12 -5 14 -7q4 -4 10 -17q5 -12 11 -17q3 -1 7 -2.5t9 -1.5q9 0 15 -3t18 -15q13 -13 22 -13l15 1q11 0 22 -8q13 -10 18 -10q9 0 18 4.5t18 4.5zM462 417q47 0 85.5 -22.5t61.5 -61 t23 -86.5q0 -47 -23 -86t-61.5 -61.5t-85.5 -22.5q-49 0 -87.5 24t-61 63t-22.5 83q0 43 21.5 82t60.5 63.5t89 24.5zM505 117v175h52v68h-191v-68h54v-175h85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "i.loclTRK",
    horizAdvX: 275,
    d: "M161 459l19 -9q0 -13 -0.5 -40t-0.5 -59.5t-0.5 -65t-0.5 -56.5q0 -73 2.5 -112t5 -54l2.5 -15q1 -5 14.5 -10t30 -8t26.5 -4l-3 -29q-24 2 -56.5 2.5t-58.5 0.5q-25 0 -60 -0.5t-59 -2.5l3 29q11 1 27 4t29 8t14 10l2 15t4 54t2 112t-2 108.5t-4 47l-2 11.5l-64 19 l-2 26q18 0 42.5 2.5t48.5 7t41 8.5zM138 563q-22 0 -37 15.5t-15 38.5q0 22 15 37t37 15t37 -15t15 -37q0 -23 -15 -38.5t-37 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asuperior",
    horizAdvX: 286,
    d: "M273 406l9 -22q-13 -10 -27.5 -17t-28.5 -7q-16 0 -28.5 9.5t-17.5 28.5q-22 -16 -44.5 -27t-46.5 -11q-26 0 -47 14t-21 48q0 35 38.5 66.5t117.5 41.5v54q0 17 -12 25t-30 8q-24 0 -36 -12.5t-12 -30.5q0 -4 0.5 -7.5t2.5 -10.5l-19 -8q-15 8 -26.5 21.5t-11.5 18.5 q0 6 14.5 22.5t42 31t67.5 14.5q30 0 51.5 -14t21.5 -55q0 -8 0.5 -30.5t1.5 -50t1.5 -50t0.5 -30.5q0 -16 5.5 -21t12.5 -5q3 0 8.5 1t12.5 5zM177 422v74q-49 -1 -72 -20.5t-23 -40.5q0 -16 10 -23.5t26 -7.5q13 0 28.5 4.5t30.5 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "osuperior",
    horizAdvX: 331,
    d: "M308 519q0 -40 -15 -76.5t-48.5 -59.5t-88.5 -23q-71 0 -103 37.5t-32 98.5q0 40 15 76.5t48.5 60t88.5 23.5q71 0 103 -38t32 -99zM245 496q0 30 -6 59t-23 48.5t-50 19.5q-26 0 -42.5 -12.5t-25 -31t-11.5 -37.5t-3 -31q0 -28 7 -55t24.5 -44.5t47.5 -17.5 q32 0 49.5 18t25 42.5t7.5 41.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "periodcentered.loclCAT",
    horizAdvX: 165,
    d: "M82 319q-22 0 -37 15t-15 40q0 23 15 37.5t37 14.5t37.5 -14.5t15.5 -37.5q0 -25 -15.5 -40t-37.5 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "periodcentered.loclCAT.case",
    horizAdvX: 165,
    d: "M82 291q-22 0 -37 15t-15 40q0 23 15 37.5t37 14.5t37.5 -14.5t15.5 -37.5q0 -25 -15.5 -40t-37.5 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030C.alt",
    d: "M-134 754q0 23 16 35t38 12q26 0 50 -20.5t24 -65.5q0 -39 -25 -74.5t-69 -59.5l-15 21q26 22 42.5 49.5t16.5 55.5v10t-2 10q-4 -7 -14 -11.5t-19 -4.5q-20 0 -31.5 13.5t-11.5 29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0308.case",
    d: "M90 792q-22 0 -37 15.5t-15 38.5q0 22 15 37t37 15t37 -15t15 -37q0 -23 -15 -38.5t-37 -15.5zM-90 792q-22 0 -37 15.5t-15 38.5q0 22 15 37t37 15t37 -15t15 -37q0 -23 -15 -38.5t-37 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0307.case",
    d: "M0 793q-22 0 -37 15.5t-15 38.5q0 22 15 37t37 15t37 -15t15 -37q0 -23 -15 -38.5t-37 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gravecomb.case",
    d: "M15 747l-173 162q2 17 23 29.5t46 12.5l134 -199z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acutecomb.case",
    d: "M131 909l-173 -162l-30 5l134 199q25 0 46 -12.5t23 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030B.case",
    d: "M246 912l-173 -162l-30 5l134 199q25 0 46 -12.5t23 -29.5zM75 912l-173 -162l-30 5l134 199q25 0 46 -12.5t23 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0302.case",
    d: "M-18 946h37l94 -194l-30 -5l-83 104l-82 -104l-30 5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030C.case",
    d: "M18 752h-37l-104 195l30 5l92 -114l93 114l30 -5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0306.case",
    d: "M-129 891l37 5q5 -27 33 -40t59 -13q32 0 60 13t33 40l37 -5q-7 -54 -46 -81t-84 -27q-44 0 -82.5 27t-46.5 81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030A.case",
    d: "M-105 848q0 44 31 74.5t74 30.5q44 0 74 -30.5t30 -74.5q0 -43 -30 -73.5t-74 -30.5q-43 0 -74 30.5t-31 73.5zM-3 923q-20 0 -35 -14.5t-15 -55.5q0 -30 12 -54.5t40 -24.5q20 0 34.5 15t14.5 55q0 31 -11 55t-40 24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tildecomb.case",
    d: "M138 893l26 -8q-15 -50 -34 -72.5t-40.5 -27t-44.5 2.5t-47 17t-47.5 15.5t-46 -1t-42.5 -34.5l-26 8q15 50 34 72.5t40.5 27t44.5 -2.5t47 -17t47.5 -15.5t46 1t42.5 34.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0304.case",
    d: "M158 850l-39 -46q-34 2 -68.5 3t-69.5 1q-34 0 -68 -1t-69 -3l-8 16l39 46q38 -2 75 -3.5t74 -1.5q32 0 63.5 1t62.5 3z"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u1EF2",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u1E84",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u1E82",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u1E80",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u0178",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u0176",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u0174",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u0166",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u0164",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\xDD",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "Y",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "W",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "V",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "T",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u01FA",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0104",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0102",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0100",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xC5",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xC4",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xC3",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xC2",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xC1",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xC0",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "A",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "1",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "\xBA",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "\xAA",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "4",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "0",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "3",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u2026",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u201E",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u201A",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "4",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: ".",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: ",",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "J",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u01FA",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u01CD",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u0104",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u0102",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u0100",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\xC5",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\xC4",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\xC3",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\xC2",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\xC1",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\xC0",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "A",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "\u01FF",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "\u01FD",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "\u0153",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "\u0151",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "\u014F",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "\u014D",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "\u0123",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "\u0121",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "\u011F",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "\u011D",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "\u011B",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "\u0119",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "\u0117",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "\u0115",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "\u0113",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "\u0111",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "\u010F",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "\u010D",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "\u010B",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "\u0109",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "\u0107",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "\u0105",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "\u0103",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "\u0101",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "\xF8",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "\xF6",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "\xF5",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "\xF4",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "\xF3",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "\xF2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "\xEB",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "\xEA",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "\xE9",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "\xE8",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "\xE7",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "\xE5",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "\xE4",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "\xE3",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "\xE2",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "\xE1",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "\xE0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "q",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "o",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "g",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "e",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "c",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "a",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "x",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "p",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "d",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "-",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "x",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "/",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "-",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "x",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "/",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "-",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u1EF3",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u1E85",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u1E83",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u1E81",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u01FF",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u01FE",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0177",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0175",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0153",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0152",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0151",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0150",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u014F",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u014E",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u014D",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u014C",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0123",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0121",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0120",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u011F",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u011E",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u011D",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u011C",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u011B",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0119",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0117",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0115",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0113",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0111",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u010F",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u010D",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u010C",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u010B",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u010A",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0109",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0108",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0107",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0106",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xFF",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xFD",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF8",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF6",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF5",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF4",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF3",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xEB",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xEA",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xE9",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xE8",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xE7",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xD8",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xD6",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xD5",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xD4",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xD3",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xD2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xC7",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "y",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "w",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "v",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "q",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "o",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "g",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "e",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "c",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "Q",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "O",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "G",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "C",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "x",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "/",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "-",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xAE",
    k: -70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xA9",
    k: -70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "}",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "]",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "?",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "*",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: ")",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "!",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u01FF",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u0153",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u0151",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u014F",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u014D",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u0123",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u0121",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u011F",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u011D",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u011B",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u0119",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u0117",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u0115",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u0113",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u0111",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u010F",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u010D",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u010B",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u0109",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u0107",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xF8",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xF6",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xF5",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xF4",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xF3",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xF2",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xEB",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xEA",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xE9",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xE8",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xE7",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "q",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "o",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "g",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "e",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "c",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "J",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "J",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "J",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "J",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "J",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "J",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "x",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "/",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "-",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "J",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "J",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "J",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "x",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "p",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "d",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "-",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "x",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "p",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "d",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "-",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: "x",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: "/",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: "-",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "x",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "/",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "-",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "x",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "/",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "-",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FA",
    u2: "J",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: "x",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: "/",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: "-",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: "x",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: "/",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: "-",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E84",
    u2: "x",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E84",
    u2: "/",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E84",
    u2: "-",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "x",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "/",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "-",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ff",
    u2: "\xAE",
    k: -70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ff",
    u2: "\xA9",
    k: -70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ff",
    u2: "}",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ff",
    u2: "]",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ff",
    u2: "?",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ff",
    u2: "*",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ff",
    u2: ")",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ff",
    u2: "!",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut,Oslashacute",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,uni01CD,Aringacute",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn,omacron,obreve,ohungarumlaut,oslashacute",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,uni01CD,Aringacute",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,Ohungarumlaut,OE,Oslashacute",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,uni01CD,Aringacute",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,uni01CD,Aringacute",
    g2: "V,W,Y,Yacute,Wcircumflex,Ycircumflex,Ydieresis,Wgrave,Wacute,Wdieresis,Ygrave",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,uni01CD,Aringacute",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,uni01CD,Aringacute",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,uni01CD,Aringacute",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W,Y,Yacute,Wcircumflex,Ycircumflex,Ydieresis,Wgrave,Wacute,Wdieresis,Ygrave",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,oslashacute",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W,Y,Yacute,Wcircumflex,Ycircumflex,Ydieresis,Wgrave,Wacute,Wdieresis,Ygrave",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni01CE,aringacute,aeacute",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W,Y,Yacute,Wcircumflex,Ycircumflex,Ydieresis,Wgrave,Wacute,Wdieresis,Ygrave",
    g2: "m,n,r,ntilde,nacute,uni0146,ncaron,napostrophe,eng,racute,uni0157,rcaron",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W,Y,Yacute,Wcircumflex,Ycircumflex,Ydieresis,Wgrave,Wacute,Wdieresis,Ygrave",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,uni01CD,Aringacute",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W,Y,Yacute,Wcircumflex,Ycircumflex,Ydieresis,Wgrave,Wacute,Wdieresis,Ygrave",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W,Y,Yacute,Wcircumflex,Ycircumflex,Ydieresis,Wgrave,Wacute,Wdieresis,Ygrave",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W,Y,Yacute,Wcircumflex,Ycircumflex,Ydieresis,Wgrave,Wacute,Wdieresis,Ygrave",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W,Y,Yacute,Wcircumflex,Ycircumflex,Ydieresis,Wgrave,Wacute,Wdieresis,Ygrave",
    g2: "s,sacute,scedilla,uni0219",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,uni01CD,Aringacute",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,oslashacute",
    k: 105
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni01CE,aringacute,aeacute",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,uni01CD,Aringacute",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "AE,AEacute",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "N,Ntilde,Nacute,uni0145,Ncaron,Eng",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,oslashacute",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "N,Ntilde,Nacute,uni0145,Ncaron,Eng",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni01CE,aringacute,aeacute",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "N,Ntilde,Nacute,uni0145,Ncaron,Eng",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "V,W,Y,Yacute,Wcircumflex,Ycircumflex,Ydieresis,Wgrave,Wacute,Wdieresis,Ygrave",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "V,W,Y,Yacute,Wcircumflex,Ycircumflex,Ydieresis,Wgrave,Wacute,Wdieresis,Ygrave",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,oslashacute",
    k: 105
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni01CE,aringacute,aeacute",
    k: 105
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "m,n,r,ntilde,nacute,uni0146,ncaron,napostrophe,eng,racute,uni0157,rcaron",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,uni01CD,Aringacute",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "fi,fl,ffi,ffl,fb,fh,fj,fk",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "s,sacute,scedilla,uni0219",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "f,ff",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,oslashacute",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,oslashacute",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,Ohungarumlaut,OE,Oslashacute",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni01CE,aringacute,aeacute",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "V,W,Y,Yacute,Wcircumflex,Ycircumflex,Ydieresis,Wgrave,Wacute,Wdieresis,Ygrave",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,uni01CD,Aringacute",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,ff",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,oslashacute",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,ff",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: -70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,uni0136",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,oslashacute",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,uni0136",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,oslashacute",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni01CE,aringacute,aeacute",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,uni01CD,Aringacute",
    k: 95
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 133
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,oslashacute",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni01CE,aringacute,aeacute",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,uni01CD,Aringacute",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 132
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAverageRegular);
export default __webpack_public_path__ + "static/media/Average-Regular.e5daf5ecc7e75689844861d7bddd71d6.svg";
export { ForwardRef as ReactComponent };